export const is = {
    addDatabase: {
        addDatabase: "BÃ¦ta viÃ° gagnagrunni",
        addFromFile: "BÃ¦ta viÃ° Ãºr skrÃ¡",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Allir pakkar",
        onePackage: "Einn pakki",
        priceType: "VerÃ°tegund",
        setPriceVatVisibility: "SÃ½nileiki fyrir VSK",
        setVisibilityAndOrder: "Stilla sÃ½nileika og rÃ¶Ã° verÃ°tegunda",
        withAndWithoutVat: "BÃ¦Ã°i meÃ° og Ã¡n VSK",
        withVat: "AÃ°eins meÃ° VSK",
        withoutVat: "AÃ°eins Ã¡n VSK"
    },
    barvis: {
        base: "Heiti grunns",
        bigCanSize: "StÃ³r dÃ³s/fata",
        coating: "GrunnmÃ¡lning",
        identifier: "AuÃ°kenning",
        laboratory: "RannsÃ³knarstofa",
        orderOverview: "Yfirlit yfir pÃ¶ntun",
        rank: "RÃ¶Ã°un",
        smallCanSize: "LÃ­til dÃ³s/fata"
    },
    basicSetup: {
        alreadyLoggedIn: "ÃÃº ert Ã¾egar skrÃ¡Ã°(ur) inn sem %{login}.",
        askSupplier: "Biddu sÃ¶luaÃ°ila hugbÃºnaÃ°arins um aÃ° Ãºthluta Ã¾Ã©r vÃ­Ã°tÃ¦kara leyfi.",
        asterisk: "StjÃ¶rnumerktir reitir eru Ã¡skildir.",
        identificationKeys: "AuÃ°kennislyklar",
        importCustomData: "Ef Ã¾Ã¶rf krefur skaltu flytja inn sÃ©rsniÃ°in gÃ¶gn Ãºr eldri litblÃ¶ndunarhugbÃºnaÃ°i.",
        learnIdentification: "LÃ¦rÃ°u auÃ°kennislykilinn sem Ã¾Ãº fÃ©kkst hjÃ¡ sÃ¶luaÃ°ila hugbÃºnaÃ°arins.",
        login: "Eftirfarandi skref Ã­ upphaflegu uppsetningunni krefjast stjÃ³rnunarheimilda",
        noDatabase: "Engum gagnagrunnum hefur veriÃ° bÃ¦tt viÃ° enn. Setja Ã¾arf inn aÃ° minnsta kosti einn.",
        offlineLicensing: "Leyfi til notkunar utan nets",
        productSelection: "Val Ã¡ vÃ¶ru",
        registrationForm: "SkrÃ¡ningareyÃ°ublaÃ°",
        seeQuestionMark: "SkoÃ°aÃ°u litlu spurningamerkin til aÃ° fÃ¡ frekari upplÃ½singar um stillinguna.",
        selectDefaultPrinter: "Veldu sjÃ¡lfgefinn prentara og viÃ°bÃ³tarstillingar.",
        selectDefaultTemplate:
            "Veldu sjÃ¡lfgefiÃ° sniÃ°mÃ¡t Ãºr Ã¾eim sem fyrir eru, bÃºÃ°u til nÃ½tt eÃ°a settu inn Ã¾itt eigiÃ°.",
        selectDispenser: "Veldu Ã¾Ã¡ gerÃ° blÃ¶ndunarvÃ©lar fyrir liti sem Ã¾Ãº notar.",
        selectLanguage: "Veldu tungumÃ¡l.",
        selectProducts: "Veldu eina af Ã¾eim tiltÃ¦ku vÃ¶rum sem Ã¾Ãº vilt virkja.",
        selectSpectroType: "Veldu gerÃ° litrÃ³fsmÃ¦lis sem Ã¾Ãº notar.",
        setAdditionalPrinterOptions: "Tilgreindu viÃ°bÃ³tarstillingar prentara.",
        setAutomaticUpdates: "Tilgreindu stillingar fyrir sjÃ¡lfvirkar uppfÃ¦rslur.",
        setCustomItems: "Tilgreindu sÃ©rsniÃ°nar vÃ¶rur og sÃ½nileika gagna. Fletta niÃ°ur til aÃ° skoÃ°a fleiri mÃ¶guleika",
        setEnvironment: "Tilgreindu heildarumhverfi hugbÃºnaÃ°arins. Flettu niÃ°ur til aÃ° skoÃ°a fleiri mÃ¶guleika.",
        setFormulaRepresentation: "SlÃ¡Ã°u inn framsetningu uppskrifta. Flettu niÃ°ur til aÃ° skoÃ°a fleiri mÃ¶guleika.",
        summary:
            "ÃÃº getur hvenÃ¦r sem er breytt Ã¾essum stillingum og fundiÃ° fleiri stillingarvalkosti. NjÃ³ttu Ã¾ess aÃ° nota %{name}!",
        summarySuccess: "BÃºiÃ° er aÃ° setja Ã¾ig upp Ã­ kerfinu!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Tilgreindu hÃ¦Ã° Ã­ hylki",
        criticalLevelCanister: "Of lÃ­tiÃ° magn Ã­ hylki",
        fillToMax: "Fylla aÃ° hÃ¡marki",
        maxDispenseLevel: "HÃ¡marksskammtur",
        otherCanisters: "AÃ°rar hÃ¦Ã°artÃ¶lur Ã­ hylki",
        warningLevelCanister: "ViÃ°vÃ¶run vegna hÃ¦Ã°ar Ã­ hylki"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "FÃ¡anlegar ÃºtgÃ¡fur",
        canisterInformation: "UpplÃ½singar um hylki",
        canisterPreview: "ForskoÃ°un Ã¡ hylkjum",
        currentLevel: "NÃºverandi hÃ¦Ã°",
        errors: "Villa",
        fillState: "StaÃ°a Ã¡fyllingar",
        fillToMax: "Fylla aÃ° hÃ¡marki",
        fillingAmount: "Magn Ã¡fyllingar",
        finalLevel: "Lokastig",
        minimumAmount: "LÃ¡gmarksmagn",
        minimumLevel: "LÃ¡gmarkshÃ¦Ã°",
        moveTableToRefill: "FÃ¦rÃ°u borÃ°iÃ° til aÃ° fylla Ã¡ aftur",
        refillNoAmount: "Ekkert magn skrÃ¡Ã°",
        refillOverLimit: "MagniÃ° sem fÃ¦rt er inn er yfir hÃ¡marksrÃºmtaki hylkis.",
        refillSummary: "%{amount} %{unit} af litarefninu %{colorant} verÃ°ur bÃ¦tt Ã­ litahÃ³lfiÃ° %{canisterId}.",
        systemWarningAmount: "Magn sem orsakar kerfisviÃ°vÃ¶run",
        warningAmount: "Magn sem orsakar viÃ°vÃ¶run"
    },
    changeDatabase: {
        changeDatabase: "Breyta gagnagrunni ",
        databaseWarning: "Ekki er hÃ¦gt aÃ° nota gagnagrunninn %{databaseName} vegna"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "Hreinsa allar rÃ¡sir",
        cleanChannels: "Hreinsa rÃ¡sir",
        cleaningTime: "HreinsunartÃ­mi",
        selectChannels: "Velja rÃ¡sir",
        startCleaning: "Byrja hreinsun "
    },
    clientServerSettings: {
        activeServer: "Virkja netÃ¾jÃ³n",
        addNewServer: "BÃ¦ta viÃ° nÃ½jum netÃ¾jÃ³ni",
        availableServers: "AÃ°rir tiltÃ¦kir netÃ¾jÃ³nar",
        clientIdentifier: "AuÃ°kenni biÃ°lara",
        clientServerSettings: "Stillingar biÃ°lara/netÃ¾jÃ³ns",
        disabledStatus: "Gert Ã³virkt",
        editServer: "Breyta netÃ¾jÃ³ni",
        fillRequiredFields: "Fylla verÃ°ur Ãºt alla Ã¡skilda reiti",
        noOtherServers: "Engir aÃ°rir netÃ¾jÃ³nar eru tiltÃ¦kir",
        offlineStatus: "Utan nets",
        onlineStatus: "Ã netinu",
        port: "GÃ¡tt",
        serverName: "Heiti netÃ¾jÃ³ns",
        serverNameMissing: "Heiti netÃ¾jÃ³ns er Ã¡skiliÃ°",
        stabileConnection: "NotaÃ°u fasta IP-tÃ¶lu til aÃ° tryggja stÃ¶Ã°uga tengingu.",
        wrongFormatIp: "Rangt sniÃ° IP-tÃ¶lu"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "LitatÃ³nn",
        fandeckPosition: "StaÃ°setning litakorts",
        moreInfoIcons: "MyndtÃ¡kn fyrir frekari upplÃ½singar",
        notExistingFormula: "Uppskrift er ekki til",
        orderBy: "PÃ¶ntun Ã¡",
        selectYourGrid: "Velja hnitanet",
        showInPanel: "SÃ½na Ã¡ svÃ¦Ã°inu",
        warningIcon: "ViÃ°vÃ¶runartÃ¡kn fyrir âUppskrift er ekki tilâ"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "FjÃ¶ldi litarefna:",
        preview: "ForskoÃ°un",
        prices: "VerÃ°"
    },
    currencySettings: {
        addNewCurrency: "BÃ¦ta viÃ° nÃ½jum gjaldmiÃ°li ",
        codePlaceholder: "KÃ³Ã°i",
        currencySettings: "GjaldmiÃ°ilsstillingar",
        namePlaceholder: "Heiti",
        ratePlaceholder: "Gengi gjaldmiÃ°ils",
        setDecimalPlaces: "Stilla fjÃ¶lda tugastafa",
        setMainCurrency: "Stilla aÃ°algjaldmiÃ°il",
        setRounding: "NÃ¡mundun",
        symbolPlaceholder: "TÃ¡kn"
    },
    customFandecks: {
        customFandecks: "SÃ©rsniÃ°iÃ° litakort",
        deleteButtonWarning: "Allar formÃºlur Ã­ litakortinu verÃ°a einnig fjarlÃ¦gÃ°ar.",
        deleteCustomFandeck:
            "Ã Ã¶rugglega aÃ° eyÃ°a Ã¾essu sÃ©rsniÃ°na litakorti? Ãllum formÃºlum Ã­ litakortinu verÃ°ur einnig eytt.",
        disableStandardFandecks: "Show only custom fandecks",
        enableStandardFandecks: "Show standard fandecks",
        fandeckName: "Heiti litakorts "
    },
    customRedlike: {
        addColorantFromBrand: "BÃ¦ta viÃ° litarefni Ãºr vÃ¶ruheitinu %{brandName}",
        addNewCustomer: "BÃ¦ta viÃ° nÃ½jum viÃ°skiptavini",
        addNewNote: "BÃ¦ta viÃ° nÃ½rri athugasemd",
        addedDate: "ViÃ°bÃ³targÃ¶gn",
        addedQuantity: "ViÃ°bÃ³tarmagn",
        availableMachine: "VÃ©lin er tiltÃ¦k",
        brand: "Merki",
        brandPlease: "Velja merki",
        cancelCustomer: "Ãgilda viÃ°skiptavin",
        colorPlease: "Veldu lit",
        confirmCustomerData: "StaÃ°festa gÃ¶gn viÃ°skiptavinar",
        confirmNoteData: "StaÃ°festa upplÃ½singar um athugasemd",
        confirmSelectedUser: "Ã aÃ° nota Ã¾ennan viÃ°skiptavin %{customerName} fyrir Ã¾essa pÃ¶ntun?",
        confirmed: "StaÃ°fest",
        controlData: "StjÃ³rnun endanlegra gagna",
        customerCellNumber: "SÃ­manÃºmer viÃ°skiptavinar",
        customerFilter: "SÃ­a fyrir viÃ°skiptavin",
        customerName: "Nafn viÃ°skiptavinar",
        customerPhone: "SÃ­mi viÃ°skiptavinar",
        customerPlease: "Veldu viÃ°skiptavin",
        dateFilter: "DagsetningarsÃ­a",
        enterPin: "FÃ¦ra inn aÃ°gangskÃ³Ã°a",
        enterTheNumberOfPackages: "FÃ¦ra inn fjÃ¶lda pakka",
        existingCustomer: "Notandi er Ã¾egar til",
        fandeckPlease: "Veldu litakort",
        fillCanisterHistory: "Fylla Ãºt ferilupplÃ½singar fyrir hylki",
        findCustomer:
            "Til aÃ° Ãºthluta vildarkorti Ã¡ Ã¾essa pÃ¶ntun Ã¾arft Ã¾Ãº aÃ° skanna inn strikamerki eÃ°a leita eftir tÃ¶lvupÃ³sti",
        findCustomerByEmail: "SÃ­a viÃ°skiptavini eftir tÃ¶lvupÃ³sti eÃ°a strikamerki",
        finishPreviousStep: "(LjÃºktu viÃ° fyrri skref)",
        formulaUnit: "Uppskriftareining",
        getBackToList: "Fara aftur Ã­ lista yfir viÃ°skiptavini",
        historyOfOrders: "Ferill pÃ¶ntunar",
        insertNote: "Fara Ã­ âSetja inn athugasemdâ",
        loadHistoryOrder: "Ã aÃ° sÃ¦kja valdar pantanir?",
        loyaltyCards: "Vildarkort",
        machineIsAvailable: "VÃLIN ER TILTÃK",
        machineIsUnavailable: "VÃLIN ER EKKI TILTÃK",
        newLoyaltyCard: "NÃ½tt vildarkort",
        noAvailableMachine: "VÃ©lin er ekki tiltÃ¦k",
        noCustomerSelected: "Engir viÃ°skiptavinir voru valdir. Ã aÃ° halda Ã¡fram?",
        notePlease: "Setja inn athugasemd",
        openHistory: "Opna feril",
        orAdd: "eÃ°a bÃ¦ta viÃ° viÃ°skiptavini",
        orSelect: "eÃ°a velja viÃ°skiptavin",
        orderModification: "Upprunalegu pÃ¶ntuninni verÃ°ur breytt. Viltu halda Ã¡fram?",
        orderOverview: "Yfirlit yfir pÃ¶ntun",
        orderToMachine: "SENDA MÃNA PÃNTUN TIL VÃLAR",
        ordersHistory: "Ferill pÃ¶ntunar",
        packagePlease: "Veldu pakka",
        pleaseSelectBrand: "Veldu merki",
        previewImage: "IMG-forskoÃ°un",
        previewPackage: "ForskoÃ°un Ã¡ pakka",
        productPlease: "Veldu vÃ¶ru",
        resetFilters: "NÃºllstilla allar sÃ­ur",
        searchForHistoricalOrders: "EÃ°a leita eftir pÃ¶ntunum Ã­ ferli",
        selectBrand: "Veldu merki",
        selectColor: "Fara Ã­ val Ã¡ litum",
        selectCustomer: "Fara Ã­ val Ã¡ viÃ°skiptavini",
        selectExistingCustomer: "Velja skrÃ¡Ã°an viÃ°skiptavin",
        selectFandeck: "Fara Ã­ val Ã¡ litakorti",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "Fara Ã­ val Ã¡ pakka",
        selectProduct: "Fara Ã­ val Ã¡ vÃ¶ru",
        shotsCoefficient: "SkotstuÃ°ull",
        showDetail: "SÃ½na upplÃ½singar",
        showHideEshopName: "SÃ½na/fela vefverslunarheiti litarins Ã­ aÃ°skildum dÃ¡lki",
        showKeyboard: "SÃ½na lyklaborÃ°",
        skipCustomerButton: "Hlaupa yfir valda viÃ°skiptavini",
        skipCustomerText: "Hlaupa yfir ef ekki Ã¡ aÃ° fÃ¦ra inn viÃ°skiptavin",
        skipNote: "Hlaupa yfir athugasemd og skoÃ°a samantekt",
        spectroBrand: "Leitar Ã­ vÃ¶ruheitinu %{brandName}",
        statusAccepted: "samÃ¾ykkt",
        statusCanceled: "Ã³gilt",
        statusCreated: "bÃºiÃ° til",
        statusDone: "framkvÃ¦mt",
        statusPartlyDone: "framkvÃ¦mt aÃ° hluta",
        statusPreparing: "undirbÃ½r",
        summaryChosenBase: "grunnur",
        summaryChosenBrand: "merki",
        summaryChosenCanSize: "StÃ¦rÃ° Ã¡ dÃ³s/fÃ¶tu",
        summaryChosenColor: "litur",
        summaryChosenColorCard: "litakort",
        summaryChosenProduct: "vara",
        summaryChosenQuantity: "magn",
        summaryColorPreview: "ForskoÃ°un Ã¡ lit",
        summaryCustomNote: "Athugasemd skilgreind af notanda",
        summaryCustomerNumber: "nÃºmer viÃ°skiptavinar",
        summaryFormula: "Uppskrift",
        summaryFormulaNote: "Athugasemd Ã­ uppskrift",
        summaryNote: "athugasemd",
        sureAboutSend: "Ã Ã¶rugglega aÃ° senda pÃ¶ntun?",
        useCustomerInOrder: "Ã aÃ° nota Ã¾ennan viÃ°skiptavin %{customerName} fyrir Ã¾essa pÃ¶ntun?",
        uuid: "UUID (altÃ¦kt einkvÃ¦mt auÃ°kenni)",
        viewSummary: "SjÃ¡ samantekt",
        volume: "RÃºmtak"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "Festa staÃ°festingu Ã¡ pÃ¶ntun",
        pinScreenSaverConfirmation: "Festa staÃ°festingu Ã¡ skjÃ¡hvÃ­lu",
        pinSettingsConfirmation: "StaÃ°festing Ã¡ stillingu PIN-nÃºmers",
        printAuto: "Leyfa sjÃ¡lfvirka prentun",
        printerSettings: "Stillingar prentara",
        selectColorWithFandeck: "Algengir litir og litakort",
        setKeyboard: "Stilla lyklaborÃ°",
        setKioskMode: "Stilla allan skjÃ¡inn",
        setLanguage: "Stilla tungumÃ¡l",
        setModule: "Stilla einingu",
        setQuickSelect: "Stilla flÃ½tival",
        setScreensaverTimeout: "Stilla tÃ­ma skjÃ¡hvÃ­lu",
        setUnit: "Stilla einingu "
    },
    customRedlikeMachine: {
        action: "AÃ°gerÃ°",
        additionalPrint: "Fleiri Ãºtprent",
        brand: "Merki",
        brandAccess: "Notandinn â%{userName}â getur ekki sÃ³tt gÃ¶gn Ãºr â%{brandName}â",
        can: "DÃ³s/fata staÃ°sett",
        canistersLevel: "Yfirlit yfir hÃ¦Ã° Ã­ hylki",
        closeDetailInformation: "Loka upplÃ½singum",
        colorantsAmount: "Magn litarefnis",
        confirmRefill: "StaÃ°festa endurÃ¡fyllingu litarefnis",
        deleteOrder: "EyÃ°a pÃ¶ntun",
        dialogNoMachine: "VÃ©lin er ekki tengd",
        dialogNoRcc: "Engin RCC (Redlike Control Center) er tengd",
        dispense: "LitatÃ³nn",
        dispenserInErrorState: "Villa hefur komiÃ° upp Ã­ litblÃ¶ndunarvÃ©l",
        dispensingIsOk: "LitblÃ¶ndunarvÃ©lin er Ã­ lagi",
        emergencyButtonPressed: "Ãtt Ã¡ neyÃ°arstÃ¶Ã°vunarhnapp",
        errorCode: "VillukÃ³Ã°i",
        errorEvents: "Villa Ã­ litblÃ¶ndunarvÃ©l",
        errorReset: "Villa Ã­ endurrÃ¦singu",
        explanation: "SkÃ½ring",
        imageNotAvailable: "Myndin er ekki tiltÃ¦k",
        incorrectCanister: "SkannaÃ°a hylkiÃ° er ekki rÃ©tt!",
        incorrectColorant: "Villa: SkannaÃ°a litarefniÃ° er ekki rÃ©tt. Veldu rÃ©tt litarefni.",
        lastEvents: "SÃ­Ã°asta tilvik",
        machineActions: "Skynjari litblÃ¶ndunarvÃ©lar",
        machineConfiguration: "Grunnstilling litblÃ¶ndunarvÃ©lar",
        machineError: "Villa Ã­ vÃ©l",
        machineIsBusy: "VÃ©lin er upptekin",
        machineNotAvailable: "VÃ©lin er ekki tiltÃ¦k",
        machineTinting: "BÃ­ddu aÃ°eins, vÃ©lin er aÃ° blanda lit ...",
        manualScan: "Handvirk skÃ¶nnun",
        notEnoughSpace: "VILLA: ÃaÃ° er ekki nÃ¦gilegt plÃ¡ss fyrir Ã¾ennan litarefnispakka",
        numberOfCanistersUnderCriticalLevel: "FjÃ¶ldi hylkja meÃ° of litlu magni er %{0}",
        numberOfCanistersUnderWarningLevel: "FjÃ¶ldi hylkja undir viÃ°vÃ¶runarmarki %{0}",
        offlinePressed: "LyklaborÃ° utan nets er virkt",
        orderSettings: "PÃ¶ntunarstillingar",
        otherOrderInformation: "UpplÃ½singar um pÃ¶ntun",
        packageCount: "Pakkatalning",
        packageWithSeparator: "Pakki",
        received: "MÃ³ttekiÃ°",
        receivedOrders: "MÃ³tteknar pantanir",
        receivedTime: "MÃ³ttekin tÃ­masetning",
        recirculation: "HringrÃ¡sarflutningur",
        refillInformation: "Litarefni: %{0}, Ã¡fylling: %{1}, hylki: %{2}",
        resetErrors: "Villa Ã­ nÃºllstillingu",
        scanCanister: "Skanna Ã¾etta hylki",
        scanColorantPackage: "SkannaÃ°u viÃ°eigandi litarefnispakka",
        selectedOrder: "Valdar pantanir",
        shelfMovingDown: "Hillan fÃ¦rist niÃ°ur",
        shelfMovingUp: "Hillan fÃ¦rist upp",
        solution: "ÃrrÃ¦Ã°i",
        startDispensing: "Byrja aÃ° blanda",
        stirring: "HrÃ¦ra",
        touchToStartFilling: "Ãttu hÃ©r til aÃ° hefja Ã¡fyllingu litarefnis",
        unknownBrand: "ÃÃ¾ekkt merki"
    },
    customRedlikeSettings: {
        addPos: "UpplÃ½singar um sÃ¶lustaÃ° (POS)",
        addServer: "BÃ¦ta viÃ° netÃ¾jÃ³ni",
        adminOperations: "AÃ°gerÃ°ir stjÃ³rnanda",
        adminSettings: "Stillingar stjÃ³rnanda",
        another: "Annar",
        aslOrService: "TÃ¡knmÃ¡l eÃ°a Ã¾jÃ³nusta",
        availableMachines: "TiltÃ¦kar vÃ©lar",
        barcode: "Strikamerki",
        basicOperations: "GrunnaÃ°gerÃ°ir",
        canisterBarcodes: "Strikamerki hylkis",
        canisterLevels: "HÃ¦Ã°Ã­hylkjum",
        closeConnection: "Loka tengingunni",
        closeRedlike: "Loka %{name}",
        databaseList: "Gagnagrunnur",
        disabledStatus: "Gert Ã³virkt",
        dispenseLogicType: "BirgÃ°astjÃ³rnunargerÃ° skÃ¶mmtunar",
        dropServers: "HÃ¦tta viÃ° aÃ° velja netÃ¾jÃ³n",
        editServer: "Breyta netÃ¾jÃ³ni",
        lastEvent: "SÃ­Ã°asta tilvik",
        logOut: "SkrÃ¡ Ãºt",
        machineConfiguration: "Grunnstillingar",
        maxDispenseAmount: "HÃ¡markar skÃ¶mmtunarmagn",
        offlineStatus: "Utan nets",
        onlineStatus: "Ã netinu",
        openFrondesk: "Opin viÃ°taka",
        print: "Prentstillingar",
        rebootPC: "EndurrÃ¦sa tÃ¶lvu",
        restartRedlike: "EndurrÃ¦sa %{name}",
        restoreConnection: "Tengjast aftur",
        scanCanisterBarcode: "Skanna strikamerki hylkisins",
        scanOrDeleteCanisterBarcode: "Skanna eÃ°a eyÃ°a strikamerki",
        setCanisterBarcode: "Stilla strikamerki hylkisins",
        swVersion: "HugbÃºnaÃ°arÃºtgÃ¡fa",
        systemFunctions: "Virkni kerfis",
        userSettings: "Stillingar notenda "
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Breyta lit",
        editColorant: "Breyta litarefni",
        emptyColorant: "Eitt litarefnanna er tÃ³mt",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "FormÃºla fyrir aÃ°alframleiÃ°sluvÃ¶ru",
        formulaForMasterProductWithParam: "FormÃºla fyrir aÃ°alframleiÃ°sluvÃ¶ru %{productName}",
        isNotAvailable: "er ekki tiltÃ¦kur",
        noBaseSelected: "Grunnur er Ã¡skilinn",
        noColorantsSelected: "Ekkert litarefni hefur veriÃ° valiÃ°",
        noFandeckSelected: "Litakort er Ã¡skiliÃ°",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Vara er Ã¡skilin",
        productPreview: "ForskoÃ°un vÃ¶ru",
        saveCustomRecipe: "Vista sÃ©rblÃ¶ndun",
        saveIsNotAvailable: "âVistaâ er ekki Ã­ boÃ°i",
        showSiblingProducts: "SÃ½na tengdar vÃ¶rur",
        siblingProducts: "Tengdar vÃ¶rur eftir aÃ°alframleiÃ°sluvÃ¶ru"
    },
    customersTab: {
        addCustomer: "BÃ¦ta viÃ° viÃ°skiptavini",
        additionalSettings: "Ãtarlegri stillingar",
        adress: "Heimilisfang",
        createAndSelect: "BÃ¦ta viÃ° og velja",
        createNewCustomer: "BÃºa til nÃ½jan viÃ°skiptavin",
        editCustomer: "Breyta viÃ°skiptavini",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "ReikningsnÃºmer",
        information: "SamskiptaupplÃ½singar",
        listOfCustomers: "ViÃ°skiptavinalisti",
        rabat: "AfslÃ¡ttur",
        selectCustomer: "Velja viÃ°skiptavin",
        spentLastMonth: "NotaÃ° sÃ­Ã°asta mÃ¡nuÃ°inn",
        spentMoney: "NotaÃ°ir fjÃ¡rmunir",
        typeOfMargin: "HagnaÃ°argerÃ°ir",
        zipCode: "PÃ³stnÃºmer"
    },
    dialog: {
        cheaperColorSearch: "Leit aÃ° Ã³dÃ½rari lit stendur yfir",
        competitiveColorSearch: "Litaleit meÃ° hermingu er Ã­ gangi",
        reallyChangeModule: "Ã Ã¶rugglega aÃ° breyta einingunni?",
        reallyCloseRedlike:
            "Ã Ã¶rugglega aÃ° loka %{name}? Ãllum %{name} svÃ¦Ã°um verÃ°ur lokaÃ° og Ã³vistuÃ°um breytingum verÃ°ur eytt.",
        reallyDeleteOrder: "Ã Ã¶rugglega aÃ° eyÃ°a Ã¾essari pÃ¶ntun? Ãllum upplÃ½singum um Ã¾essa pÃ¶ntun verÃ°ur eytt.",
        reallyRebootPC:
            "Ã Ã¶rugglega aÃ° endurrÃ¦sa Ã¾essa tÃ¶lvu? Ãllum svÃ¦Ã°um verÃ°ur lokaÃ° og Ã³vistuÃ°um breytingum verÃ°ur eytt.",
        reallyRestartRedlike:
            "Ã Ã¶rugglega aÃ° endurrÃ¦sa %{name}? Ãllum svÃ¦Ã°um verÃ°ur lokaÃ° og Ã³vistuÃ°um breytingum verÃ°ur eytt.",
        reallyShutdownPc:
            "Ã Ã¶rugglega aÃ° slÃ¶kkva Ã¡ Ã¾essari tÃ¶lvu? Ãllum %{name} svÃ¦Ã°um verÃ°ur lokaÃ° og Ã³vistuÃ°um breytingum verÃ°ur eytt. ",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Skammta aÃ°eins hÃ¡marksmagn sem hÃ¦gt er aÃ° lita",
        2: "Leyfa handvirka skÃ¶mmtun Ã¾vÃ­ aÃ° nota kvarÃ°a fyrir magn yfir hÃ¡markstÃ³nmagni",
        3: "EndurÃ¡fylling Ã¡ meÃ°an litblÃ¶ndun er Ã­ gangi (hlutamagn Ã­ minni skÃ¶mmtum)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Heiti litakorts"
    },
    editFormulaRgbModal: {
        apply: "Bera Ã¡",
        blue: "BlÃ¡r",
        green: "GrÃ¦nn",
        modalLabel: "Breyta lit",
        red: "RauÃ°ur",
        tryGenerateRgb: "Reyna aÃ° bÃºa til RGB eftir magni litarefnis"
    },
    environmentsSettings: {
        allowAutoCloseTab: "Loka formÃºluflipanum sjÃ¡lfkrafa",
        allowBarcodes: "Leyfa strikamerki",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "Leyfa viÃ°skiptavini",
        allowDeleteConfirmation: "Leyfa staÃ°festingu Ã¡ eyÃ°ingu",
        allowDiskSpaceNotification: "Leyfa tilkynningu um geymsluplÃ¡ss Ã¡ diski",
        allowDispensing: "Leyfa litblÃ¶ndun",
        allowFileTransfer: "Leyfa sjÃ¡lfvirkan skrÃ¡aflutning",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "Leyfa stjÃ³rnborÃ° fyrir formÃºlu",
        allowInternalNotes: "Leyfa athugasemdir Ãºr innra kerfi",
        allowLight: "Leyfa %{name}",
        allowOrderNotificationModal: "SÃ½na tilkynningu um nÃ½jar pantanir",
        allowOrdering: "Leyfa pÃ¶ntun",
        allowPricing: "Leyfa verÃ°lagningu",
        allowPrint: "Leyfa prentun",
        allowProductPreviewImage: "SÃ½na dÃ¦mi um vÃ¶rumynd",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "Leyfa leit aÃ° Ã³dÃ½rari litum",
        allowSound: "Leyfa tilkynningu um pantanir meÃ° hljÃ³Ã°i",
        allowSpectro: "Leyfa litrÃ³fsmÃ¦li",
        allowTabs: "Leyfa flipa",
        applyZoom: "Leyfa aÃ°drÃ¡tt",
        automaticLogout: "SjÃ¡lfvirk ÃºtskrÃ¡ning",
        barcodeScan: "Strikamerkjaskanni",
        canisterBarcode: "Strikamerki hylkis",
        canisterLevel: "HÃ¦Ã° Ã­ hylki",
        changelog: "BreytingaskrÃ¡",
        closeTab: "Loka flipa",
        colorDifference: "Color difference",
        colorPanelNavItem: "LitasvÃ¦Ã°i",
        competitiveColorSearch: "Litaleit meÃ° hermingu",
        customBanner: "SÃ©rsniÃ°inn borÃ°i",
        customCurrencyFormat: "GjaldmiÃ°ilssniÃ°",
        customDateFormat: "DagsetningarsniÃ°",
        customNumberFormat: "TalnasniÃ°",
        customTimeFormat: "TÃ­masniÃ°",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "SÃ½na afslÃ¡tt",
        dispensingHistory: "Ferill litblÃ¶ndunar",
        dispensingNotes: "Leyfa athugasemdir um litblÃ¶ndun",
        enableCustomers: "Gera viÃ°skiptavini virka",
        enableDeleteConfirmation: "Virkja staÃ°festingu Ã¡ eyÃ°ingu",
        enableDispensing: "Virkja litblÃ¶ndun",
        enableLight: "Virkja %{name}",
        enableMarginMarkup: "Virkja hagnaÃ° (Ã­ hlutfalli viÃ° sÃ¶lutekjur) eÃ°a Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)",
        enableNotes: "Virkja athugasemdir",
        enableOrdering: "Virkja pÃ¶ntun",
        enableProductPreviewImage: "Virkja vÃ¶rumynd",
        enableSpectro: "Virkja litrÃ³fsmÃ¦li",
        enableVirtualKeyboard: "Leyfa sÃ½ndarlyklaborÃ°",
        environmentsSettings: "Umhverfisstillingar",
        exportTranslationKeys: "Flytja Ãºt Ã¾Ã½Ã°ingarlykla",
        formulaNotes: "Leyfa athugasemd Ã­ uppskrift",
        hintTooltips: "HollrÃ¡Ã° um verkfÃ¦ri",
        image: "Litur + mynd/frekari upplÃ½singar",
        keyboardShortcuts: "FlÃ½tileiÃ°ir Ã¡ lyklaborÃ°i",
        languageBased: "Eftir tungumÃ¡li",
        lockYourComputer: "LÃ¦sa tÃ¶lvunni",
        machineReset: "NÃºllstilling vÃ©lar",
        manageTranslations: "StjÃ³rna Ã¾Ã½Ã°ingum",
        margin: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur)",
        markup: "AÃ°eins Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "HÃ¡marksfjÃ¶ldi uppskriftaflipa",
        memoryTabs: "Geyma nÃ½lega opnaÃ°a flipa",
        moreInfo: "Litur + mynd + frekari upplÃ½singar",
        navigationItems: "Stillingar fyrir flettiatriÃ°i",
        newTab: "NÃ½r flipi",
        numberOfPriceGroups: "FjÃ¶ldi verÃ°flokka",
        order: "PÃ¶ntun",
        orderId: "AuÃ°kenni pÃ¶ntunar",
        ordersHistory: "Ferill pÃ¶ntunar",
        overwriteLastTab: "Yfirskrifa sÃ­Ã°asta uppskriftaflipann",
        priceCalculation: "VerÃ°Ãºtreikningur",
        priceDefBothPurchasePrimary: "BÃ¦Ã°i, kaupa aÃ°al",
        priceDefBothSellPrimary: "BÃ¦Ã°i, selja aÃ°al",
        priceDefPurchaseOnly: "AÃ°eins kaupverÃ°",
        priceDefSellOnly: "AÃ°eins sÃ¶luverÃ°",
        priceDefinition: "Skilgreining Ã¡ verÃ°i",
        priceGroupsEnabled: "Virkja verÃ°flokka",
        runLightAtStartUp: "Keyra %{light} viÃ° rÃ¦singu",
        screenSaverTimeout: "FyrningartÃ­mi skjÃ¡vara",
        selectedSpectro: "Valinn %{spectro} litrÃ³fsmÃ¦lir.",
        selectedSpectroNone: "Enginn litrÃ³fsmÃ¦lir valinn.",
        setAutomaticClientStart: "Keyra %{name} viÃ° rÃ¦singu tÃ¶lvunnar",
        setCustomHomeButton: "AÃ°gerÃ°ir Ã¡ rÃ¦sihnappi",
        setDecimalPlaces: "Stilla fjÃ¶lda tugastafa",
        setFormulaPreview: "ForskoÃ°un Ã¡ uppskrift",
        setFormulaUnit: "Stilla uppskriftareiningu",
        setFts: "Nota leit Ã­ fullum texta",
        setInfoItemInRgb: "GÃ¶gn fyrir forskoÃ°un Ã¡ litun",
        setKeyboardShortcuts: "Stilla flÃ½tilykla",
        setKioskMode: "Stilla allan skjÃ¡inn",
        setKioskModeOff: "SlÃ¶kkva Ã¡ fullri skjÃ¡stillingu",
        setKioskModeOn: "Kveikja Ã¡ fullskjÃ¡sstillingu",
        setNavigationItems: "Stilla flettiatriÃ°i",
        setNavigationItemsList: "Stilla sÃ½nileika og rÃ¶Ã° flettiatriÃ°a",
        setOrderSearchItems: "Stilla breytur fyrir pÃ¶ntunarleit",
        setRounding: "Stilla nÃ¡mundun",
        setSearchParameters: "Stilla fÃ¦ribreytur fyrir uppskriftaleit",
        setTabLimit: "Stilla takmarkanir Ã¡ flipa",
        setYourLanguage: "Stilla tungumÃ¡l",
        setZoom: "Stilla aÃ°drÃ¡tt",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Ekki er hÃ¦gt aÃ° breyta Ã¾essari stillingu Ã¾ar sem sprettiglugginn hefur veriÃ° gerÃ°ur Ã³virkur Ã­ stillingum vÃ©lar",
        sortItems: "Flokka flettiatriÃ°i",
        startDispensing: "Byrja aÃ° blanda",
        stir: "HrÃ¦ra"
    },
    error: {
        errorDetail: "UpplÃ½singar um villu",
        errorOccurred:
            "ÃvÃ¦nt villa kom upp. HafÃ°u samband viÃ° Ã¾jÃ³nustuveriÃ° okkar Ã¡ %{0} og viÃ° hÃ¶fum samband viÃ° fyrsta tÃ¦kifÃ¦ri.",
        hideDetail: "Fela upplÃ½singar"
    },
    favoritesTab: {
        addFolder: "BÃ¦ta viÃ° mÃ¶ppu",
        closeTabToLoadFormula:
            "LokaÃ°u einhverju eyÃ°ublaÃ°anna til aÃ° opna nÃ½jan flipa. ÃÃº hefur nÃ¡Ã° hÃ¡marksfjÃ¶lda opinna flipa",
        deleteFolder: "EyÃ°a mÃ¶ppu",
        editFolder: "Breyta mÃ¶ppu",
        favoriteFormulas: "EftirlÃ¦tisuppskriftir",
        formulaNotes: "Athugasemd Ã­ uppskrift",
        message: {
            formulasFromFolder: "Uppskrift Ãºr mÃ¶ppu",
            moveAllFormulas: "Flytja allar uppskriftir Ãºr Ã¾essari mÃ¶ppu Ã­ aÃ°almÃ¶ppu",
            removeAllFormulas: "FjarlÃ¦gja allar uppskriftir Ãºr Ã¾essari mÃ¶ppu",
            wantToDeleteFolder: "Ã Ã¶rugglega aÃ° eyÃ°a Ã¾essari mÃ¶ppu?"
        },
        newFolder: "NÃ½ mappa",
        packages: "Pakkar",
        pricePerPackage: "VerÃ° Ã¡ pakka",
        regularPrice: "Venjulegt verÃ°",
        removeFromFavorites: "FjarlÃ¦gja Ãºr eftirlÃ¦ti",
        specialPriceOff: "TilboÃ°sverÃ° %{number}% aftengt",
        specialPriceVIP: "SÃ©rtilboÃ° fyrir vildarviÃ°skiptavini"
    },
    fileTransfer: {
        afterImport: "Eftir innflutning",
        alreadyExists: "Verkefni fyrir tilgreinda gerÃ° og sniÃ° er Ã¾egar til",
        customFormulaSimple: "SÃ©rsnÃ­Ã°a blÃ¶ndu, einfalda",
        direction: "Stefna",
        exportTask: "SkrÃ¡aflutningur",
        fileTransferNotification: "Tilkynning um skrÃ¡aflutning",
        flashMessage: "SkyndiskilaboÃ°",
        importTask: "Innflutningur Ã¡ skrÃ¡",
        noInformation: "Engar upplÃ½singar",
        protocol: {
            folder: "Mappa",
            ftp: "FTP-samskiptaregla",
            ftps: "FTPS-aÃ°ferÃ°arlÃ½sing",
            redlikeStorage: "%{softwareName} aÃ°ferÃ°arlÃ½sing fyrir FTP-geymslu",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "KÃ¶nnunarskrÃ¡r fyrir aÃ°ferÃ°arlÃ½singu Ã­ tilgreindri staÃ°bundinni mÃ¶ppu.",
            ftp: "KÃ¶nnunarskrÃ¡r fyrir aÃ°ferÃ°arlÃ½singu Ã­ ytri FTP-mÃ¶ppu gegnum venjulega FTP-tengingu.",
            ftps: "KÃ¶nnunarskrÃ¡r fyrir aÃ°ferÃ°arlÃ½singu Ã¡ ytri FTPS-Ã¾jÃ³ni (FTP-SSL / FTP Secure) gegnum venjulega FTP-tengingu.",
            redlikeStorage: "KÃ¶nnunarskrÃ¡r fyrir aÃ°ferÃ°arlÃ½singu Ã­ %{softwareName} geymslu."
        },
        remoteFolder: "RÃ³tarmappa",
        startType: "GerÃ° rÃ¦singar",
        statusbar: "UpplÃ½singar af stÃ¶Ã°ustiku",
        testConnection: "PrÃ³fa tengingu",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "GerÃ° notanda",
        filter: "SÃ­a",
        from: "FrÃ¡",
        to: "Til"
    },
    findText: {
        findTextTitle: "Leita eftir texta",
        removeMarks: "FjarlÃ¦gja merki",
        search: "Leita aÃ° orÃ°i"
    },
    flashMessage: {
        VMNotAllowed: "SÃ½ndarvÃ©l er ekki leyfÃ°.",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "SjÃ¡lfvirk innskrÃ¡ning Ã­ gagnagrunn mistÃ³kst.",
        autotaskDuplicateName:
            "GÃ¶gn um heilleika gagnagrunns: %{0} vara meÃ° %{1} %{2} er Ã¾egar til, notaÃ°u mismunandi %{3}.",
        barcodeIsUsed: "StrikamerkiÃ° er Ã¾egar Ã­ notkun",
        barcodeNotFound: "StrikamerkiÃ° fannst ekki.",
        bugReportSent: "SkÃ½rslu um hugbÃºnaÃ°arvillu hefur veriÃ° skilaÃ°.",
        cannoctConnectToServer: "Ekki er hÃ¦gt aÃ° tengjast netÃ¾jÃ³ninum.",
        cannotWriteLicense: "Ekki er hÃ¦gt aÃ° skrifa leyfi.",
        clientConnectionRejected: "Tengingu hefur veriÃ° hafnaÃ°.",
        clientNotLoggedIn: "BiÃ°larinn er ekki innskrÃ¡Ã°ur.",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty: "NiÃ°urstÃ¶Ã°ur Ãºr litaleit meÃ° hermingu eru auÃ°ar",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "TÃ¶lvan hefur veriÃ° dagsett aftur.",
        connectionFailed: "PrÃ³fun tengingar mistÃ³kst: %{0}",
        connectionSuccess: "PrÃ³fun tengingar tÃ³kst",
        corruptedLicenseFile: "LeyfisskrÃ¡in er skemmd.",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "ViÃ°skiptavinur fannst ekki.",
        dataNotAvailable: "NetÃ¾jÃ³nn getur ekki tengst gagnagrunninum.",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "ÃvÃ¦nt villa kom upp viÃ° sÃ­Ã°ustu Ã¾jÃ³nsaÃ°gerÃ°.",
        deleteAll: "Eyddu Ã¶llu.",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "HÃ¦gt er aÃ° slÃ¶kkva Ã¡ viÃ°bÃ³tinni fyrir vetur meÃ° Ã¾vÃ­ aÃ° nota fellilistann hÃ¦gra megin Ã¡ flipasvÃ¦Ã°inu.",
        duplicateBarcode: "Afrit af strikamerki er Ã¾egar til",
        duplicateName: "TvÃ­tekning, heiti er Ã¾egar til.",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "LeyfiÃ° er ÃºtrunniÃ°.",
        exportSuccess: "ÃaÃ° tÃ³kst aÃ° flytja Ãºt gÃ¶gn.",
        fandeckExist: "Ãetta heiti Ã¡ sÃ©rsniÃ°nu litakorti er Ã¾egar til.",
        featureNotAutorized: "AÃ°gerÃ°in er ekki samÃ¾ykkt.",
        fileExportComplete: "ÃaÃ° tÃ³kst aÃ° flytja Ãºt skrÃ¡na.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "SkrÃ¡ fylgir ekki eÃ°a er tÃ³m.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Ekki var hÃ¦gt aÃ° vinnu Ãºr gÃ¶gnum Ã­ skrÃ¡nni, skrÃ¡in er ekki gild.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Ekki tÃ³kst aÃ° greina ÃºtgÃ¡fu skrÃ¡arinnar.",
        filetransferNoData: "Engin tenging viÃ° gagnagrunn, athugaÃ°u stillingar",
        formulaDataUnavailable: "UppskriftargÃ¶gn eru ekki tiltÃ¦k.",
        helperDefaultMessage: "ÃaÃ° kom upp Ã³vÃ¦nt villa viÃ° sÃ­Ã°ustu aÃ°gerÃ° frÃ¡ hjÃ¡lparÃ¾jÃ³ninum.",
        helperServerError: "Villa Ã­ hjÃ¡lparÃ¾jÃ³ni.",
        importAborted: "InnflutningsferliÃ° var truflaÃ°.",
        importSuccess: "ÃaÃ° tÃ³kst aÃ° flytja inn gÃ¶gn.",
        incompatibleBaseCan: "Grunnurinn getur ekki veriÃ° samhÃ¦fur viÃ° tilgreinda vÃ¶ru, grunn og pakka.",
        incorrectPassword: "Gamli aÃ°gangskÃ³Ã°inn Ã¾inn er rangur. FÃ¦rÃ°u inn rÃ©ttan kÃ³Ã°a.",
        invalidCurrency: "GjaldmiÃ°ilskÃ³Ã°i er Ã³gildur. Evra er stillt sem sjÃ¡lfgefinn gjaldmiÃ°ill.",
        invalidDatabaseName: "Heiti gagnagrunnsins er Ã³gilt.",
        invalidEmail: "NetfangiÃ° Ã¾itt er Ã³gilt.",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Lykill notanda Ã­ fyrirtÃ¦ki er Ã³gildur.",
        invalidLicenseFile: "LeyfisskrÃ¡ er Ã³gild.",
        invalidLicenseIdentificationKeys: "AuÃ°kennislyklar Ã¾Ã­nar fyrir leyfiÃ° eru Ã³gildir.",
        invalidLicenseKey: "LeyfiÃ° Ã¾itt er Ã³gilt",
        invalidLicenseProduct: "LeyfisskrÃ¡in passar ekki viÃ° vÃ¶runa.",
        invalidRccResponse: "ÃvÃ¦nt villa kom upp viÃ° meÃ°hÃ¶ndlun Ã¡ sÃ­Ã°asta RCC-svari (Redlike Control Center).",
        invalidServerResponse: "ÃvÃ¦nt villa kom upp viÃ° meÃ°hÃ¶ndlun Ã¡ sÃ­Ã°asta svari netÃ¾jÃ³ns.",
        invalidUrl: "SlÃ³Ã°in er Ã³gild.",
        itemNotFound: "Varan fannst ekki.",
        keyboardShortcutUsedInModal:
            "Ekki er hÃ¦gt aÃ° nota Ã¾ennan flÃ½tilykil Ã­ sprettiglugganum. LokaÃ°u fyrst sprettiglugganum.",
        keyboardShortcutValidation: "Ekki er hÃ¦gt aÃ° stilla einn flÃ½tilykil fyrir tvÃ¦r mismunandi aÃ°gerÃ°ir.",
        licenseHasBeenRevoked:
            "LeyfiÃ° Ã¾itt hefur veriÃ° afturkallaÃ°. HafÃ°u samband viÃ° sÃ¶luaÃ°ila hugbÃºnaÃ°arins til aÃ° endurnÃ½ja leyfiÃ°.",
        licenseProlongationNeeded: "Framlengja Ã¾arf leyfi (tengdu tÃ¶lvu viÃ° internetiÃ° til aÃ° fÃ¡ nÃ½tt leyfi)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "LeyfiÃ° fyrir vÃ¶runni er upphaflega gefiÃ° Ãºt fyrir aÃ°ra tÃ¶lvu.",
        logFileArchiveDownloadComplete: "ÃaÃ° tÃ³kst aÃ° sÃ¦kja skrÃ¡asafniÃ°.",
        loginError: "ÃvÃ¦nt villa kom upp viÃ° innskrÃ¡ningu.",
        logoutError: "ÃvÃ¦nt villa kom upp viÃ° ÃºtskrÃ¡ningu.",
        machineIsConnecting: "VÃ©lin er tengd, bÃ­ddu andartak.",
        machineIsNotConnected: "VÃ©lin Ã¾Ã­n er EKKI TENGD viÃ° RCC. AthugaÃ°u stillingar RCC (Redlike Control Center).",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "HÃ¡marksfjÃ¶lda flipa nÃ¡Ã°. LokaÃ°u einum flipanna.",
        noTemplate: "Ekki er hÃ¦gt aÃ° prenta Ã¾ar sem engin sniÃ°mÃ¡t eru tiltÃ¦k.",
        openNewTab: "OpnaÃ°u nÃ½jan uppskriftarflipa til aÃ° lesa uppskriftina meÃ° Ã¾vÃ­ aÃ° nota strikamerki",
        orderAlreadyAcquired: "PÃ¶ntunin hefur Ã¾egar veriÃ° keypt, Ã¾aÃ° verÃ°ur aÃ° gefa hana Ãºt fyrst.",
        orderCreated: "PÃ¶ntunin hefur veriÃ° send.",
        passwordIsNotUnique: "NÃ½ja aÃ°gangsorÃ°iÃ° verÃ°ur aÃ° vera frÃ¡brugÃ°iÃ° Ã¾vÃ­ gamla.",
        printCannotBeCarriedOut: "Ekki er hÃ¦gt aÃ° prenta vegna Ã¾ess aÃ° prentaranafniÃ° er Ã³gilt.",
        problemWithFileExport: "Villa kom upp Ã¾egar skrÃ¡in var vistuÃ° Ã¡ diskinum.",
        productFileWarning: "VÃ¶ruskrÃ¡in er aÃ°eins aÃ°gengileg Ã¡ netinu.",
        productNotLicensed: "Ekkert leyfi er til fyrir vÃ¶runni.",
        rccDefaultMessage: "ÃvÃ¦nt villa kom upp viÃ° sÃ­Ã°ustu RCC-aÃ°gerÃ° (Redlike Control Center).",
        rccError: "Villa Ã­ RCC (Redlike Control Center)",
        rccNeedRestart: "EndurrÃ¦stu RCC (Redlike Control Center) aftur.",
        restoredSettings: "Stillingarnar voru endurheimtar.",
        revokedLicense: "LeyfiÃ° hefur veriÃ° afturkallaÃ°.",
        runningOutOfSpace: "TÃ¶lvan er aÃ° verÃ°a uppiskroppa meÃ° geymsluplÃ¡ss.",
        savedFormulaToHistory: "Uppskriftin var vistuÃ° Ã­ litatÃ³naferlinum.",
        savedLogArchive: "SkrÃ¡asafniÃ° var vistaÃ° Ã­ safninu Ã¾Ã­nu.",
        scanning: "Hreinsun Ã­ gangi",
        serverError: "NetÃ¾jÃ³nsvilla",
        setClientIdentifier: "Tilgreindu fyrst biÃ°laraauÃ°kenniÃ° Ã¾itt.",
        showLess: "SÃ½na minna",
        showMore: "SÃ½na meira",
        spectroIsDisconnecting: "LitrÃ³fsmÃ¦lir aftengist, bÃ­ddu andartak.",
        spectroIsNotConnected:
            "LitrÃ³fsmÃ¦lir er EKKI TENGDUR sem stendur. AthugaÃ°u stillingar RCC (Redlike Control Center).",
        spectroIsNotSelected:
            "LitrÃ³fsmÃ¦lir er EKKI VALINN aÃ° svo stÃ¶ddu. AthugaÃ°u stillingar RCC (Redlike Control Center).",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "ÃÃ¾ekkt villa: %{0}",
        userAlreadyLoggedIn: "ÃÃº ert Ã¾egar skrÃ¡Ã°(ur) inn.",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Ekki tÃ³kst aÃ° tengjast Web Api-netÃ¾jÃ³ninum.",
        webApiInternalError: "Web Api-netÃ¾jÃ³nn â innri villa",
        webApiInvalidUser: "Web Api-netÃ¾jÃ³nn â Ã³gildur notandi",
        webApiNoLicenseAvailable: "Web Api-netÃ¾jÃ³nn â ekkert leyfi Ã­ boÃ°i",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Rangt sniÃ° fyrir %{0} innslÃ¡tt.",
        wrongRccVersion:
            "AthugaÃ°u ÃºtgÃ¡fu Ã¾Ã­na af RCC (Redlike Control Center). BiÃ°larinn Ã¾inn er aÃ°eins samhÃ¦fur viÃ° RCC (Redlike Control Center) %{0}. "
    },
    footer: {
        aboutApplication: "Um umsÃ³kn",
        activeUser: "Virkur notandi",
        logOut: "ÃtskrÃ¡ning",
        machineErrors: "VÃ©larbilun"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Allar mÃ¦lieiningar sem eru tiltÃ¦kar Ã­ gagnagrunni",
        allowCustomFormulas: "Leyfa sÃ©rsniÃ°nar uppskriftir",
        allowCustomPackageSize: "Leyfa sÃ©rsniÃ°na pakkastÃ¦rÃ°",
        allowFormulaAutomaticNaming: "Leyfa sjÃ¡lfvirka Ãºthlutun heitis",
        automaticNaming: "SjÃ¡lfvirk Ãºthlutun heitis fyrir uppskrift",
        basePanelSize: "Stilla stÃ¦rÃ° stjÃ³rnborÃ°s fyrir grunn",
        bippPanelSize: "Stilla stÃ¦rÃ° stofns Ã¡ stjÃ³rnborÃ°i fyrir vÃ¶rustÃ¦rÃ°",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "LitasvÃ¦Ã°i",
        colorPreviewAsImage: "ForskoÃ°un lita sem mynd",
        colorPreviewResizable: "StÃ¦rÃ°arstillanleg forskoÃ°un lita",
        competitiveColorSearch: "Litaleit meÃ° hermingu",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "SÃ©rsniÃ°nar uppskriftir",
        customPackageSettingsUnitGrav: "SÃ©rstilla mÃ¦lieiningu fyrir Ã¾yngd Ã­ stillingum pakka",
        customPackageSettingsUnitVol: "SÃ©rstilla mÃ¦lieiningu fyrir magn Ã­ stillingum pakka",
        customPackageSize: "SÃ©rsniÃ°in pakkastÃ¦rÃ°",
        customUnits: "Velja sÃ©rstakar mÃ¦lieiningar",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Breyta litarefnum",
        editColorantsAllowed: "Leyfa breytingar Ã¡ litarefnum",
        fandeckPanelSize: "Stilla stÃ¦rÃ° stjÃ³rnborÃ°s fyrir litaspjald",
        favoriteFormulas: "EftirlÃ¦tisuppskriftir",
        formulaColorPreview: "ForskoÃ°un Ã¡ lit Ã­ uppskrift",
        formulaDataSettings: "Gagnastillingar uppskrifta",
        formulaPanel: "UppskriftarsvÃ¦Ã°i",
        formulaPanelSize: "Stilla stÃ¦rÃ° stjÃ³rnborÃ°s fyrir formÃºlu",
        formulaSettings: "Stillingar uppskrifta",
        generateColorPreview: "BÃºa til forskoÃ°un",
        gravimetricOnly: "AÃ°eins Ã¾yngdarmÃ¦lieiningar",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "Nota aÃ°eins mynd Ãºr staÃ°bundnum gagnagrunni",
        imagesOnline: "Reyndu fyrst aÃ° opna mynd Ã¡ netinu, ef Ã¾aÃ° mistekst skal opna mynd Ãºr staÃ°bundinni geymslu",
        infoPanelResizable: "StÃ¦rÃ°arstillanlegt stjÃ³rnborÃ° upplÃ½singa",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "MÃ¦lieiningin fer eftir valinni vÃ¶ru",
        productFilesDialog: "SÃ½na glugga til aÃ° opna skrÃ¡ Ã¡ netinu",
        productFilesLocal: "Nota aÃ°eins vÃ¶ruskrÃ¡r Ãºr staÃ°bundnum gagnagrunni",
        productFilesOnline:
            "Reyndu fyrst aÃ° opna vÃ¶ruskrÃ¡ Ã¡ netinu, ef Ã¾aÃ° mistekst skal opna skrÃ¡ Ãºr staÃ°bundinni geymslu",
        productPanelSize: "Stilla stÃ¦rÃ° stjÃ³rnborÃ°s fyrir vÃ¶ru",
        searchPanelQuickSelect: "FlÃ½tival",
        setAdditionalFormulaPanel: "Stilla viÃ°bÃ³taruppskriftarsvÃ¦Ã°i",
        setCompetitiveColorSearch: "Leyfa litaleit meÃ° hermingu",
        setInitialFormulaPanel: "Stilla upphaflegt uppskriftarsvÃ¦Ã°i ",
        setMaxToleranceForCompetitiveColors: "Stilla hÃ¡marksfrÃ¡vik viÃ° litaleit meÃ° hermingu",
        setNumberOfCompetitiveColors: "Stilla fjÃ¶lda lita viÃ° hermingu",
        setSearchPanel: "Stilla leitarsvÃ¦Ã°i",
        setVisibilityAndOrder: "Stilla sÃ½nileika og rÃ¶Ã° mismunandi uppskriftagagna",
        setVisibleUnit: "Stilla sÃ½nilegar einingar",
        showColorPreview: "SÃ½na forskoÃ°un Ã¡ lit",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "RÃ¶Ã°un Ã¡ stjÃ³rnborÃ°i fyrir litarefni",
        useBase: "Nota valda vÃ¶ru sem stofn",
        useBaseInProductPackage: "Nota valda vÃ¶ru sem stofn Ã­ vÃ¶rustÃ¦rÃ°",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "Nota valda vÃ¶ru sem vÃ¶ru",
        useProductCode: "Notkun vÃ¶rukÃ³Ã°a",
        useProductGroups: "Nota vÃ¶ruflokka",
        volumetricOnly: "AÃ°eins rÃºmmÃ¡lsmÃ¦lieiningar"
    },
    general: {
        accepted: "Accepted",
        active: "SÃ­Ã°asta aÃ°gerÃ°",
        actual: "Raunverulegt",
        actualLevel: "NÃºverandi hÃ¦Ã°",
        add: "BÃ¦ta viÃ°",
        addColorant: "BÃ¦ta viÃ° litarefni",
        addColorantForPackage: "Add colorant for package",
        addFile: "BÃ¦ta viÃ° skrÃ¡",
        all: "Allt",
        amount: "Magn",
        applyNow: "Apply now",
        attachments: "SambÃ¶nd",
        automaticCorrection: "Automatic correction",
        automatically: "SjÃ¡lfkrafa",
        available: "TiltÃ¦kt",
        back: "Til baka",
        base: "Grunnur",
        baseInProductPackage: "Grunnur Ã­ vÃ¶ru og pakka",
        batchNumber: "Batch number",
        bottom: "Botn",
        buildingSite: "Building site",
        calculate: "Reikna",
        can: "DÃ³s/fata",
        canSize: "StÃ¦rÃ° Ã¡ dÃ³s/fÃ¶tu",
        cancel: "Ãgilda",
        canister: "LitahÃ³lf",
        canisterId: "AuÃ°kenni hylkis",
        canisterIndex: "SkrÃ¡ yfir litahÃ³lf",
        canisters: "Hylki",
        cap: "Lok",
        capacity: "AfkÃ¶st",
        channels: "RÃ¡sir",
        choose: "Velja",
        city: "Borg/bÃ¦r",
        clean: "Hreinsa",
        clear: "GlÃ¦rt",
        client: "BiÃ°lari",
        close: "Loka",
        closeAll: "Loka Ã¶llu",
        collapseAll: "Fela allt",
        color: "Litur",
        colorCode: "LitakÃ³Ã°i",
        colorFile: "Colorfile",
        colorName: "Heiti litar",
        colorPreview: "ForskoÃ°un Ã¡ lit",
        colorant: "Litarefni",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Litarefnispakki",
        colorants: "Litarefni",
        colors: "Colors",
        company: "FyrirtÃ¦ki",
        competitiveColor: "Competitive color",
        confirm: "StaÃ°festa",
        confirmDeletion: "Ã Ã¶rugglega aÃ° eyÃ°a Ã¾essu varanlega?",
        confirmHelpSettings: "Ã Ã¶rugglega aÃ° geyma Ã¾etta eyÃ°ublaÃ° og skilja reitinn eftir auÃ°an?",
        connect: "Tengja",
        continue: "Halda Ã¡fram",
        correction: "Correction",
        country: "Land",
        created: "BÃºiÃ° til",
        creationDateOf: "Creation date of",
        criticalLevel: "Of lÃ­tiÃ° magn Ã­ hylki",
        currency: "GjaldmiÃ°ill",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "SÃ©rsniÃ°iÃ°",
        customData: "Custom data",
        customFandeck: "SÃ©rsniÃ°iÃ° litakort",
        customFormula: "SÃ©rstilla blÃ¶ndu",
        customPackage: "SÃ©rsniÃ°iÃ°",
        customPackageSettings: "SÃ©rstilla pakkastillingar",
        customer: "ViÃ°skiptavinur",
        customerVersion: "ÃtgÃ¡fa viÃ°skiptavinar",
        customers: "ViÃ°skiptavinir",
        database: "Gagnagrunnur",
        date: "Dagsetning",
        default: "SjÃ¡lfgefiÃ°",
        delete: "EyÃ°a",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "LÃ½sing",
        disconnect: "HÃ¦tta",
        discount: "AfslÃ¡ttur",
        discover: "UppgÃ¶tva",
        dispense: "Skammta",
        dispensing: "Skammta",
        doNotShowAgain: "Ekki sÃ½na Ã¾essi skilaboÃ° aftur.",
        downloadingFile: "SÃ¦kir skrÃ¡r",
        edit: "Breyta",
        email: "TÃ¶lvupÃ³stur",
        enabled: "Gert virkt",
        error: "Villa",
        expandAll: "StÃ¦kka allt",
        exportData: "Flytja Ãºt gÃ¶gn",
        exportPdf: "Flytja Ãºt PDF-skjÃ¶l",
        fan: "Litakort",
        fandeck: "Litakort",
        fandeckCode: "Fandeck code",
        fandeckName: "Heiti litakorts",
        fandecks: "Litakort",
        favorite: "EftirlÃ¦ti",
        fileTransfer: "SkrÃ¡aflutningur",
        filling: "Spartl",
        fillingDate: "Dagsetning Ã¡fyllingar",
        find: "Finna",
        finish: "LjÃºka",
        finishedCorrection: "Finished correction",
        formula: "Uppskrift",
        formulas: "Formulas",
        frontdesk: "AfgreiÃ°sla",
        getQrCode: "SÃ¦kja QR-kÃ³Ã°a",
        gravimetric: "ÃyngdarmÃ¦ling",
        historical: "Historical",
        history: "Ferill",
        hours: "Hou.",
        id: "AuÃ°kenni",
        images: "Myndir",
        in: "Ã",
        index: "AtriÃ°askrÃ¡",
        insertBarcode: "FÃ¦rÃ°u inn strikamerki",
        install: "Setur upp",
        installed: "Sett upp",
        instructions: "LeiÃ°beiningar",
        internalNote: "Innri athugasemd",
        interval: "TÃ­mabil",
        ip: "IP-tala",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "TakmÃ¶rk",
        load: "HlaÃ°a",
        loadFormula: "Lesa uppskrift",
        localVersion: "StaÃ°bundin ÃºtgÃ¡fa",
        machine: "VÃ©l",
        manualCorrection: "Manual correction",
        manually: "Handvirkt",
        margin: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur)",
        markup: "Ãskilegt hagnaÃ°arhlutfall (Ã¡lagning)",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "HÃ¡markshÃ¦Ã°",
        maxValue: "HÃ¡m.",
        maximum: "HÃ¡mark",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamerismi (lagskipting lita)",
        minimum: "LÃ¡gmark",
        minutes: "LÃ¡gm.",
        missingItem: "Vara sem vantar",
        missingRequiredItems: "Allir stjÃ¶rnumerktri reitir eru Ã¡skildir",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Meira",
        moreInfo: "Frekari upplÃ½singar",
        moveDown: "FÃ¦ra niÃ°ur",
        moveUp: "FÃ¦ra upp",
        myOrders: "MÃ­nar pantanir",
        name: "Heiti",
        nameTitle: "Heiti",
        new: "NÃ½tt",
        next: "NÃ¦sta",
        no: "Ekkert",
        noColorantsAvailable: "Ekkert litarefni er tiltÃ¦kt",
        noFormulas: "Engin uppskrift enn",
        noPricesAvailable: "Ekkert verÃ° Ã­ boÃ°i",
        nominalAmount: "Nafnmagn",
        notAvailable: "Ekki tiltÃ¦kt",
        note: "Athugasemd",
        numberOfCanisters: "FjÃ¶ldi hylkja",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "FjÃ¶ldi merkimiÃ°a",
        numberOfPackages: "FjÃ¶ldi pakka",
        off: "SlÃ¶kkt",
        ok: "Ã lagi",
        on: "Kveikt",
        onFocus: "Ã fÃ³kus",
        open: "OpiÃ°",
        operator: "Operator",
        options: "MÃ¶guleikar",
        order: "Order",
        other: "AnnaÃ°",
        otherError: "AÃ°rar villur",
        out: "Ãt",
        overwrite: "Overwrite",
        package: "Pakki",
        packagePreview: "ForskoÃ°un Ã¡ pakka",
        partialUpdates: "Partial updates",
        phone: "SÃ­mi",
        pleaseWait: "Augnablik",
        previous: "Previous",
        price: "VerÃ°",
        priceGroup: "VerÃ°flokkur",
        print: "Ãtprentun",
        printTask: "PrentaÃ°gerÃ°",
        processingStep: "Processing %{step}",
        product: "Vara",
        productCode: "VÃ¶rukÃ³Ã°i",
        productName: "VÃ¶ruheiti",
        products: "VÃ¶rur",
        pump1: "Pumpa 1",
        pump2: "Pumpa 2",
        purchasePrice: "KaupverÃ°",
        purge: "Hreinsun",
        qualityControl: "Quality control",
        quantity: "Magn",
        quantityQty: "QTY",
        quickTint: "FljÃ³tleg litblÃ¶ndun",
        rccIsNotAvailable: "RCC er ekki tiltÃ¦kt",
        rccIsNotConnected: "RCC (Redlike Control Center) er ekki tengt",
        rccNotLicensed: "RCC er ekki heimilaÃ°",
        reconnect: "Tengjast aftur",
        refill: "Fylla Ã¡ aftur",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "NÃºllstilla",
        restart: "EndurrÃ¦sa",
        restore: "Endurheimta",
        retint: "Endurlita",
        revision: "EndurskoÃ°un",
        safetySheet: "ÃryggisblaÃ°",
        save: "Vista",
        saveAs: "Vista sem",
        saveToDispensingHistory: "Vista Ã­ ferli",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sek.",
        select: "Select",
        selectAll: "Velja allt",
        selectChannels: "Velja rÃ¡sir",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "SÃ¶luverÃ°",
        settings: "Stillingar",
        shelf: "Hilla",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "StÃ¦rÃ°",
        skip: "Hlaupa yfir",
        smartPurge: "Snjallhreinsun",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "LitrÃ³fsmÃ¦lir",
        standardFormula: "StÃ¶Ã°luÃ° formÃºla",
        status: "StaÃ°a",
        street: "Gata",
        sum: "Sum",
        summary: "Samantekt",
        sync: "Samstillir",
        technicalSheet: "TÃ¦kniblaÃ°",
        templates: "SniÃ°mÃ¡t",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "BlÃ¶ndun lita",
        top: "Efst",
        total: "Samtals",
        totalAmount: "Heildarmagn",
        totalBaseAmount: "Heildarmagn stofns",
        totalColorantAmount: "Heildarmagn litarefna",
        type: "Type",
        ufiCode: "UFI-kÃ³Ã°i",
        ufiThreshold: "UFI-mÃ¶rk",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Eining",
        units: "TÃ¦ki",
        unknown: "Unknown",
        update: "UppfÃ¦ra",
        updated: "UppfÃ¦rt",
        user: "Notandi",
        value: "Gildi",
        vat: "VSK",
        verified: "Verified",
        version: "ÃtgÃ¡fa",
        versionId: "AuÃ°kenni ÃºtgÃ¡fu",
        versionStructure: "Samsetning ÃºtgÃ¡fu",
        volumetric: "RÃºmmÃ¡lseining",
        warning: "ViÃ°vÃ¶run",
        warningLevel: "ViÃ°vÃ¶runarstig",
        withoutName: "(nafnlaust)",
        workingProperly: "Working properly",
        yes: "JÃ¡",
        zoom: "AÃ°drÃ¡ttur"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° %{name} biÃ°ji um aÃ° lÃ¡ta hreinsa burstaÃ­lÃ¡tiÃ° Ã¡ tilteknum tÃ­ma. StjÃ³rnandi skammtara skal fjarlÃ¦gja og hreinsa burstaÃ­lÃ¡tiÃ° handvirkt og setja Ã¾aÃ° Ã¾vÃ­ nÃ¦st handvirkt aftur Ã¡ sinn staÃ°.",
            capMaintenance:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° %{name} biÃ°ji um aÃ° lÃ¡ta hreinsa hettuna Ã¡ tilteknum tÃ­ma. StjÃ³rnandi skammtara skal hreinsa sjÃ¡lfvirka lokunarbÃºnaÃ°inn handvirkt Ã¾egar hann opnast.",
            cleanAll:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi sjÃ¡lfkrafa hreinsun allra rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            cleanChannels:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi sjÃ¡lfkrafa hreinsun tiltekinna rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            computerReboot: "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° tÃ¶lvan endurrÃ¦sist sjÃ¡lfkrafa Ã¡ tilteknum tÃ­ma.",
            computerShutdown:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° slÃ¶kkt verÃ°i sjÃ¡lfkrafa Ã¡ tÃ¶lvunni Ã¡ tilteknum tÃ­ma.",
            dispenserCleaning:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° %{name} biÃ°ji um aÃ° lÃ¡ta hreinsa skammtarann Ã¡ tilteknum tÃ­ma. StjÃ³rnandi skammtara skal hreinsa vÃ©lina handvirkt meÃ° klÃºt.",
            humidifierWaterLevelMaintenance:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° %{name} biÃ°ji um endurÃ¡fyllingu rakatÃ¦kis Ã¡ tilteknum tÃ­ma. StjÃ³rnandi skammtara skal fylgjast meÃ° vatnshÃ¦Ã° Ã­ rakatÃ¦kinu og fylla Ã¡ handvirkt.",
            purgeAll:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi hreinsun allra rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            purgeChannels:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi hreinsun tiltekinna rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            recirculateAll:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi endurdÃ¦lingu allra rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            recirculateChannels:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi endurdÃ¦lingu tiltekinna rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            refillAll:
                "Stilltu Ã¾etta sjÃ¡lfvirka verk Ã¡ aÃ° lÃ¡ta %{name} biÃ°ja um aÃ°gerÃ°ina aÃ° fylla sjÃ¡lfkrafa aftur Ã¡ allar rÃ¡sir Ã¡ tilgreindum tÃ­ma. StjÃ³rnandi litafÃ©lar Ã¾arf aÃ° fylla  Ã¡ litarefni handvirkt Ã­ Ã¶ll litahÃ³lf.",
            refillCanisters:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° (autotask) til aÃ° lÃ¡ta %{name} biÃ°ja um aÃ°gerÃ°ina aÃ° fylla sjÃ¡lfkrafa aftur Ã¡ tilteknar rÃ¡sir Ã¡ tilgreindum tÃ­ma. StjÃ³rnandi skammtara Ã¾arf handvirkt aÃ° fylla  Ã¡ litarefni  Ã­ litahÃ³lf sem ekki uppfylla skilyrÃ°i.",
            smartPurgeAll:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi sjÃ¡lfkrafa snjallhreinsun allra rÃ¡sa Ã¡ tilteknum tÃ­ma. Hreinsun verÃ°ur framkvÃ¦md, svo framarlega sem allar krÃ¶fur fyrir snjallhreinsun hafa veriÃ° uppfylltar.",
            smartPurgeChannels:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi sjÃ¡lfkrafa snjallhreinsun tiltekinna rÃ¡sa Ã¡ tilteknum tÃ­ma. Hreinsun verÃ°ur framkvÃ¦md, svo framarlega sem allar krÃ¶fur fyrir snjallhreinsun hafa veriÃ° uppfylltar.",
            stirAll:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi hrÃ¦ringu allra rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            stirCanisters:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° skammtarinn framkvÃ¦mi hrÃ¦ringu tiltekinna rÃ¡sa Ã¡ tilteknum tÃ­ma.",
            switchPlateMaintenance:
                "Stilltu Ã¾essa sjÃ¡lfvirku aÃ°gerÃ° Ã¾annig aÃ° %{name} biÃ°ji um aÃ° lÃ¡ta hreinsa rofaplÃ¶tuna Ã¡ tilteknum tÃ­ma. StjÃ³rnandi skammtara skal fjarlÃ¦gja og hreinsa rofaplÃ¶tuna handvirkt og setja hana Ã¾vÃ­ nÃ¦st handvirkt aftur Ã¡ sinn staÃ°."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "Heimilt aÃ° bÃ¦ta viÃ° nÃ½jum netÃ¾jÃ³ni handvirkt ef ekki er hÃ¦gt aÃ° finna hann meÃ° leitaraÃ°gerÃ°inni.",
            clientIdentifier:
                "Ãessi valkostur gerir Ã¾Ã©r kleift aÃ° auÃ°kenna Ã¾ennan biÃ°lara ef margir biÃ°larar eru tengdir netÃ¾jÃ³ninum.",
            disconnect:
                "UpplÃ½singar um netÃ¾jÃ³ninn sem er Ã­ notkun. Aftengingarhnappurinn gerir Ã¾Ã©r kleift aÃ° fara af Ã¾essum netÃ¾jÃ³ni og skipta yfir Ã­ annan ef hann er til staÃ°ar.",
            discover: "Finndu Ãºt hvort Ã¾aÃ° eru aÃ°rir netÃ¾jÃ³nar Ã­ boÃ°i Ã¡ Ã¾essu neti.",
            dropServers: "Eyddu Ã¶llum netÃ¾jÃ³num sem hafa fundist Ã¡Ã°ur af Ã¾essum lista.",
            dropServersNotAvailable: "ÃaÃ° er enginn netÃ¾jÃ³nn Ã­ boÃ°i",
            edit: "LeyfÃ°u handvirkar breytingar Ã¡ netÃ¾jÃ³ni sem Ã¾egar hefur fundist.",
            editDisabled: "Enginn netÃ¾jÃ³nn var valinn."
        },
        continue: "Viltu Ã¶rugglega halda Ã¡fram?",
        driverSettings: {
            alfaRestApi: {
                host: "FÃ¦rÃ°u inn vÃ©larheiti tÃ¶lvunnar eÃ°a IP-tÃ¶lu hennar.",
                machineType: "Ã viÃ° um allar Alfa-vÃ©lar. BÃ¦Ã°i Windows og Linux."
            },
            corobDsProxy: {
                machineType:
                    "Gildir fyrir kynslÃ³Ã°irnar Slave (D200, D600 ..), 4G (First One) og 5G (EvoFlx). DspProxy verÃ°ur aÃ° vera uppsett. AÃ°eins Windows."
            },
            corobEvoDriver: {
                machineType:
                    "Gildir fyrir kynslÃ³Ã° 5G (EvoFlx). EVOservice verÃ°ur aÃ° vera sett upp. BÃ¦Ã°i Windows og Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "Velja grunnstillingu blÃ¶ndunarvÃ©lar fyrir liti. StÃ¶Ã°luÃ° stilling.",
                hldRootDir: "Velja aÃ°almÃ¶ppuna fyrir HLD. StÃ¶Ã°luÃ° stilling.",
                machineType:
                    "Gildir fyrir Corob Flex (500, 520, 540) = Ã¡Ã°ur Lenteq. HLD verÃ°ur aÃ° vera sett upp. AÃ°eins Ã­ Windows."
            },
            corobNextDriver: {
                machineType:
                    "Gildir fyrir kynslÃ³Ã°irnar Slave (D200, D600 ..), 4G (First One) og 5G (EvoFlx). NextDriver verÃ°ur aÃ° vera sett upp. AÃ°eins Linux."
            },
            dromontDDrv: {
                databasePath: "SlÃ³Ã° aÃ° gagnagrunninum meÃ° kvÃ¶rÃ°unargÃ¶gnum. StÃ¶Ã°luÃ° stilling.",
                driverPath: "SlÃ³Ã° aÃ° reklinum (D_DRV.exe). StÃ¶Ã°luÃ° stilling.",
                machineType:
                    "Ãbein samskipti skammtara um stilltar slÃ³Ã°ir. Ã viÃ° um kynslÃ³Ã°ir V1 og V2. D_SET verÃ°ur aÃ° vera sett upp. BÃ¦Ã°i Windows og Linux.",
                resultPath: "SlÃ³Ã° aÃ° niÃ°urstÃ¶Ã°uskrÃ¡nni sem sett er upp Ã¾egar aÃ°gerÃ° er lokiÃ°. StÃ¶Ã°luÃ° stilling.",
                serviceSoftwarePath: "SlÃ³Ã° aÃ° Dromont-Ã¾jÃ³nustuhugbÃºnaÃ°inum (D_SET.exe). SjÃ¡lfgefin forstilling."
            },
            dromontDirect: {
                machineType:
                    "Bein samskipti viÃ° skammtara. Ã viÃ° um kynslÃ³Ã°ir V1 og V2. D_SET verÃ°ur aÃ° vera sett upp. BÃ¦Ã°i Windows og Linux.",
                rootDir: "Veldu aÃ°almÃ¶ppuna Dromont, meÃ° sjÃ¡lfgefinni stillingu."
            },
            dromontMisura: {
                driverPath:
                    "SlÃ³Ã° aÃ° reklinum (MisuraRetail.exe) kann aÃ° breytast, allt eftir Ã¾vÃ­ hvaÃ°a ÃºtgÃ¡fa Misura Retail er notuÃ°. StÃ¶Ã°luÃ° stilling.",
                extensionPath: "SlÃ³Ã° aÃ° samskiptaskrÃ¡ fyrir Ã¾jÃ³nustuaÃ°gerÃ°ir.",
                formulaPath: "LeiÃ° aÃ° samskiptaskrÃ¡ fyrir litblÃ¶ndun.",
                machineType: "Ã viÃ° um kynslÃ³Ã° V3. Dromont Misura verÃ°ur aÃ° vera sett upp. AÃ°eins Windows."
            },
            fastAndFluidIDD: {
                machineType: "Ã viÃ° um allar F & F-vÃ©lar. AÃ°eins Windows.",
                path: "StyÃ°ur IDD2 (HA 450, HA 650, X-smart o.s.frv.) â hÃ¡Ã° leyfi, IDD3 (HP 500 o.s.frv.), IDD4 (HA 180, HA 480, HA 680, Xprotint o.s.frv.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "Ã viÃ° um allar F & F-vÃ©lar. BÃ¦Ã°i Windows og Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "Ã viÃ° um allar Hero-vÃ©lar. AÃ°eins Windows."
            },
            italtinto: {
                machineType:
                    "Ã viÃ° um allar Italtinto-vÃ©lar. Wcal eÃ°a ItaltintoCal verÃ°ur aÃ° vera sett upp. AÃ°eins Windows.",
                path: "SlÃ³Ã° aÃ° leiÃ°rÃ©ttri Italtinto-stillingarskrÃ¡."
            },
            manualAdvanced: {
                machineType: "Ã viÃ° um allar handstÃ½rÃ°ar vÃ©lar, Ã¾.m.t. stuÃ°ning fyrir hylki. BÃ¦Ã°i Windows og Linux.",
                path: "SlÃ³Ã° aÃ° grunnstillingarskrÃ¡nni meÃ° gÃ¶gnum um litblÃ¶ndunarvÃ©lina og Ã­lÃ¡tin."
            },
            manualSimple: {
                machineType: "Ã viÃ° um allar handstÃ½rÃ°ar vÃ©lar. BÃ¦Ã°i Windows og Linux.",
                path: "SlÃ³Ã° aÃ° grunnstillingarskrÃ¡nni meÃ° gÃ¶gnum um litblÃ¶ndunarvÃ©lina."
            },
            none: {
                machineType: "Enginn rekill var valinn fyrir skammtara."
            },
            santintColorLink3: {
                machineType: "Ã viÃ° um allar Santint-vÃ©lar. AÃ°eins Windows."
            },
            simulation: {
                machineType:
                    "Gildir viÃ° hermingu Ã¡ litblÃ¶ndunarvÃ©l, ef engin raunveruleg litblÃ¶ndunarvÃ©l er tengd viÃ° tÃ¶lvuna.",
                path: "SlÃ³Ã° Ã¡ grunnstillingarskrÃ¡ hermingar, sem verÃ°ur aÃ° stemma viÃ° tilgreindan gagnagrunn."
            },
            udcp: {
                machineType: "UDCP-skammtari"
            }
        },
        environment: {
            activeServerPlugins: "Yfirlit yfir viÃ°bÃ³tarforrit hugbÃºnaÃ°ar.",
            allowAutoCloseTab:
                "Ãegar Ã¾essi stilling er virk lokast hver uppskriftaflipi sjÃ¡lfkrafa Ã¾egar skÃ¶mmtunarferlinu er lokiÃ°.",
            allowAutomaticClientStart:
                "Ãegar Ã¾essi stilling er virk rÃ¦sist %{name} sjÃ¡lfkrafa eftir aÃ° tÃ¶lvan er rÃ¦st.",
            allowAutomaticPrint:
                "MerkimiÃ°inn er prentaÃ°ur sjÃ¡lfkrafa. Krefst viÃ°bÃ³tarstillingar fyrir prentun fyrir litblÃ¶ndun, eftir litblÃ¶ndun eÃ°a hvort tveggja.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "Ã uppskriftarsvÃ¦Ã°inu verÃ°ur viÃ°skiptavinarhlutinn tiltÃ¦kur.",
            allowDispensing:
                "Ã uppskriftarsvÃ¦Ã°inu er litblÃ¶ndunarhnappurinn virkur Ã¡samt stillingum litblÃ¶ndunarvÃ©larinnar Ã­ vÃ©larstillingum.",
            allowFileTransfer:
                "Ãegar Ã¾essi stilling er valin er sjÃ¡lfvirkur Ãºtflutningur og innflutningur gagna meÃ° skrÃ¡aflutningi Ã­ boÃ°i.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "StÃ¶Ã°ustjÃ³rnborÃ° verÃ°ur virkjaÃ° Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu.",
            allowLight: "%{name} verÃ°ur tiltÃ¦kt.",
            allowOrdering: "Ã uppskriftarsvÃ¦Ã°inu er pÃ¶ntunarhnappurinn virkur.",
            allowPricing:
                "Ã uppskriftarsvÃ¦Ã°inu er hÃ¦gt aÃ° nota verÃ°. SÃ½nileiki verÃ°s er birtur Ã­ tiltÃ¦ku verÃ°i. VerÃ° er stillt Ã­ verÃ°stillingum.",
            allowProductPreviewImage: "VÃ¶rumyndin verÃ°ur sÃ½nd Ã¡ meÃ°an litblÃ¶ndun fer fram",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors: "AÃ°gerÃ°in til aÃ° leita aÃ° Ã³dÃ½rari litum er tiltÃ¦k Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu.",
            allowSoundNotification: "Tilkynning um pÃ¶ntun. Ãegar pÃ¶ntun berst er spilaÃ° stutt lag.",
            allowSpectro: "LitrÃ³fsmÃ¦lir",
            allowTabs: "Ãegar Ã¾essi stilling er virk er hÃ¦gt aÃ° vinna meÃ° marga flipa samtÃ­mis.",
            applyZoom: "AÃ°drÃ¡ttur eykur eÃ°a minnkar upplausnina. Einnig mÃ¡ nota flÃ½tilyklana CTRL + og CTRL -.",
            automaticLogout: "Stilltu fjÃ¶lda mÃ­nÃºtna Ã¾ar til sjÃ¡lfvirk ÃºtskrÃ¡ning er virkjuÃ°.",
            availableDatabases:
                "Stillingarnar gera Ã¾Ã©r kleift aÃ° skipta Ã¡ milli gagnagrunna ef fleiri en einn eru tiltÃ¦kir.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "StrikamerkjaprÃ³f er notaÃ° til aÃ° sannreyna skannaÃ°a strikamerkiÃ° meÃ° Ã¾vÃ­ aÃ° bera Ã¾aÃ° saman viÃ° strikamerki sem fyrir eru Ã­ gagnagrunninum.",
            customBanner: "Settu inn Ã¾itt eigiÃ° lÃ³gÃ³ eÃ°a borÃ°a og staÃ°setningu hans.",
            customCurrencyFormat:
                "SÃ©rstillt sniÃ° gjaldmiÃ°ils getur hnekkt sjÃ¡lfgefnu sniÃ°i gjaldmiÃ°ils, eftir vÃ¶ldu tungumÃ¡li. ",
            customDateFormat:
                "SÃ©rstillt sniÃ° dagsetningar getur hnekkt sjÃ¡lfgefnu sniÃ°i dagsetningar, eftir vÃ¶ldu tungumÃ¡li.",
            customNumberFormat: "SÃ©rstillt sniÃ° talna getur hnekkt sjÃ¡lfgefnu sniÃ°i talna, eftir vÃ¶ldu tungumÃ¡li.",
            customTimeFormat: "SÃ©rstillt sniÃ° tÃ­ma getur hnekkt sjÃ¡lfgefnu sniÃ°i tÃ­ma, eftir vÃ¶ldu tungumÃ¡li.",
            defaultPrinter:
                "Valinn prentari er notaÃ°ur viÃ° Ãºtprentun merkimiÃ°a, nema Ã¾essu sÃ© breytt Ã­ glugganum âPrentstillingarâ.",
            defaultTemplate:
                "ValiÃ° sniÃ°mÃ¡t er notaÃ° viÃ° Ãºtprentun merkimiÃ°a, nema Ã¾essu sÃ© breytt Ã­ glugganum âPrentstillingarâ.",
            deleteImportedData:
                "EyÃ°a Ã¡Ã°ur innfluttum sÃ©rsniÃ°num gÃ¶gnum. HÃ¦gt er aÃ° flytja gÃ¶gn inn aftur eftir aÃ° Ã¾eim er eytt.",
            diskSpaceNotification: "Athugar tiltÃ¦kt plÃ¡ss Ã¡ diski og sendir viÃ°vÃ¶run ef plÃ¡ss er of lÃ­tiÃ°.",
            dispensingNotes: "Ã uppskriftarsvÃ¦Ã°inu er hlutinn um athugasemdir um litblÃ¶ndun tiltÃ¦kur.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "Ã %{name} er sÃ½ndarlyklaborÃ°iÃ° tiltÃ¦kt.",
            exportLocalSettings: "Flytur Ãºt staÃ°bundnar stillingar Ã¡ Ã¾essari tÃ¶lvu.",
            exportStaticSql:
                "Flytur Ãºt staÃ°bundnar stillingar Ã¡ Ã¾essari tÃ¶lvu. SkrÃ¡na sem var flutt Ãºt er hÃ¦gt aÃ° nota til aÃ° bÃºa til gagnagrunn meÃ° sÃ¶mu stillingum.",
            exportTranslationKeys:
                "Flyttu Ãºt nÃ½justu Ã¾Ã½Ã°ingarnar og sendu Ã¾Ã¦r Ã­ tÃ¶lvupÃ³sti til sÃ¶luaÃ°ila hugbÃºnaÃ°arins eftir Ã¾Ã½Ã°inguna til aÃ° lÃ¡ta flytja Ã¾Ã¦r inn.",
            favoriteButton: "Smella hÃ©r til aÃ° bÃ¦ta uppskrift viÃ° sem eftirlÃ¦ti",
            formulaNotes: "Ã uppskriftarsvÃ¦Ã°inu er hlutinn fyrir athugasemdir viÃ° uppskriftir tiltÃ¦kur.",
            helpSettings: "UpplÃ½singarnar eru sÃ½nilegar Ã­ hlutanum âHjÃ¡lpâ Ã¡ svÃ¦Ã°inu meÃ° flÃ½tiaÃ°gangi.",
            importCustomData: "Flytja inn staÃ°bundin, sÃ©rsniÃ°in gÃ¶gn sem tengjast vÃ¶ldu sniÃ°i.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Flytur inn staÃ°bundnar stillingar Ã¡ Ã¾essari tÃ¶lvu.",
            internalNote: "Ã stjÃ³rnborÃ°i fyrir formÃºlu verÃ°ur hÃ¦gt aÃ° opna hluta meÃ° athugasemdum Ãºr kerfi.",
            lockComputer:
                "Stillingarnar tryggja aÃ° ekki er hÃ¦gt aÃ° fara Ãºr umhverfi fyrir %{name} â Ã¾annig fÃ¦st heildarupplifun af forritinu Ã¡ Ã¶llum skjÃ¡num. Ã aÃ°eins viÃ° um Windows.",
            maxNumberTabs: "TakmÃ¶rkun flipa tilgreinir hversu marga uppskriftaflipa er hÃ¦gt aÃ° opna samtÃ­mis.",
            memoryTabs: "LeyfÃ°u enduropnun nÃ½lega opnaÃ°ra flipa eftir aÃ° hugbÃºnaÃ°ur er rÃ¦stur.",
            printAfterDispensing:
                "Ãessi stilling krefst upplÃ½singa um hversu mÃ¶rg eintÃ¶k merkimiÃ°a eigi aÃ° prenta Ã¾egar litblÃ¶ndun er lokiÃ°.",
            printAsImage:
                "Prentun sem mynd auÃ°veldar Ãºrlausn vandamÃ¡la Ã¾egar sjÃ¡lfgefin prentun mistekst. Ekki nota Ã¾etta Ã¾egar sjÃ¡lfgefin prentun virkar sem skyldi. AÃ°eins samhÃ¦ft viÃ° Linux.",
            printBeforeDispensing:
                "Ãessi stilling krefst upplÃ½singa um hversu mÃ¶rg eintÃ¶k merkimiÃ°a eigi aÃ° prenta Ã¾egar litblÃ¶ndun er lokiÃ°.",
            printEnabled:
                "Ãessi stilling gerir Ã¾Ã©r kleift aÃ° nota prentarann meÃ° hugbÃºnaÃ°inum. Ãtarlegri stillingar er aÃ° finna Ã­ Prentstillingar.",
            printOnRequest: "Ã uppskriftarsvÃ¦Ã°inu er pÃ¶ntunarhnappurinn virkur.",
            printTaskVariable: "PrentaÃ°gerÃ°in er aÃ°eins framkvÃ¦md ef prentbreytan er tiltÃ¦k Ã­ prentgÃ¶gnum",
            quickTintTemplate: "ValiÃ° sniÃ°mÃ¡t er notaÃ° viÃ° flÃ½tiprentun merkimiÃ°a.",
            restoreLocalSettings: "Endurheimtir staÃ°bundnar stillingar Ã¡ Ã¾essari tÃ¶lvu.",
            runLightAtStartUp: "%{light} Ã­ staÃ° %{name}.",
            screenSaverTimeout: "Stilla tÃ­ma skjÃ¡hvÃ­lu",
            selectCustomDataFormat:
                "Veldu sniÃ°mÃ¡t yfir upprunaleg gÃ¶gn sem skal flytja inn. Fyrir hvert sniÃ° Ã¾arf hugsanlega aÃ° nota mismunandi viÃ°bÃ³tarskrÃ¡r og -stillingar.",
            setCustomHomeButton: "Hnappurinn âHeimâ Ã­ %{name} endurbeinir aÃ° vÃ¶ldu svÃ¦Ã°i.",
            setFts: "MeÃ° leit Ã­ heildartexta er hÃ¦gt aÃ° leita Ã­ heildartexta uppskrifta (einnig Ãºr miÃ°ju orÃ°i o.s.frv.).",
            setKeyboardShortcuts: "ÃaÃ° er ekki hÃ¦gt aÃ° stilla sama flÃ½tilykil fyrir tvÃ¦r mismunandi aÃ°gerÃ°ir.",
            setNumberOfDecimalPlaces:
                "NÃ¡mundun sÃ½nir hversu mÃ¶rgum aukastÃ¶fum litarefniÃ° sem Ã¡ aÃ° nota Ã­ uppskriftinni er sÃ½nt meÃ°.",
            setOrderSearchParameters:
                "Leit Ã­ pÃ¶ntunum tilgreinir fÃ¦ribreyturnar sem Ã¡ aÃ° nota Ã¾egar leitaÃ° er Ã­ pÃ¶ntunum. AÃ°eins tiltÃ¦kt Ã­ %{name}.",
            setOverwriteLastTab:
                "Ãegar Ã¾Ãº velur nÃ½ja uppskrift meÃ° altÃ¦kri leit, Ã¾egar uppskriftaflipanum er nÃ¡Ã°, verÃ°ur skrifaÃ° yfir Ã¾ann uppskriftaflipa Ã­ nÃ½ju, vÃ¶ldu uppskriftinni sem var sÃ­Ã°ast valinn.",
            setSearchPanel:
                "Tilgreindu Ã¾inn eigin sÃ½nileika og rÃ¶Ã° atriÃ°anna sem nota Ã¡ Ã¾egar leitaÃ° er aÃ° nÃ½rri uppskrift.",
            setVisibilityAndOrder:
                "Valin flettingaratriÃ°i eru sÃ½nileg Ã¡ svÃ¦Ã°inu meÃ° flÃ½tiaÃ°gangi. Efsta staÃ°setningin tilgreinir hÃ©r staÃ°setningu vinstra megin Ã¡ svÃ¦Ã°inu. HÃ¡marksfjÃ¶ldi leyfilegra flettingaratriÃ°a er 6.",
            setYourLanguage: "Breytingar Ã¡ tungumÃ¡li krefjast endurrÃ¦singar Ã¡ hugbÃºnaÃ°i.",
            settingsSearch: "Flettu upp mismunandi stillingum ef Ã¾Ãº ert ekki viss um hvar Ã¾Ã¦r er aÃ° finna.",
            showNewOrderNotifications: "PÃ¶ntunarskilaboÃ° eru sprettigluggi sem tilkynnir aÃ° nÃ½ pÃ¶ntun hafi borist.",
            sorting: "HÃ¦gt er aÃ° panta flÃ½tilitblÃ¶ndun Ã­ Ã­lÃ¡tunum eftir nÃ¶fnum litarefna eÃ°a meÃ° auÃ°kennum hylkja.",
            turnOnKioskMode: "Stillt er Ã¡ allan skjÃ¡inn og ferlislÃ­nan er falin.",
            windowClosingRules:
                "Stillingin Ã¡kvarÃ°ar hvort gluggi meÃ° fljÃ³tlegri litblÃ¶ndun lokast fyrir eÃ°a eftir aÃ° litblÃ¶ndunin hefst."
        },
        formulaSettings: {
            additionalFormulaTab: "Stillingin Ã¡kvarÃ°ar hvaÃ°a svÃ¦Ã°i verÃ°ur sÃ½nt Ã¾egar nÃ½r uppskriftarflipi er opnaÃ°ur.",
            allowCustomFormulas: "FramleiÃ°sla og leit eftir sÃ©rsniÃ°num uppskriftum verÃ°ur virk.",
            allowCustomPackageSize: "SÃ©rsniÃ°nar pakkastÃ¦rÃ°ir verÃ°a virkjaÃ°ar Ã¡ uppskriftarsvÃ¦Ã°inu.",
            allowEditingColorants:
                "Ã uppskriftarsvÃ¦Ã°inu verÃ°ur hnappur til aÃ° breyta litblÃ¶ndun gerÃ°ur virkur (sÃ½nilegur eftir val Ã¡ lit).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Stilla stÃ¦rÃ° stofns Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu",
            bippPanelSize: "Stilla stÃ¦rÃ° stofns Ã­ vÃ¶rustÃ¦rÃ° Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "Ã uppskriftarsvÃ¦Ã°inu eru einu sÃ½nilegu upplÃ½singarnar litasÃ½niÃ°.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "ForskoÃ°un lita verÃ°ur tÃ¡knuÃ° meÃ° mynd Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu.",
            colorPreviewResizable: "Leyfir endurstillingu stÃ¦rÃ°ar Ã¡ stjÃ³rnborÃ°i fyrir forskoÃ°un lita.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Ã stjÃ³rnborÃ°i fyrir formÃºlu er hÃ¦gt aÃ° raÃ°a litarefni eftir heiti eÃ°a eftir magni.",
            customCanOption:
                "Veldu mÃ¦lieiningarnar sem mÃ¡ nota til aÃ° sÃ©rstilla pakkastÃ¦rÃ° Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu.",
            customCanSettingsUnit:
                "Veldu mÃ¦lieiningarnar sem mÃ¡ nota sem sjÃ¡lfgefnar til aÃ° sÃ©rstilla pakkastÃ¦rÃ° Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation: "Ef Ã¾essi valkostur er gerÃ°ur virkur mun sprettigluggi staÃ°festa eyÃ°ingu hlutar.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "Stilla stÃ¦rÃ° litaspjalds Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu",
            favoriteFormulasInitial: "Ãegar Ã¾Ãº byrjar Ã¡ %{name} verÃ°ur svÃ¦Ã°i meÃ° eftirlÃ¦ti sÃ½nt.",
            formulaAutomaticNaming:
                "Uppskrift sem er breytt fÃ¦r sjÃ¡lfkrafa heiti sem byggist Ã¡ Ã¾eim breytingum Ã¡ litarefni sem gerÃ°ar hafa veriÃ°.",
            formulaPanel: "Ãegar Ã¾Ãº opnar nÃ½jan flipa birtist uppskriftarsvÃ¦Ã°iÃ°.",
            formulaPanelInitial: "Ãegar Ã¾Ãº byrjar Ã¡ %{name} birtist uppskriftarsvÃ¦Ã°iÃ°.",
            formulaPanelSize: "Stilla stÃ¦rÃ° formÃºlu Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "Ãegar Ã¾essi stilling er valin verÃ°ur forskoÃ°un lita bÃºin til sjÃ¡lfkrafa. ForskoÃ°unin sem birtist er ekki nÃ¡kvÃ¦m.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "Ã uppskriftarsvÃ¦Ã°inu verÃ°ur myndin af vÃ¶runni sÃ½nileg viÃ° hliÃ°ina Ã¡ litasÃ½ninu, og mÃ¶gulegt er aÃ° opna svÃ¦Ã°iÃ° meÃ° frekari upplÃ½singum.",
            images: "Stillingin Ã¡kvarÃ°ar uppruna myndskrÃ¡a.",
            infoPanelResizable: "Leyfir endurstillingu stÃ¦rÃ°ar Ã¡ stjÃ³rnborÃ°i fyrir frekari upplÃ½singar.",
            initialFormulaTab: "Stillingin Ã¡kvarÃ°ar hvaÃ°a svÃ¦Ã°i er sÃ½nt Ã¾egar %{0} byrjar.",
            moreInfo: "Ã uppskriftarsvÃ¦Ã°inu verÃ°ur upplÃ½singasvÃ¦Ã°iÃ° sÃ½nilegt viÃ° hliÃ°ina Ã¡ litasÃ½ni og vÃ¶rumynd.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "Ãessi stilling gerir kleift aÃ° nota vÃ¶runÃºmer meÃ° vÃ¶ruheitum ef upplÃ½singarnar eru til staÃ°ar Ã­ gagnagrunninum.",
            productFiles: "Ãessi stilling Ã¡kvarÃ°ar uppruna vÃ¶ruskjala sem eru tiltÃ¦k Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu.",
            productGroups: "Ãessi stilling heimilar stigveldi innan vÃ¶ruflokka, ef slÃ­kt er tiltÃ¦kt Ã­ gagnagrunninum.",
            productPanelSize: "Stilla stÃ¦rÃ° vÃ¶ru Ã¡ stjÃ³rnborÃ°i fyrir formÃºlu",
            searchNewFormula:
                "Ãegar Ã¾Ãº opnar nÃ½jan flipa birtist âLeita eftir uppskriftâ (inniheldur upplÃ½singar um sÃ­Ã°ustu uppskrift sem var blÃ¶nduÃ° og uppÃ¡halds uppskriftir).",
            searchNewFormulaInitial:
                "Ãegar Ã¾Ãº byrjar Ã¡ %{name} birtist âLeita eftir uppskriftâ (inniheldur upplÃ½singar um sÃ­Ã°ustu uppskrift sem var blÃ¶nduÃ° og uppÃ¡halds uppskriftir).",
            searchPanelFormulaItems: "Velja verÃ°ur minnst eina formÃºlu.",
            searchPanelProductItems: "AÃ°eins er hÃ¦gt aÃ° velja eina vÃ¶ru.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "Ãegar Ã¾essi stilling er virkjuÃ° verÃ°ur aÃ°gerÃ°in viÃ° litaleit meÃ° hermingu Ã¡ litasvÃ¦Ã°i tiltÃ¦k.",
            setFormulaInfoInPreview: "Ã uppskriftarsvÃ¦Ã°inu verÃ°ur valda gagnagerÃ°in alltaf sÃ½nileg Ã­ litasÃ½ninu.",
            setFormulaPreview:
                "Stillingin breytir stÃ¶Ã°u og birtingu litasÃ½nis, pakkamyndar og upplÃ½singagagna um litinn.",
            setFormulaRGBPreviewVisibleInformation:
                "Ã uppskriftarsvÃ¦Ã°inu verÃ°ur valda gagnagerÃ°in alltaf sÃ½nileg Ã­ litasÃ½ninu.",
            setFormulaUnit:
                "Ã uppskriftarsvÃ¦Ã°inu Ã¡kvarÃ°ar Ã¾essi stilling hvaÃ°a litareiningu Ã¡ aÃ° opna fyrst eftir aÃ° Ã¾Ãº hefur valiÃ° lit. Gildir einnig Ã­ fljÃ³tlegri litblÃ¶ndun.",
            setFormulaVisibilityAndOrder:
                "Ã uppskriftarsvÃ¦Ã°inu verÃ°a vÃ¶ldu gÃ¶gnin sÃ½nileg Ã­ hlutanum âFrekari upplÃ½singarâ (gildir aÃ°eins ef uppskriftardÃ¦miÃ° undir uppskriftarstillingu er stillt Ã¡ âMyndâ eÃ°a âFrekari upplÃ½singarâ.)",
            setMaxToleranceForCompetitiveColors: "Stilltu hÃ¡marksfrÃ¡vik Delta E (CIE 2000) viÃ° litaleit meÃ° hermingu.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "Ã uppskriftarsvÃ¦Ã°inu Ã¡kvarÃ°ar Ã¾essi stilling hvaÃ°a litarefni eru sÃ½nileg Ã¾egar Ã¾Ãº hefur valiÃ° lit. Gildir einnig Ã­ fljÃ³tlegri litblÃ¶ndun.",
            showColorPreview:
                "UppskriftarsvÃ¦Ã°iÃ° sÃ½nir litlar litaprufur viÃ° hliÃ°ina Ã¡ heiti litarins Ã¾egar leitaÃ° er eftir nÃ½rri uppskrift.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Samtala fyrir magn litarefnis er undir lÃ¡gmarki.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "LÃ¡gmark fyrir magn sem hÃ¦gt er aÃ° lita meÃ° er minnsta magn litarefnis sem hÃ¦gt er aÃ° skammta, samkvÃ¦mt rÃ¡Ã°leggingum frÃ¡ rannsÃ³knarstofu.",
            checkOverfill:
                "Ãessi stilling kannar hvort Ã¾aÃ° er nÃ¦gilegt plÃ¡ss Ã­ dÃ³sinni fyrir litarefni, strax eftir aÃ° magn er stillt.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "Magn litarefnis er undir magni sem hÃ¦gt er aÃ° lita meÃ°.",
            dispensingWithErrorsEnabled:
                "Ef Ã¾etta er leyft birtist viÃ°vÃ¶run ef sannprÃ³fun stenst ekki, en Ã¾aÃ° verÃ°ur Ã¾rÃ¡tt fyrir Ã¾aÃ° hÃ¦gt aÃ° halda Ã¡fram skÃ¶mmtun.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Samtala fyrir magn litarefnis er yfir hÃ¡marki magns sem hÃ¦gt er aÃ° lita meÃ°.",
            overfill: "Umframmagn greindist.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Ãg Ã¾ekki Ã¡hÃ¦ttuÃ¾Ã¦ttina, halda Ã¡fram"
        },
        help: "HjÃ¡lp",
        helpLink: "HjÃ¡lparmiÃ°stÃ¶Ã°",
        helper: {
            automaticallyCheckForUpdates:
                "ÃaÃ° er sjÃ¡lfkrafa athugaÃ° hvort uppfÃ¦rsla er til staÃ°ar fyrir %{name} eÃ°a gagnagrunn Ã¡ tilgreindu tÃ­mabili.",
            automaticallyDownloadUpdates:
                "Ef uppfÃ¦rsla er fÃ¡anleg verÃ°ur hÃºn sÃ³tt sjÃ¡lfkrafa Ã¡n Ã¾ess aÃ° Ã¾aÃ° Ã¾urfi aÃ° staÃ°festa.",
            automaticallyInstallNewDatabases:
                "Ef fjarverandi DB er sent hingaÃ° er Ã¾aÃ° sett upp sem nÃ½tt DB. Eftir Ã¾aÃ° er hÃ¦gt aÃ° nota DB.",
            automaticallyInstallUpdates:
                "Ef uppfÃ¦rsla er sÃ³tt er hÃºn sett upp sjÃ¡lfkrafa Ã¡n Ã¾ess aÃ° Ã¾aÃ° Ã¾urfi aÃ° staÃ°festa.",
            canBrowseChangeLog: "ViÃ° uppfÃ¦rslu hugbÃºnaÃ°ar verÃ°ur stÃ¶Ã°luÃ° breytingaskrÃ¡ %{name} tiltÃ¦k til skoÃ°unar",
            forceInstall: "UppfÃ¦rslan verÃ°ur Ã¾vinguÃ°.",
            installDuringNight: "UppfÃ¦rsla er sett upp aÃ° nÃ¦turlagi ef tÃ¶lvan er Ã­ gangi."
        },
        licensing: {
            collect:
                "SkrÃ¡ningargÃ¶gnum er hlaÃ°iÃ° niÃ°ur Ã¡ valda staÃ°setningu. SkrÃ¡ningargagna er krafist af sÃ¶luaÃ°ila hugbÃºnaÃ°ar til aÃ° fÃ¡ villugreiningar.",
            company: "FyrirtÃ¦kiÃ° sem veitti leyfiÃ°.",
            computerID: "AuÃ°kenni leyfis til aÃ° aÃ°stoÃ°a sÃ¶luaÃ°ila hugbÃºnaÃ°ar ef veita Ã¾arf hjÃ¡lp.",
            email: "Netfang leyfishafa.",
            licenseUuid: "AuÃ°kenni leyfis til aÃ° aÃ°stoÃ°a sÃ¶luaÃ°ila hugbÃºnaÃ°ar ef veita Ã¾arf hjÃ¡lp.",
            name: "Nafn leyfishafa.",
            openBugreport:
                "LÃ¡ttu okkur vita ef Ã¾aÃ° eru gallar Ã­ hugbÃºnaÃ°inum og sendu okkur skÃ½rslu meÃ° villulÃ½singunni.",
            posInfoContactperson: "UpplÃ½singar sÃ¶luaÃ°ila um eiganda, sem skal prenta Ã¡ merkimiÃ°ann.",
            posInfoMachineInformation:
                "UpplÃ½singar sÃ¶luaÃ°ila um skammtarann, sem skal prenta Ã¡ merkimiÃ°ann eÃ°a auÃ°kenna Ã­ netkerfinu.",
            posInfoPos: "UpplÃ½singar sÃ¶luaÃ°ila um staÃ°inn, sem skal prenta Ã¡ merkimiÃ°ann.",
            reactivation: "Endurvirkjun eÃ°a breyting Ã¡ nÃºgildandi leyfi.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "SkrÃ¡ningarupplÃ½singar til aÃ° auÃ°kenna leyfishafann.",
            registrationMachineInformation:
                "SkrÃ¡ningarupplÃ½singar til aÃ° auÃ°kenna litblÃ¶ndunarvÃ©lina sem tengist leyfishafann.",
            registrationPos: "SkrÃ¡ningarupplÃ½singar til aÃ° auÃ°kenna staÃ°setningu leyfisins.",
            versionScope: "FyrningarmÃ¶rk hugbÃºnaÃ°ar.",
            versionType: "GerÃ° hugbÃºnaÃ°arafurÃ°a."
        },
        machineIsBusy: "Ekki er hÃ¦gt aÃ° nÃºllstilla villur Ã¾ar sem vÃ©lin er upptekin.",
        machineSettings: {
            allowManualColorantAddition:
                "Ef nauÃ°synlegt litarefnismagn fer yfir hÃ¡marksskammtamagniÃ° gerir stillingin Ã¾Ã©r kleift aÃ° bÃ¦ta Ã¾vÃ­ viÃ° handvirkt eftir litblÃ¶ndunina.",
            autotasks:
                "âAutotaskâ eru sjÃ¡lfvirkar aÃ°gerÃ°ir Ã­ viÃ°haldi vÃ©lar og tÃ¶lvu sem hÃ¦gt er aÃ° stilla til aÃ° framkvÃ¦ma Ã¡ tilteknum tÃ­ma eÃ°a tÃ­mabili.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "Strikamerkinu er ÃºthlutaÃ° Ã¡ Ã¾aÃ° hylki Ã¾ar sem litarefniÃ° er tiltÃ¦kt. StrikamerkiÃ° er nauÃ°synlegt til aÃ° tryggja rÃ©tta Ã¡fyllingu litarefnis.",
            checkCanBeforeDispense:
                "Grunnstillingar vÃ©larinnar eru bornar saman viÃ° gagnagrunninn Ã­ hvert skipti sem RCC (Redlike Control Center) er endurrÃ¦st. Ef misrÃ¦mi kemur upp birtist tilkynning.",
            checkOverfill:
                "Stillingin kannar hvort nÃ³g plÃ¡ss er Ã­ dÃ³sinni/fÃ¶tunni fyrir litarefniÃ°, Ã¡Ã°ur en Ã¾aÃ° er afhent.",
            currentlySelectedMachine: "Inniheldur upplÃ½singar um vÃ©lina sem er valin.",
            dispenseInvalidColorants:
                "MeÃ° stillingunni er hÃ¦gt aÃ° skammta litarefni sem ekki eru tilgreind Ã­ stillingum vÃ©larinnar meÃ° Ã¾vÃ­ aÃ° biÃ°ja um handvirka viÃ°bÃ³t viÃ° litarefni.",
            dispenserConfigurationBackup:
                "SÃ¦ktu og vistaÃ°u nÃºverandi stillingar vÃ©larinnar til aÃ° bÃºa til Ã¶ryggisafrit.",
            dispensingLogic:
                "SkÃ¶mmtunarstjÃ³rnunargerÃ°ir geta tryggt mismunandi atferli fyrir hvert hylki Ã¾egar meira er af litarefni sem Ã¡ aÃ° afhenda en leyfilegt er eÃ°a Ã³skaÃ° er eftir. ViÃ°bÃ³taratferli er stillt Ã­ âSkÃ¶mmtunarvalkostirâ.",
            enableTmc: "Ãessi stilling gerir Ã¾Ã©r kleift aÃ° senda gÃ¶gn til TMC.",
            enableUserIdentification: "Notandinn Ã¾arf aÃ° skrÃ¡ sig inn Ã¡Ã°ur en litblÃ¶ndun er leyfÃ°.",
            machineUnit: "Eining Ã­ vÃ©l skilgreinir mÃ¦lieiningu fyrir litarefni Ã­ hylkjunum.",
            minDispensedAmount:
                "LÃ¡gmarksskammtamagn sÃ½nir hve mikiÃ° Ã¾arf aÃ° skammta af litarefni til aÃ° Ã­huga hreinsun (til aÃ° forÃ°ast frekari hreinsun).",
            minimalDispenseAmount:
                "LÃ¡gmarksskammtamagn er minnsta rÃ¡Ã°lagÃ°a magn af litarefni sem hÃ¦gt er aÃ° skammta. Ef fariÃ° er yfir Ã¾essi mÃ¶rk birtast skilaboÃ° (skÃ¶mmtun er enn mÃ¶guleg).",
            missingAutotaskCanisters: "Velja Ã¾arf minnst 1 hylki",
            missingAutotaskChannels: "Velja Ã¾arf minnst 1 rÃ¡s",
            missingAutotaskChannelsValue: "ÃskiliÃ° er aÃ° tilgreina rÃºmtak fyrir allar valdar rÃ¡sir",
            missingAutotaskCleanTime: "ÃskiliÃ° er aÃ° tilgreina hreinsunartÃ­ma",
            missingAutotaskName: "ÃskiliÃ° er aÃ° tilgreina heiti sjÃ¡lfvirku aÃ°gerÃ°arinnar (Autotask)",
            missingAutotaskRecirculation: "ÃskiliÃ° er aÃ° tilgreina tÃ­ma og hraÃ°a hringrÃ¡sarflutnings",
            missingAutotaskStirring: "ÃskiliÃ° er aÃ° tilgreina tÃ­ma og hraÃ°a fyrir hrÃ¦ringu",
            missingAutotaskVolume: "ÃskiliÃ° er aÃ° tilgreina rÃºmtak Ãºthreinsunar",
            placeCanSensor:
                "Stillingin virkjar skynjara fyrir staÃ°setningu dÃ³sa â litblÃ¶ndun hefst ekki nema dÃ³sin/fatan sÃ© rÃ©tt staÃ°sett.",
            placeCanSensorDelay:
                "RÃ¡Ã°lÃ¶gÃ° stilling sem tengist skynjara. Ãetta tryggir aÃ° skÃ¶mmtun hefst aÃ°eins eftir skilgreint tÃ­mabil, Ã¾egar dÃ³sin/fatan er rÃ©tt staÃ°sett.",
            purgeVolume:
                "RÃºmtak Ãºthreinsunar Ã¡kvarÃ°ar hversu mikiÃ° af litarefni Ã¡ aÃ° hreinsa Ãºt Ã¾egar snjallhreinsun er framkvÃ¦md.",
            rccUrl: "RCC (Redlike Control Center) er Ã¡byrgÃ°araÃ°ili samskipta viÃ° litblÃ¶ndunarvÃ©lina.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "Stillingin virkjar skynjara Ã¾egar dÃ³sir eru fjarlÃ¦gÃ°ar â litblÃ¶nduninni telst ekki lokiÃ° fyrr en dÃ³sin hefur veriÃ° fjarlÃ¦gÃ°.",
            removeCanSensorDelay:
                "RÃ¡Ã°lÃ¶gÃ° stilling sem tengist skynjara Ã¾egar dÃ³sir eru fjarlÃ¦gÃ°ar. Ãetta tryggir aÃ° litblÃ¶ndun er ekki lokiÃ° fyrr en eftir skilgreint tÃ­mabil Ã¾egar dÃ³sin hefur veriÃ° fjarlÃ¦gÃ°.",
            skipPlaceCanDialog:
                "Ãegar Ã¾essi stilling er virk bÃ­Ã°ur litblÃ¶ndunarvÃ©lin ekki, Ã¾egar dÃ³s er staÃ°sett, Ã¾ar til Ã½tt er Ã¡ hnappinn heldur byrjar litunarferliÃ° sjÃ¡lfkrafa.",
            skipRemoveCanDialog:
                "Ãegar Ã¾essi stilling er virk bÃ­Ã°ur litblÃ¶ndunarvÃ©lin ekki, Ã¾egar dÃ³s er fjarlÃ¦gÃ°, Ã¾ar til Ã½tt er Ã¡ hnappinn heldur skilgreinir litunarferliÃ° sjÃ¡lfkrafa sem lokiÃ°.",
            smartPurgeType:
                "HreinsunargerÃ°in getur annaÃ°hvort aÃ°eins Ã­hugaÃ° aÃ° skammta eÃ°a skammtaÃ° samhliÃ°a Ã¶Ã°rum hreinsunartilvikum, Ã¾egar sannreynt hefur veriÃ° aÃ° Ã¾Ã¶rf sÃ© fyrir snjallhreinsun.",
            splitFormula:
                "Ef nauÃ°synlegt magn af litarefni fer yfir hÃ¡marksskammtamagn gerir stillingin Ã¾Ã©r kleift aÃ° skammta magn af litarefni, fylla Ã¡ Ã­lÃ¡tiÃ° og halda sÃ­Ã°an Ã¡fram aÃ° skammta afganginn.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Sannreyna verÃ°ur grunninn meÃ° strikamerki Ã¡Ã°ur en litblÃ¶ndun er leyfÃ°. Stillingin tryggir aÃ° notaÃ°ur sÃ© rÃ©ttur grunnur.",
            validateColorantsDuringInit:
                "Grunnstillingar vÃ©larinnar eru bornar saman viÃ° gagnagrunninn Ã­ hvert skipti sem RCC (Redlike Control Center) er endurrÃ¦st. Ef misrÃ¦mi kemur upp birtist tilkynning."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Opnar glugga Ã¾ar sem hÃ¦gt er aÃ° slÃ¡ strikamerkiÃ° inn handvirkt.",
            canisterBarcodes:
                "Opnar glugga Ã¾ar sem sjÃ¡ mÃ¡ strikamerki hylkja og hÃ¦gt er aÃ° stilla strikamerki fyrir hylki.",
            canisterLevel: "Opnar glugga Ã¾ar sem sjÃ¡ mÃ¡ strikamerki hylkja og hÃ¦gt er aÃ° stilla hÃ¦Ã° Ã­ hylki.",
            canisters: "Opnar svÃ¦Ã°i Ã¾ar sem sjÃ¡ mÃ¡ hÃ¦Ã° Ã­ hylki og hÃ¦gt er aÃ° stilla hÃ¦Ã° Ã­ hylki.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° leita eftir nÃ½rri uppskrift Ã­ rafrÃ¦nu litakorti.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Opnar glugga meÃ° yfirliti yfir loknar Ã¡fyllingar hylkja.",
            customFormula: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° bÃºa til nÃ½ja sÃ©rstaka litblÃ¶ndun",
            customers:
                "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° fÃ¡ yfirlit yfir viÃ°skiptavini og hÃ¦gt er aÃ° bÃ¦ta viÃ° / breyta / eyÃ°a viÃ°skiptavinum.",
            dispensingHistory: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° fÃ¡ yfirlit yfir allar litablÃ¶ndur.",
            favorites: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° velja eftirlÃ¦tis uppskrift.",
            help: "Opnar glugga meÃ° upplÃ½singum um Ã¾jÃ³nustu viÃ° viÃ°skiptavini, ef hÃºn er veitt af birgi.",
            hideItems: "Opnar glugga Ã¾ar sem hÃ¦gt er aÃ° merkja vÃ¶rur og litaspjÃ¶ld sem falin.",
            historyOfOrders: "Gildir aÃ°eins fyrir %{name}, opnar svÃ¦Ã°i meÃ° yfirliti yfir pantanir Ã¡ litablÃ¶ndum.",
            machineReset: "Setur af staÃ° nÃºllstillingu litblÃ¶ndunarvÃ©lar.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° fÃ¡ yfirlit yfir sendar pantanir.",
            purge: "Opnar glugga Ã¾ar sem hÃ¦gt er aÃ° stilla Ã¡ hreinsun hylkja.",
            quickTint: "Opnar glugga Ã¾ar sem hÃ¦gt er aÃ° blanda lit handvirkt.",
            searchFormula: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er leita aÃ° nÃ½rri uppskrift.",
            spectro: "Opnar svÃ¦Ã°i Ã¾ar sem hÃ¦gt er aÃ° mÃ¦la meÃ° litrÃ³fsmÃ¦li.",
            stir: "Opnar glugga Ã¾ar sem hÃ¦gt er aÃ° stilla hrÃ¦ringu Ã­ Ã­lÃ¡tinu.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Opnar svÃ¦Ã°i meÃ° yfirliti yfir mÃ³tteknar pantanir."
        },
        noHelpForLicense:
            "Engin hjÃ¡lp er Ã­ boÃ°i fyrir leyfiÃ° Ã¾itt. Biddu sÃ¶luaÃ°ilann Ã¾inn um aÃ° bÃ¦ta Ã¾eim mÃ¶guleika viÃ°.",
        posInfo: {
            sync: "Samstillir gÃ¶gn viÃ° hlutann âSkrÃ¡ningâ"
        },
        poweredByDeso: "Keyrt af %{name}",
        priceSettings: {
            VatPrice: "VSK-gildi fyrir litarefni Ã­ %.",
            VatPriceProduct: "VirÃ°isaukaskattur verÃ°ur sÃ¡ sami fyrir Ã¶ll litarefni. Stillt Ã¡ %.",
            basePurchase: "InnkaupaverÃ° fyrir grunn (Ã¾.m.t. âAÃ°eins grunnurâ).",
            basePurchasePriceProduct: "KaupverÃ° vÃ¶runnar Ã­ tilteknum grunni. GefiÃ° upp Ã­ vÃ¶ldum gjaldmiÃ°li.",
            baseSell:
                "SÃ¶luverÃ° fyrir aÃ°eins grunn (Ã¾.m.t. grunnur og hagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning).",
            baseSellFull: "Sell full price for base.",
            cntName: "Skilgreinir hvaÃ°a litarefni verÃ°iÃ° tengist.",
            cntPurchase: "InnkaupaverÃ° fyrir litarefni (Ã¾.m.t. âAÃ°eins litarefniâ).",
            cntPurchaseByName:
                "InnkaupaverÃ° fyrir litarefni, reiknaÃ° Ãºt stakt fyrir hvert efni (Ã¾.m.t. âAÃ°eins litaefniâ).",
            cntPurchasePricePerLiter:
                "FramleiÃ°sluverÃ° fyrir litarefni Ã¡ lÃ­tra ((Ã¡n hagnaÃ°ar (Ã­ hlutfalli viÃ° sÃ¶lutekjur)â eÃ°a Ã¦skilegs hagnaÃ°arhlutfalls (Ã¡lagning)).",
            cntSell:
                "SÃ¶luverÃ° aÃ°eins fyrir litarefni (Ã¾.m.t. litarefni og hagnaÃ° (framlegÃ°) / Ã³skaÃ° grÃ³Ã°ahlutfall (Ã¡lagning)).",
            cntSellByName:
                "SÃ¶luverÃ° fyrir Ã¶ll notuÃ° litarefni, reiknaÃ° Ãºt hvert fyrir sig (Ã¾.m.t. litarefni og hagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter: "SÃ¶luverÃ° litarefnis Ã¡ lÃ­tra (aÃ°eins litarefni). Stilltu Ã­ vÃ¶ldum gjaldmiÃ°li.",
            cntVat: "VirÃ°isaukaskattur litarefnis gefinn upp Ã­ %.",
            colorants:
                "Almenn verÃ°lagning Ã¡ litarefni er sÃº sama fyrir Ã¶ll litarefni. Ãessi aÃ°gerÃ° hentar sÃ©rlega vel til aÃ° stilla VSK.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "GjaldmiÃ°ilskÃ³Ã°i verÃ°ur aÃ° vera Ã¡ stÃ¶Ã°luÃ°u Ã¾riggja bÃ³kstafa formi, t.d. EUR.",
            currencyNameNew: "Heiti gjaldmiÃ°ils, t.d. evra.",
            currencyRateNew:
                "GengiÃ° gagnvart aÃ°algjaldmiÃ°linum, til dÃ¦mis 25,855 CZK fyrir 1 â¬. VerÃ°inu verÃ°ur aÃ° breyta stÃ¶Ã°ugt til aÃ° uppfÃ¦ra Ã¾aÃ°.",
            currencyRoundingNew:
                "NÃ¡mundun stillir minnsta mÃ¶gulega gildi gjaldmiÃ°ilsins, til dÃ¦mis er nÃ¡mundun fyrir evru 0,01 vegna Ã¾ess aÃ° minnsta mÃ¶gulega gildi er 1 sent.",
            currencySymbolNew: "StaÃ°laÃ° tÃ¡kn fyrir gjaldmiÃ°ilinn, t.d. â¬ fyrir evru.",
            defaultPrice: "VerÃ° litarefnis, gefiÃ° upp Ã­ vÃ¶ldum gagnagrunni (Ã¡n VSK).",
            defaultPriceGroup: "VerÃ° litarefnis Ã­ hverjum verÃ°flokki, gefiÃ° upp Ã­ vÃ¶ldum gagnagrunni (Ã¡n VSK).",
            defaultVatPrice: "VSK fyrir litarefniÃ° tilgreint Ã­ vÃ¶ldum gagnagrunni.",
            discountHeader: "AfslÃ¡tturinn dregur skilgreint gildi frÃ¡ kaupverÃ°i litarefnisins. Tilgreint Ã­ %.",
            discountHeaderProduct: "AfslÃ¡tturinn dregur skilgreint gildi frÃ¡ verÃ°i litarefnisins. Tilgreint Ã­ %.",
            export: "Flyttu Ãºt skrÃ¡ meÃ° verÃ°inu sem nÃº er sett inn. ÃaÃ° er hÃ¦gt aÃ° flytja Ã¾aÃ° inn aftur eftir aÃ° verÃ°i hefur veriÃ° breytt.",
            import: "Flyttu inn rÃ©tt sniÃ°na (Ãºtflutta) skrÃ¡ til aÃ° setja inn eÃ°a breyta verÃ°i.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "Veldu hvaÃ°a verÃ°Ãºtreikning Ã¡ aÃ° nota til aÃ° reikna Ãºt endanlegt verÃ°. FramlegÃ° og Ã¡lagningu er bÃ¦tt viÃ° meÃ°an afslÃ¡tturinn er dreginn frÃ¡ tilgreindu sÃ¶luverÃ°i.",
            marginAll:
                "VerÃ° fyrir hagnaÃ° (Ã­ hlutfalli viÃ° sÃ¶lutekjur)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning) fyrir marga pakka (Ã¾.m.t. Ã­ hlutfalli viÃ° sÃ¶lutekjur/Ã¡lagning).",
            marginHeader: "FramlegÃ° bÃ¦tir skilgreindu gildi viÃ° kaupverÃ° litarefnis. Tilgreint Ã­ %.",
            marginHeaderProduct: "FramlegÃ° bÃ¦tir skilgreindu gildi viÃ° kaupverÃ° litarefnis. Tilgreint Ã­ %.",
            marginPerPkg:
                "VerÃ° fyrir hagnaÃ° (Ã­ hlutfalli viÃ° sÃ¶lutekjur)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning) fyrir einn pakka (Ã¾.m.t. Ã­ hlutfalli viÃ° sÃ¶lutekjur/Ã¡lagning).",
            markupHeader: "Ãlagning bÃ¦tir skilgreindu gildi viÃ° kaupverÃ° litarefnis. Tilgreint Ã­ %.",
            markupHeaderProduct: "Ãlagning bÃ¦tir skilgreindu gildi viÃ° kaupverÃ° eÃ°a vÃ¶ru. Tilgreint Ã­ %.",
            packagePricing: "ViÃ°bÃ³tarÃ¡lag er gefiÃ° upp fyrir hverja pakkastÃ¦rÃ° fyrir sig.",
            packageSurcharge: "Almennt pakkaverÃ° er hiÃ° sama fyrir hverja pakkaÃ¡lagningu.",
            priceDefinition: "Stillingin skilgreinir hvaÃ°a gerÃ°ir verÃ°s Ã¡ aÃ° nota viÃ° Ãºtreikning Ã¡ endanlegu verÃ°i.",
            priceGroupNumber:
                "Stillingin skilgreinir hve margir verÃ°flokkar verÃ°a notaÃ°ir. GildissviÃ° fyrir staka verÃ°flokka er hÃ¦gt aÃ° stilla Ã­ âSjÃ¡lfgefin gildiâ.",
            priceGroupPricePerLiter: "VerÃ° Ã¡ litarefni, sem er notaÃ° til aÃ° reikna Ãºt verÃ°flokkaverÃ°iÃ°.",
            priceGroups:
                "VerÃ°hÃ³par sÃ½na nÃºmer viÃ°komandi verÃ°hÃ³ps (mÃ¶rkin eru tilgreind Ã­ gagnagrunninum eÃ°a Ã­ almennri verÃ°lagningu).",
            priceGroupsEnabled:
                "Stillingin gerir Ã¾Ã©r kleift aÃ° vinna meÃ° verÃ°flokka. Tilgreindu gildissviÃ°iÃ° Ã­ âSjÃ¡lfgefin gildiâ og stÃ¶k verÃ° Ã­ âVerÃ°lagning litarefnisâ.",
            priceGroupsGeneric:
                "VerÃ°hÃ³par eru verÃ°bil fyrir fullgerÃ°a mÃ¡lningu, Ã¡ grundvelli litarefnisins Ã­ uppskriftinni.",
            productBasePackageSellPrice: "SÃ¶luverÃ° fyrir pakka Ã­ tilgreindum stofni. Stilltu Ã­ vÃ¶ldum gjaldmiÃ°li.",
            productBaseSellPrice:
                "SÃ¶luverÃ° fyrir stofn reiknaÃ° Ãºt Ã¡ lÃ­tra (aÃ°eins stofn). Stilltu Ã­ vÃ¶ldum gjaldmiÃ°li.",
            productBaseVat: "VirÃ°isaukaskattsgildi fyrir tiltekinn pakka er gefiÃ° upp Ã­ %.",
            productName: "Skilgreinir hvaÃ°a grunn hvaÃ°a vÃ¶ru verÃ°iÃ° tengist.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "KaupverÃ°iÃ° fyrir alla pakka er notaÃ° Ã¾egar afgreiddir eru sÃ©rsniÃ°nir pakkar.",
            productSize: "Skilgreinir hvaÃ°a pakka af tilgreindum grunni og vÃ¶ru verÃ°iÃ° tengist.",
            productVat: "VirÃ°isaukaskattur fyrir Ã¾ennan vÃ¶rugrunn gefinn upp Ã­ %.",
            products:
                "Almennt vÃ¶ruverÃ° er Ã¾aÃ° sama fyrir hverja vÃ¶ru. Ãessi aÃ°gerÃ° hentar sÃ©rlega vel til aÃ° stilla VSK.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "SÃ¶luverÃ° fyrir marga pakka (Ã¾.m.t. grunnur, litarefni, Ã¡lagning og hagnaÃ°ur (Ã¡lagning)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)).",
            sellPricePerKg:
                "SÃ¶luverÃ° fyrir vÃ¶runa Ã¡ hvert kÃ­lÃ³ (Ã¾.m.t. grunnur, litarefni, Ã¡lagning og hagnaÃ°ur (Ã¡lagning)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)).",
            sellPricePerL:
                "SÃ¶luverÃ° fyrir vÃ¶runa Ã¡ hvern lÃ­tra (Ã¾.m.t. grunnur, litarefni, Ã¡lagning og hagnaÃ°ur (Ã¡lagning)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)).",
            sellPricePerPkg:
                "SÃ¶luverÃ° fyrir einn pakka (Ã¾.m.t. grunnur, litarefni, Ã¡lagning og hagnaÃ°ur (Ã¡lagning)/Ã¦skilegt hagnaÃ°arhlutfall (Ã¡lagning)).",
            setPriceTypesVisibilityAndOrder:
                "Ã formÃºlusvÃ¦Ã°inu verÃ°ur valiÃ° verÃ° sÃ½nilegt Ã­ hlutanum fyrir verÃ°. HÃ¦sta staÃ°an hÃ©r skilgreinir stÃ¶Ã°una lengst til vinstri Ã¡ hlutanum.",
            surchargeAll: "VerÃ° Ã¡ viÃ°bÃ³targjaldi fyrir nokkra pakka (Ã¾.m.t. Ã¡lagning).",
            surchargePerPkg: "VerÃ° Ã¡ viÃ°bÃ³targjaldi fyrir einn pakka (Ã¾.m.t. Ã¡lagning).",
            tintPurchaseAll:
                "KaupverÃ° fyrir allt litblÃ¶ndunarferliÃ° fyrir marga pakka (Ã¾.m.t. litarefni og Ã¡lagningu).",
            tintPurchasePerPkg:
                "KaupverÃ° fyrir allt litblÃ¶ndunarferliÃ° fyrir einn pakka (Ã¾.m.t. litarefni og Ã¡lagningu).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll:
                "KaupverÃ° vÃ¶ru samtals fyrir allt litblÃ¶ndunarferliÃ° fyrir marga pakka (Ã¾.m.t. litarefni og Ã¡lagningu).",
            totalPurchasePerKg:
                "KaupverÃ° vÃ¶ru samtals fyrir allt litblÃ¶ndunarferliÃ° Ã¡ hvert kÃ­lÃ³ (Ã¾.m.t. litarefni og Ã¡lagningu).",
            totalPurchasePerL:
                "KaupverÃ° vÃ¶ru samtals fyrir allt litblÃ¶ndunarferliÃ° Ã¡ hvern lÃ­tra (Ã¾.m.t. litarefni og Ã¡lagningu).",
            totalPurchasePerPkg:
                "KaupverÃ° vÃ¶ru samtals fyrir allt litblÃ¶ndunarferliÃ° fyrir einn pakka (Ã¾.m.t. litarefni og Ã¡lagningu).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat:
                "Ã uppskriftarspjaldinu verÃ°ur verÃ°iÃ° sÃ½nilegt Ã­ bÃ¡Ã°um afbrigÃ°um, meÃ° og Ã¡n VSK, samtÃ­mis.",
            withVat: "Ã uppskriftarsvÃ¦Ã°inu er allt verÃ° aÃ°eins sÃ½nilegt aÃ° meÃ°tÃ¶ldum VSK.",
            withoutVat: "Ã uppskriftarsvÃ¦Ã°inu er allt verÃ° aÃ°eins sÃ½nilegt aÃ° frÃ¡tÃ¶ldum VSK."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Samstillir gÃ¶gn viÃ° hlutann âPOS-upplÃ½singarâ"
        },
        searchingPleaseWait: "BÃ­ddu andartak, Ã¾aÃ° er veriÃ° aÃ° velja mestu samsvÃ¶runina viÃ°",
        setupSteps: {
            customData: "SÃ©rsniÃ°in gÃ¶gn",
            machineType: "GerÃ° vÃ©larinnar",
            userPreferences: "KjÃ¶rstillingar notanda "
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "Ãegar nota Ã¡ notandatengd gildi eru mÃ¦ldar niÃ°urstÃ¶Ã°ur reiknaÃ°ar Ãºt aftur til aÃ° fjarlÃ¦gja sÃ­uÃ¡hrifin. LeyfÃ°u Ã¾essa stillingu fyrir altÃ¦ka litrÃ³fsmÃ¦lingu.",
            XRiteModelRM400: "Ekki Ã¾arf aÃ° nota neina rekla.",
            datacolorDiagnosticTile: "Gagnalitur notar greiningarflÃ­sar",
            datacolorSilent: "Gagnalitur hljÃ³Ã°ur",
            measureModes: "Velja studd gljÃ¡stig.",
            model: "GerÃ°",
            simulationPath: "HermingarslÃ³Ã°",
            spectroType: "GerÃ° litrÃ³fsmÃ¦lis",
            spectroTypeCom:
                "Setja Ã¾arf upp staÃ°laÃ°an rekil fyrir litrÃ³fsmÃ¦li. GÃ¦ttu aÃ° COM-tenginu sem notaÃ° er. Windows og Linux.",
            spectroTypeDataColorReader:
                "TÃ¶lvan verÃ°ur aÃ° hafa Bluetooth-tengingu. LitrÃ³fsmÃ¦lirinn verÃ°ur aÃ° vera paraÃ°ur viÃ° tÃ¶lvuna. Windows 10 meÃ° haustuppfÃ¦rslu 2018 er krafist.",
            spectroTypeMinolta2XXXd:
                "Setja Ã¾arf upp staÃ°laÃ°an rekil fyrir litrÃ³fsmÃ¦li. GÃ¦ttu aÃ° COM-tenginu sem notaÃ° er. Windows og Linux.",
            spectroTypeNotSelected: "Veldu gerÃ° litrÃ³fsmÃ¦lis.",
            spectroTypeRM400: "Ekki Ã¾arf aÃ° nota neina rekla.",
            spectroTypeSimulation:
                "RannsÃ³knastofugildi sem eru Ã¡skilin til aÃ° nÃ¡ fram herminiÃ°urstÃ¶Ã°um. Windows og Linux.",
            spectroTypeXRite: "AÃ°eins Ã­ Windows."
        },
        ufiCode: {
            baseUfiCodeValidation: "Sannreyna verÃ°ur UFI-kÃ³Ã°a grunndÃ³sar meÃ° strikamerki Ã¡Ã°ur en skÃ¶mmtun er leyfÃ°.",
            enableUfiCodes:
                "UFI-kÃ³Ã°ar eru notaÃ°ir Ã­ ESB og veita upplÃ½singar um hversu skaÃ°leg tiltekin vara er umhverfinu.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Ef litarefni Ã­ formÃºlu fer yfir tilgreind mÃ¶rk verÃ°ur UFI-kÃ³Ã°i hennar prentaÃ°ur Ã¡ prentaÃ°a merkiÃ°.",
            printUfiCodePercentage:
                "Ef litarefni Ã­ formÃºlu fer yfir tilgreind mÃ¶rk verÃ°ur UFI-kÃ³Ã°i hennar prentaÃ°ur Ã¡ prentaÃ°a merkiÃ°, Ã¡samt upplÃ½singum um hlutfall.",
            ufiCodesByPercentage:
                "RÃ¡Ã°andi UFI-kÃ³Ã°inn er notaÃ°ur viÃ° prentun meÃ° hliÃ°sjÃ³n af raunmagni Ã­ dÃ³sinni. FarÃ°u Ã­ âStillingar fyrir dÃ³sirâ til aÃ° skilgreina mÃ¶rk fyrir hverja dÃ³s.",
            ufiCodesFromDatabase:
                "UFI-kÃ³Ã°inn Ãºr aÃ°algagnagrunninum sem stjÃ³rnandi gagnagrunnsins tilgreindi er notaÃ°ur viÃ° prentun.",
            ufiCodesFromLastFilling:
                "UFI-kÃ³Ã°inn frÃ¡ sÃ­Ã°ustu endurÃ¡fyllingu sem stjÃ³rnandi tilgreindi er notaÃ°ur viÃ° prentun, Ã³hÃ¡Ã° Ã¾vÃ­ magni sem er fyllt Ã¡."
        },
        userManagement: {
            add: "Stillingin bÃ¦tir viÃ° nÃ½jum notanda sem getur skrÃ¡Ã° sig inn Ã­ hugbÃºnaÃ°inn. Notandinn getur fengiÃ° ÃºthlutaÃ° strikamerki og hÃ¦gt er aÃ° stilla hann til aÃ° skrÃ¡ sig inn sjÃ¡lfkrafa eftir aÃ° hugbÃºnaÃ°urinn er rÃ¦stur.",
            assignedGroups:
                "Ãetta tilgreinir hvaÃ°a notendahÃ³pum notandinn tilheyrir. Mismunandi notendahÃ³par fela Ã­ sÃ©r mismunandi rÃ©ttindi.",
            availableGroups:
                "Ãetta skilgreinir hvaÃ°a notendahÃ³par eru tiltÃ¦kir fyrir notandann. Mismunandi notendahÃ³par fela Ã­ sÃ©r mismunandi rÃ©ttindi.",
            loggedUserDelete: "Ekki er hÃ¦gt aÃ° eyÃ°a Ã¾eim notanda sem er skrÃ¡Ã°ur inn."
        },
        visit: "EÃ°a fara Ã¡",
        visitNoLicense: "Til aÃ° fÃ¡ frekari upplÃ½singar skaltu fara Ã¡"
    },
    helpSettings: {
        customHelpLink: "Tengill Ã¡ Ã¾jÃ³nustuver viÃ°skiptavinar",
        helpSettings: "HjÃ¡lparstillingar",
        message: "SkilaboÃ°"
    },
    helper: {
        automaticallyCheckForUpdates: "Leita sjÃ¡lfkrafa aÃ° uppfÃ¦rslum",
        automaticallyDownloadUpdates: "SÃ¦kja uppfÃ¦rslur sjÃ¡lfkrafa",
        automaticallyInstallNewDatabases: "Setja nÃ½ja gagnagrunna upp sjÃ¡lfkrafa",
        automaticallyInstallUpdates: "Setja uppfÃ¦rslur upp sjÃ¡lfkrafa",
        bugReport: "VilluskÃ½rsla fyrir hugbÃºnaÃ°",
        canBrowseChangeLog: "SÃ½na %{name} breytingaskrÃ¡ Ã¡ netinu",
        collect: "Safna saman",
        collectLogFiles: "Safna saman skrÃ¡ningargÃ¶gnum",
        component: "Ãhlutur",
        content: "Innihald",
        contentSize: "StÃ¦rÃ° innihalds",
        download: "SÃ¦kja",
        downloadLogFiles: "SÃ¦kja skrÃ¡ningargÃ¶gn",
        downloadingData: "SÃ¦kir gÃ¶gn",
        everyHours: "Ã %{interval} klukkustunda fresti",
        forceInstall: "Ãvinga uppfÃ¦rslu",
        installDuringNight: "AÃ° nÃ¦turlagi (23:00â05:00)",
        newVersion: "NÃ½ ÃºtgÃ¡fa",
        notConnected: "HjÃ¡lp er ekki tengd",
        openBugReport: "Opna villuskÃ½rslu",
        packageSize: "StÃ¦rÃ° pakka",
        pleaseWait: "Ãetta gÃ¦ti tekiÃ° dÃ¡lÃ­tinn tÃ­ma, bÃ­ddu andartak.",
        send: "Senda",
        sendBugReportToCustomerService: "Senda villuskÃ½rslu",
        sendingReport: "Sendir",
        subject: "Efni"
    },
    helperDialog: {
        1: "ÃÃº getur athugaÃ° hvort uppfÃ¦rslur Ã¡ hugbÃºnaÃ°i eÃ°a gagnagrunni eru Ã­ boÃ°i.",
        2: "Ã aÃ° halda Ã¡fram aÃ° sÃ¦kja uppfÃ¦rslupakkana?",
        3: "Ã aÃ° halda Ã¡fram aÃ° setja upp uppfÃ¦rslupakkana sem voru sÃ³ttir?",
        10: "Leitar aÃ° uppfÃ¦rslum Ã¡ hugbÃºnaÃ°i og gagnagrunni, bÃ­ddu andartak ...",
        11: "Ein uppfÃ¦rsla er Ã­ boÃ°i fyrir tÃ¶lvuna Ã¾Ã­na. Ã aÃ° sÃ¦kja uppfÃ¦rsluna?",
        12: "Engar uppfÃ¦rslur eru Ã­ boÃ°i fyrir tÃ¶lvuna Ã¾Ã­na.",
        14: "Villa kom upp viÃ° leit aÃ° uppfÃ¦rslum. %{0}",
        15: "Samstillir svÃ¦Ã°i gagnagrunna, bÃ­ddu andartak ...",
        20: "SÃ¦kir uppfÃ¦rslupakka, bÃ­ddu andartak ...",
        21: "VeriÃ° er aÃ° sannreyna uppfÃ¦rslupakkann sem var sÃ³ttur. BÃ­ddu andartak ...",
        22: "Ekki tÃ³kst aÃ° sÃ¦kja uppfÃ¦rslupakkann. Viltu reyna aftur?",
        23: "Ekki tÃ³kst aÃ° sÃ¦kja uppfÃ¦rslupakkann (skrÃ¡in er Ã¡ rÃ¶ngu sniÃ°i), viltu reyna aftur?",
        24: "Ã aÃ° halda Ã¡fram aÃ° setja upp uppfÃ¦rsluna?",
        25: "Uppsetning Ã¡ sjÃ¡lfvirkri uppfÃ¦rslu hefst eftir %{0}",
        26: "Ein uppfÃ¦rsla er Ã­ boÃ°i fyrir tÃ¶lvuna Ã¾Ã­na. Ã aÃ° sÃ¦kja uppfÃ¦rsluna?",
        27: "Ã aÃ° halda Ã¡fram aÃ° setja upp uppfÃ¦rsluna?",
        40: "StÃ¶Ã°var forrit og Ã¾jÃ³nustu, bÃ­ddu andartak ...",
        41: "Afritar nÃ½jar skrÃ¡r, bÃ­ddu andartak ...",
        42: "RÃ¦sir forrit og Ã¾jÃ³nustu, bÃ­ddu andartak ...",
        43: "LjÃºka viÃ° uppfÃ¦rslu hugbÃºnaÃ°ar, bÃ­ddu andartak ...",
        44: "HugbÃºnaÃ°urinn Ã¾inn var uppfÃ¦rÃ°ur.",
        45: "Ã aÃ° reyna aftur aÃ° setja upp? Ef Ã¾Ãº Ã¡kveÃ°ur aÃ° reyna aftur skaltu ganga Ãºr skugga um aÃ° engir hugbÃºnaÃ°arÃ­hlutir sÃ©u Ã­ notkun eins og er.",
        46: "Til aÃ° breytingarnar taki gildi Ã¾arf aÃ° endurrÃ¦sa tÃ¶lvuna, endurrÃ¦sing er gerÃ° Ã­ %{0}",
        999: "Innri villa kom upp: %{0}",
        automaticInstallation: "Uppsetning sjÃ¡lfvirkrar uppfÃ¦rslu",
        btnAbort: "HÃ¦tta",
        btnCancel: "Ãgilda",
        btnCheckUpdate: "Leita aÃ° uppfÃ¦rslum",
        btnContinue: "Halda Ã¡fram",
        btnDownloadUpdate: "SÃ¦kja uppfÃ¦rslu",
        btnInstallUpdate: "Setja upp uppfÃ¦rslu",
        btnOk: "Ã lagi",
        btnRetry: "Reyna aftur",
        btnSkip: "Hlaupa yfir",
        checkingForUpdates: "Kanna uppfÃ¦rslur",
        downloadingFailed: "NiÃ°urhal mistÃ³kst",
        downloadingPackage: "SÃ¦kir uppfÃ¦rÃ°an pakka, bÃ­ddu andartak",
        finishingUpdate: "UppfÃ¦rslunni er lokiÃ°",
        installingUpdate: "Setja upp uppfÃ¦rslu",
        internalError: "Innri villa",
        rebootRequired: "EndurrÃ¦singar er Ã¾Ã¶rf",
        startingComponents: "RÃ¦sa hugbÃºnaÃ°arÃ­hluti",
        stoppingComponents: "SlÃ¶kkva Ã¡ hugbÃºnaÃ°arÃ­hlutum",
        synchronizingDatabases: "Samstilling gagnagrunna",
        updateAvailable: "UppfÃ¦rsla er Ã­ boÃ°i, veldu Ã­hluti sem Ã¡ aÃ° uppfÃ¦ra",
        updateDownloaded: "UppfÃ¦rslan var sÃ³tt",
        updateFailed: "UppfÃ¦rsluferliÃ° mistÃ³kst",
        updateInstalled: "UppfÃ¦rslan var sett upp",
        verificationFailed: "Ekki tÃ³kst aÃ° sannreyna uppfÃ¦rslupakkann",
        verifyingPackage: "Sannreynir sÃ³ttan pakka",
        yourSoftwareIsUpToDate: "HugbÃºnaÃ°urinn Ã¾inn var uppfÃ¦rÃ°ur",
        yourSoftwareVersion: "HugbÃºnaÃ°arÃºtgÃ¡fan Ã¾Ã­n: %{0}"
    },
    importData: {
        abortImportingData: "StÃ¶Ã°va innflutning",
        aborted: "Innflutningur var stÃ¶Ã°vaÃ°ur",
        backupLocalDB: "Backup local database",
        confirmRestore: "Ã Ã¶rugglega aÃ° endurheimta allar staÃ°bundnar stillingar?",
        dataMissing: "Innflutningur tÃ³kst ekki Ã¾ar sem upprunaskrÃ¡in innihÃ©lt engin gÃ¶gn.",
        deleteImportedData: "EyÃ°a innflutningsgÃ¶gnum",
        encodingFile: "SkrÃ¡arkÃ³Ã°un",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Innflutningur mistÃ³kst Ã¾ar sem upprunaskrÃ¡in virÃ°ist vera skemmd.",
        fileMissing: "Innflutningur mistÃ³kst Ã¾ar sem upprunaskrÃ¡in er ekki til.",
        format: "SniÃ°",
        formatPath: "SlÃ³Ã° Ã¡ sniÃ°",
        headerMissing: "Innflutningur mistÃ³kst Ã¾ar sem fyrirsÃ¶gn skrÃ¡ar vantar.",
        import: "Flytja inn",
        importAborted: "Innflutningur stÃ¶Ã°vaÃ°ur",
        importAborting: "Innflutningur er stÃ¶Ã°vaÃ°ur",
        importFailed: "Innflutningur mistÃ³kst vegna Ã³vÃ¦ntrar villu",
        importLocalSettings: "Import Local Settings",
        importPrices: "Flytja inn verÃ°",
        imported: "ÃaÃ° tÃ³kst aÃ° flytja inn",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Flytur inn",
        noFormatAvailable: "Ekkert sniÃ° tiltÃ¦kt",
        processing: "Vinnur Ãºr",
        processingCustomFormulas: "Vinnur meÃ° sÃ©rblÃ¶ndun lita",
        processingCustomers: "Vinnur meÃ° viÃ°skiptavini",
        productsFile: "VÃ¶ruskrÃ¡",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Innflutningur er Ã­ gangi",
        unknownFormat: "Innflutningur mistÃ³kst vegna Ã¾ess aÃ° upprunaskrÃ¡in er Ã¡ Ã³Ã¾ekktu sniÃ°i",
        userFormulasFile: "Nota uppskriftaskrÃ¡r"
    },
    infoType: {
        baseDensity: "RÃºmÃ¾yngd grunns",
        baseMass: "Massi grunns",
        baseUfiCode: "UFI-kÃ³Ã°i grunns",
        baseVolume: "RÃºmtak grunns",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS-stig",
        colorLab: "RannsÃ³knarstofugÃ¶gn um lit",
        colorRgb: "RGB lita",
        colorRgbHex: "RGB Hex lita",
        colorXyz: "XYZ lita",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Massi litarefnis",
        colorantUfiCodes: "UFI-kÃ³Ã°ar litarefna",
        colorantVolume: "RÃºmtak litarefnis",
        formulaDate: "Dagsetning formÃºlu",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Frekari upplÃ½singar um formÃºlu",
        formulaMoreInfoInternal: "Frekari upplÃ½singar um formÃºlu Ãºr kerfi",
        formulaMoreInfoPrint: "Frekari upplÃ½singar um formÃºlu Ã¡ prenti",
        hbw: "HBW",
        isPackageGravimetric: "Er pakkinn Ã¾yngdarmÃ¦ldur",
        maxColorantMass: "Mesti leyfÃ°i litarefnismassi",
        maxColorantVolume: "Mesta leyfÃ°a litarefnisrÃºmtak",
        nominalMass: "Nafnmassi pakkans",
        nominalVolume: "NafnrÃºmtak pakkans",
        overfillDetected: "YfirÃ¡fylling greind",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Heildarmassi mÃ¡lningar",
        totalPaintVolume: "HeildarrÃºmtak mÃ¡lningar",
        ufiCodesTable: "Tafla yfir UFI-kÃ³Ã°a",
        verifiedFormula: "StaÃ°fest formÃºla",
        yValue: "Y-gildi"
    },
    initialTab: {
        favoriteFormulas: "EftirlÃ¦tisuppskriftir",
        lastDispensedFormulas: "SÃ­Ã°asta litablandaÃ°a uppskrift",
        searchNewFormula: "Leita eftir kvittun"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "aÃ°gerÃ°",
        add: "bÃ¦ta viÃ°",
        addition: "viÃ°bÃ³t",
        additional: "Ã­tarlegri",
        address: "heimilisfang",
        admin: "kerfisstjÃ³ri",
        advanced: "Ãtarlegt",
        after: "eftir",
        afterDispensing: "eftir skÃ¶mmtun",
        alfa: "Alfa",
        all: "allt",
        allow: "leyfa",
        alphabetically: "stafrÃ³fsrÃ¶Ã°",
        amount: "magn",
        api: "API",
        ask: "spyrja",
        autocap: "sjÃ¡lfvirk lokun",
        autotask: "sjÃ¡lfvirk aÃ°gerÃ°",
        availablePrice: "verÃ° Ã­ boÃ°i",
        backup: "Ã¶ryggisafrit",
        banner: "borÃ°i",
        barcode: "strikamerki",
        barcodes: "strikamerki",
        base: "grunnur",
        before: "fyrir",
        begin: "byrja",
        bfs: "BFS",
        bottom: "neÃ°st",
        brand: "merki",
        brush: "bursti",
        bug: "villa",
        button: "hnappur",
        buy: "kaupa",
        cC3: "CC3",
        cM: "CM",
        calibration: "kvÃ¶rÃ°un",
        can: "fata",
        canHandling: "meÃ°hÃ¶ndlun fÃ¶tu",
        canister: "hylki",
        canisterFilling: "Ã¡fylling hylkis",
        canisterLevels: "hÃ¦Ã° Ã­ hylkjum",
        canisters: "hylki",
        cap: "lok",
        center: "MiÃ°lÃ¦gt",
        centre: "MiÃ°lÃ¦gt",
        change: "breyting",
        changelog: "BreytingaskrÃ¡",
        channels: "rÃ¡sir",
        check: "athuga",
        chunk: "hluti",
        chunks: "hlutar",
        city: "bÃ¦r/borg",
        clean: "hreinn",
        cleaning: "Ã¾rif",
        clientIdentifier: "auÃ°kenni viÃ°skiptavinar",
        close: "nÃ¦rri",
        closest: "nÃ¦stur",
        code: "kÃ³Ã°i",
        collect: "safna saman",
        color: "litur",
        colorLink3: "ColorLink3",
        colorPanel: "Litaval",
        colorReader: "ColorReader",
        colorant: "litarefni",
        colorantConsumption: "notkun Ã¡ litarefni",
        colorantPrice: "verÃ° litarefnis",
        colorants: "litarefni",
        colorix: "Colorix",
        colour: "litur",
        communication: "samskipti",
        compare: "bera saman",
        competitive: "samkeppnishÃ¦fir",
        computer: "tÃ¶lva",
        config: "grunnstillir",
        configuration: "grunnstilling",
        confirm: "staÃ°festa",
        confirmation: "staÃ°festing",
        connection: "tengingar",
        contactPerson: "tengiliÃ°ur",
        control: "Eftirlit",
        copies: "afrit",
        corob: "Corob",
        cost: "kostnaÃ°ur",
        country: "land",
        create: "bÃºa til",
        currency: "gjaldmiÃ°ill",
        current: "nÃºverandi",
        custom: "SÃ©rsmÃ­Ã°aÃ°",
        customers: "viÃ°skiptavinir",
        daily: "daglega",
        dark: "Dark",
        data: "gÃ¶gn",
        database: "gagnagrunnur",
        datacolor: "Datacolor",
        date: "dagsetning",
        decimals: "aukastafir",
        default: "sjÃ¡lfgefinn",
        delay: "seinkun",
        delete: "eyÃ°a",
        deletion: "eyÃ°ing",
        deltaE: "delta e",
        device: "tÃ¦ki",
        devices: "tÃ¦ki",
        diagnosticTile: "greiningarreitur",
        dialog: "samtal",
        direct: "beinn",
        disconnect: "hÃ¦tta",
        discount: "afslÃ¡ttur",
        dispense: "skammta",
        dispenser: "litblÃ¶ndunarvÃ©l",
        dispensing: "skÃ¶mmtun",
        down: "niÃ°ur",
        download: "sÃ¦kja",
        driver: "rekill",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "breyta",
        editor: "breytingaraÃ°ili",
        email: "Netfang",
        error: "villa",
        evoDriver: "EvoDriver",
        evoService: "ÃjÃ³nusta",
        excel: "Excel",
        expiration: "gildistÃ­mi",
        export: "flytja Ãºt",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "litakort",
        fastFluid: "Fast & Fluid",
        file: "skrÃ¡",
        fill: "fylla",
        fillToMax: "fylla aÃ° hÃ¡m.",
        find: "finna",
        first: "fyrsti",
        flex: "Flex",
        folder: "mappa",
        formula: "uppskrift",
        formulas: "uppskriftir",
        from: "frÃ¡",
        fts5: "FTS5",
        fullScreen: "allur skjÃ¡rinn",
        fullText: "heildartexti",
        fulltext: "heildartexti",
        g: "g",
        genericPricing: "almenn verÃ°lagning",
        hLD: "HLD",
        hard: "hart",
        hbw: "hbw",
        help: "hjÃ¡lp",
        helpCenter: "hjÃ¡lparmiÃ°stÃ¶Ã°",
        hero: "Hero",
        history: "ferill",
        home: "heim",
        host: "hÃ½sill",
        humidifier: "rakatÃ¦ki",
        iDD: "IDD",
        identification: "auÃ°kenning",
        image: "mynd",
        impGallon: "gallon",
        impQuart: "kvartgallon",
        import: "flytur inn",
        individually: "aÃ°greint",
        info: "upplÃ½singar",
        information: "upplÃ½singar",
        initial: "frumgildi",
        initialization: "frumstilling",
        initialize: "frumstilla",
        insert: "setja inn",
        install: "Setja upp",
        intellyPurge: "snjallhreinsun",
        invalid: "Ã³gildur",
        ipAddress: "IP-tala",
        italtinto: "Italtinto",
        items: "hlutir",
        keyboard: "lyklaborÃ°",
        kg: "Kg",
        kiosk: "allur skjÃ¡rinn",
        kioskMode: "allur skjÃ¡rinn valinn",
        l: "L",
        lLD: "LLD",
        lab: "Lab",
        label: "merkimiÃ°i",
        labels: "merkimiÃ°i",
        language: "tungumÃ¡l",
        largo: "Largo",
        last: "sÃ­Ã°asti",
        lenteq: "Lenteq",
        levels: "stig",
        license: "leyfi",
        light: "ljÃ³s",
        limit: "mÃ¶rk",
        link: "tengill",
        linux: "Linux",
        load: "lesa af",
        lock: "lÃ¡s",
        logFiles: "kladdaskrÃ¡r",
        logic: "forsendur",
        logo: "lÃ³gÃ³",
        lower: "lÃ¦gri",
        machine: "vÃ©l",
        machineConfiguration: "grunnstilling vÃ©lar",
        machineManagement: "vÃ©larstÃ½ring",
        machineName: "heiti vÃ©lar",
        main: "aÃ°al",
        maintenance: "viÃ°hald",
        manual: "handvirkur",
        manualAddition: "bÃ¦tt viÃ° handvirkt",
        manualDispensing: "handvirk skÃ¶mmtun",
        manualScan: "handvirk skÃ¶nnun",
        margins: "framlegÃ°ir",
        markups: "Ã¡lagningar",
        mass: "massi",
        match: "samsvÃ¶run",
        measure: "mÃ¦la",
        measurement: "mÃ¦ling",
        measurementUnits: "mÃ¦lieiningar",
        melody: "laglÃ­na",
        message: "skilaboÃ°",
        minimal: "lÃ¡gmark",
        minolta: "Minolta",
        minus: "mÃ­nus",
        minutes: "mÃ­nÃºtur",
        misura: "Misura",
        ml: "ml",
        mode: "Ã¡stand",
        model: "tegund",
        modification: "breyting",
        modify: "breyta",
        monthly: "mÃ¡naÃ°arlega",
        moreInfo: "frekari upplÃ½singar",
        movableTable: "fÃ¦ranlegt borÃ°",
        move: "fÃ¦ra",
        music: "tÃ³nlist",
        myOrders: "mÃ­nar pantanir",
        name: "heiti",
        naming: "heiti valiÃ°",
        nano: "Nano",
        navigation: "leiÃ°sÃ¶gn",
        new: "nÃ½tt",
        nextDriver: "NextDriver",
        night: "nÃ³tt",
        nixPro: "Nix Pro",
        notes: "athugasemdir",
        notification: "tilkynning",
        number: "nÃºmer",
        off: "slÃ¶kkt",
        open: "opna",
        order: "panta",
        ordering: "pÃ¶ntun",
        overfill: "ofÃ¡fylling",
        overview: "yfirlit",
        overwrite: "yfirskrifa",
        own: "eigin",
        pCPDriver: "PCPDriver",
        package: "pakki",
        packagePrice: "pakkaverÃ°",
        packages: "pakkar",
        panels: "PlÃ¶tur",
        parameter: "FÃ¦ribreyta",
        path: "slÃ³Ã°",
        pc: "tÃ¶lva",
        phone: "sÃ­mi",
        phoneNumber: "sÃ­manÃºmer",
        picture: "mynd",
        place: "staÃ°setja",
        placement: "staÃ°setning",
        plug: "tengill",
        plugger: "tengir",
        plugging: "tenging",
        plugin: "innstunga",
        plus: "plÃºs",
        pointOfSale: "sÃ¶lustaÃ°urinn",
        popUp: "sprettigluggi",
        pos: "SÃ¶lustaÃ°ur (POS)",
        present: "nÃºverandi",
        preview: "forskoÃ°un",
        price: "verÃ°",
        priceExport: "flytja Ãºt verÃ°",
        priceGroup: "verÃ°flokkur",
        priceImport: "flytja inn verÃ°",
        prices: "verÃ°",
        pricing: "verÃ°lagning",
        primaryCurrency: "aÃ°algjaldmiÃ°ill",
        print: "prenta",
        printer: "prentari",
        printing: "prentar",
        problem: "vandamÃ¡l",
        product: "vara",
        productPrice: "vÃ¶ruverÃ°",
        profiledValues: "prÃ³fÃ­lgildi",
        punch: "gata",
        puncher: "gatari",
        punching: "gÃ¶tun",
        purge: "hreinsa",
        purgeType: "gerÃ° hreinsunar",
        purgeVolume: "rÃºmmÃ¡l hreinsunar",
        quality: "gÃ¦Ã°i",
        quick: "fljÃ³tlegt",
        quickTint: "fljÃ³tleg litblÃ¶ndun",
        rM: "RM",
        raise: "lyfta",
        rcc: "RCC",
        reader: "Reader (Colorix Reader Pro)",
        reboot: "endurrÃ¦sa",
        receive: "mÃ³ttaka",
        recirculate: "endurdÃ¦la",
        recirculation: "endurdÃ¦ling",
        redlike: "Redlike",
        refill: "fylla Ã¡ aftur",
        registration: "skrÃ¡ning",
        regular: "reglulega",
        removal: "fjarlÃ¦ging",
        remove: "fjarlÃ¦gja",
        report: "skÃ½rsla",
        reset: "nÃºllstilla",
        resolution: "upplausn",
        restart: "endurrÃ¦sa",
        rgb: "RGB",
        rights: "rÃ©ttindi",
        rounding: "nÃ¡mundun",
        rules: "reglur",
        sanTint: "SanTint",
        save: "vista",
        scale: "kvarÃ°i",
        scan: "skanna",
        scope: "umfangiÃ°",
        screen: "skjÃ¡r",
        screensaver: "skjÃ¡hvÃ­la",
        search: "leita",
        secondaryCurrency: "aukagjaldmiÃ°ill",
        select: "velja",
        selectedFormula: "Valin formÃºla",
        sell: "selja",
        sensor: "skynjari",
        serialNumber: "raÃ°nÃºmer",
        server: "netÃ¾jÃ³nn",
        servers: "netÃ¾jÃ³nar",
        service: "Ã¾jÃ³nusta",
        serviceAction: "Ã¾jÃ³nustuaÃ°gerÃ°",
        serviceActions: "Ã¾jÃ³nustuaÃ°gerÃ°ir",
        serviceSoftware: "Ã¾jÃ³nustuhugbÃºnaÃ°ur",
        serviceWindow: "Ã¾jÃ³nustugluggi",
        settings: "stillingar",
        shelf: "hilla",
        shortcuts: "flÃ½tileiÃ°ir",
        shot: "skot",
        show: "sÃ½na",
        shutDown: "ganga frÃ¡",
        shutdown: "lokun",
        silent: "hljÃ³tt",
        simple: "einfaldur",
        simulation: "hermun",
        size: "stÃ¦rÃ°",
        skip: "hlaupa yfir",
        smartPurge: "snjallhreinsun",
        software: "hugbÃºnaÃ°ur",
        softwareSupplier: "sÃ¶luaÃ°ili hugbÃºnaÃ°ar",
        sort: "raÃ°a",
        sound: "hljÃ³Ã°",
        spectro: "litrÃ³f",
        spectrophotometer: "litrÃ³fsmÃ¦lir",
        speed: "hraÃ°i",
        split: "hlutar",
        start: "byrja",
        startup: "rÃ¦sa",
        statistics: "tÃ¶lfrÃ¦Ã°igÃ¶gn",
        status: "staÃ°a",
        stir: "hrÃ¦ra",
        stirring: "hrÃ¦ring",
        street: "gata",
        support: "stoÃ°Ã¾jÃ³nusta",
        surcharge: "viÃ°auki",
        tab: "flipi",
        tabs: "flipar",
        task: "verkefni",
        template: "sniÃ°mÃ¡t",
        testing: "prÃ³f",
        time: "tÃ­mi",
        tintingManagementCenter: "litastjÃ³rnunarmiÃ°stÃ¶Ã°",
        to: "til",
        toDispense: "aÃ° skammta",
        tolerance: "frÃ¡vik",
        top: "efst",
        total: "samtals",
        translation: "Ã¾Ã½Ã°ingar",
        turnOff: "slÃ¶kkva",
        turntable: "SnÃºningsskÃ­fa",
        type: "gerÃ°",
        uIDD: "UIDD",
        uSGallon: "BandarÃ­skt gallon",
        uSQuart: "BandarÃ­skt kvart",
        unit: "tÃ¦ki",
        up: "upp",
        update: "uppfÃ¦rsla",
        url: "VefslÃ³Ã°",
        user: "notandi",
        userGroups: "notendahÃ³par",
        v1: "v1",
        v2: "v2",
        v3: "v3",
        vAT: "VSK",
        validate: "sannprÃ³fa",
        validation: "sannprÃ³fun",
        version: "ÃºtgÃ¡fa",
        virtual: "sÃ½ndar",
        volume: "rÃºmmÃ¡l",
        weekly: "vikulega",
        window: "gluggi",
        windows: "gluggar",
        with: "Ã¾egar",
        without: "Ã¡n",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y-gildi",
        zipCode: "pÃ³stnÃºmer",
        zoom: "aÃ°drÃ¡ttur"
    },
    languages: {
        bg: "BÃºlgarska",
        cs: "TÃ©kkneska",
        da: "Danska",
        de: "ÃÃ½ska",
        el: "GrÃ­ska",
        en: "Enska",
        es: "SpÃ¦nska",
        fr: "Franska",
        hr: "KrÃ³atÃ­ska",
        hu: "Ungverska",
        id: "IndÃ³nesÃ­ska",
        is: "Ãsland",
        it: "Ãtalska",
        lt: "LithÃ¡Ã­ska",
        lv: "Lettneska",
        ms: "MalasÃ­ska",
        nl: "Hollenska",
        no: "Noregur",
        pl: "PÃ³lska",
        pt: "PortÃºgalska",
        ro: "RÃºmenska",
        ru: "RÃºssneska",
        sk: "SlÃ³vakÃ­ska",
        sr: "Serbneska",
        sv: "SvÃ­Ã¾jÃ³Ã°",
        zh: "KÃ­nverska"
    },
    license: {
        activateLicense: "Virkja leyfi",
        activateNewLicense: "Virkja nÃ½tt leyfi",
        checkLicenseKey: "Kanna leyfislykil",
        companyId: "AuÃ°kenni fyrirtÃ¦kis",
        contactPerson: "TengiliÃ°ur",
        copy: "Afrit",
        country: "Land",
        emptyCity: "ÃskiliÃ° er aÃ° tilgreina borg/bÃ¦",
        emptyCountry: "ÃskiliÃ° er aÃ° tilgreina land",
        emptyName: "ÃskiliÃ° er aÃ° tilgreina heiti verslunar",
        enterIdentificationKeys: "FÃ¦rÃ°u inn auÃ°kennislykilinn Ã¾inn",
        expirationDate: "Lokadagsetning %{dateTime}",
        fillRegistration: "Fylltu Ãºt skrÃ¡ningargÃ¶gn (flettu niÃ°ur til aÃ° sjÃ¡ meira)",
        insertLicense: "FÃ¦rÃ°u inn lykilinn sem var bÃºinn til fyrir virkjun utan nets",
        invalidEmail: "NetfangiÃ° sem var fÃ¦rt inn er Ã³gilt",
        invalidPhone: "SÃ­manÃºmeriÃ° sem var fÃ¦rt inn er Ã³gilt",
        itemsMarkedasterisk: "(stjÃ¶rnumerktir reitir eru Ã¡skildir)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Leigt leyfi",
        licenseActivated: "LeyfiÃ° hefur Ã¾egar veriÃ° virkjaÃ°",
        licenseStatus: "StaÃ°a leyfis",
        licenseWillExpire: "LeyfiÃ° Ã¾itt rennur Ãºt eftir %{dayCount} daga",
        licenseWillExpireOneDay: "LeyfiÃ° Ã¾itt rennur Ãºt eftir %{dayCount} daga",
        machineInformation: "VÃ©larupplÃ½singar",
        noLicenseAvailable: "Ekkert leyfi tiltÃ¦kt",
        noProductsForKey: "Engar vÃ¶rur eru tiltÃ¦kar fyrir opna auÃ°kennislykilinn.",
        pointOfSale: "SÃ¶lustaÃ°ur",
        producer: "FramleiÃ°andi",
        reactivate: "Virkja aftur",
        reactivateLicense: "Reactivate license",
        region: "LandsvÃ¦Ã°i",
        registerLicense: "GerÃ°u afrit af virkjunarbeiÃ°ninni og farÃ°u Ã­:",
        registrationForm: "SkrÃ¡ning",
        selectProduct: "Velja vÃ¶ru",
        serialNumber: "RaÃ°nÃºmer",
        skipNewLicense: "Ef Ã¾Ãº vilt virkja nÃ½tt leyfi seinna meir getur Ã¾Ãº smellt Ã¡ âHlaupa yfirâ",
        unlimitedLicense: "ÃtakmarkaÃ° leyfi",
        userId: "AuÃ°kenni notanda",
        uuid: "UUID leyfis",
        versionDetails: "UpplÃ½singar um ÃºtgÃ¡funa",
        versionScope: "MarkmiÃ°iÃ° meÃ° ÃºtgÃ¡funni",
        versionType: "GerÃ° ÃºtgÃ¡funnar",
        zip: "PÃ³stnÃºmer"
    },
    login: {
        authenticate: "Sannvotta",
        logIn: "InnskrÃ¡ning",
        loginAs: "InnskrÃ¡ning sem annar notandi",
        messages: {
            incorrectUsername: "Notandanafn og aÃ°gangsorÃ° eru rÃ¶ng "
        },
        password: "AÃ°gangsorÃ°",
        username: "Notandanafn"
    },
    machineActionHistory: {
        actionHistory: "Ferill aÃ°gerÃ°a"
    },
    machineErrors: {
        channel: "RÃ¡sir",
        code: "KÃ³Ã°i",
        machineErrors: "Villa Ã­ vÃ©l",
        noMachineErrors: "Sem stendur eru engar villur Ã­ vÃ©linni",
        resetErrors: "Villa Ã­ nÃºllstillingu"
    },
    machineSettings: {
        action: "AÃ°gerÃ°",
        addAutotask: "BÃ¦ta viÃ° sjÃ¡lfvirkri aÃ°gerÃ° (Autotask)",
        autoCanisterIn: "SjÃ¡lfvirkt hylki inn",
        autoCanisterOut: "SjÃ¡lfvirkt hylki Ãºt",
        automaticRefill: "SjÃ¡lfvirk endurÃ¡fylling",
        autotaskSettings: "Stillingar sjÃ¡lfvirkra aÃ°gerÃ°a (Autotask)",
        backupConfiguration: "Ãryggisafrit af grunnstillingum litblÃ¶ndunarvÃ©lar",
        brushMaintenance: "ViÃ°hald bursta",
        capMaintenance: "ViÃ°hald Ã¡ loki",
        checkCanisterBeforeDispense: "SkoÃ°a hylki fyrir litblÃ¶ndun",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Athuga lÃ¡gmarksmagn litarefnis sem hÃ¦gt er aÃ° lita meÃ°",
        checkOverfill: "Athuga umframmagn Ã­ dÃ³s",
        checkTotalCntAmounts: "Athuga heildarmagn litarefnis fyrir stofninn",
        cleanAll: "Hreinsa allt",
        computerReboot: "EndurrÃ¦sa tÃ¶lvu",
        computerShutdown: "Loka tÃ¶lvu",
        connectMachine: "Tengja vÃ©l",
        days: "Dagar",
        daysOfMonth: "Dagar Ã­ mÃ¡nuÃ°i",
        devices: "TÃ¦ki",
        disabled: "Gert Ã³virkt",
        dispenseAndPurge: "LitblÃ¶ndun og hreinsun",
        dispenseOnly: "AÃ°eins litblÃ¶ndun",
        dispenserCleaning: "Hreinsun litblÃ¶ndunarvÃ©lar",
        dispensingWithErrorsEnabled: "Leyfa skÃ¶mmtun, Ã¾rÃ¡tt fyrir villur Ã­ sannprÃ³fun",
        editAutotask: "Breyta sjÃ¡lfvirkri aÃ°gerÃ° (Autotask)",
        firstRun: "Fyrsta keyrsla",
        hours: "Klukkustundir",
        humidifier: "RakatÃ¦ki",
        humidifierWaterLevelMaintenance: "VatnshÃ¦Ã° Ã­ tanki rakatÃ¦kis haldiÃ° viÃ°",
        machineConfigurationNoCanisters: "Grunnstilling vÃ©larinnar inniheldur engar dÃ³sir.",
        machineName: "Heiti vÃ©lar",
        machineSettings: "VÃ©larstillingar",
        manualPuncher: "Handvirk stÃ¶nsun",
        minDispensedAmount: "LÃ¡marksmagn litarefnis",
        minutes: "MÃ­nÃºtur",
        nextRun: "NÃ¦sta umferÃ°",
        noAutotasksSet: "Engar sjÃ¡lfvirkar aÃ°gerÃ°ir eru tilgreindar",
        noDataAvailable: "Engin gÃ¶gn eru fyrirliggjandi",
        noMachine: "Engin vÃ©l er tengd",
        onStart: "ViÃ° rÃ¦singu",
        plugger: "Tengihnappur",
        postpone: "DÃ³s/fata losuÃ°",
        puncher: "StÃ¶nsunarhnappur",
        purgeAll: "Hreinsa allt",
        purgeOnly: "Hreinsa aÃ°eins",
        recirculateAll: "EndurdÃ¦la Ã¶llu",
        recirculateChannels: "DÃ¦la aftur Ã­ gegnum rÃ¡sir",
        recirculationSpeed: "HraÃ°i viÃ° endurdÃ¦lingu",
        recirculationTime: "EndurdÃ¦lingartÃ­mi",
        refillAll: "Fylla aftur Ã¡ allt",
        refillCanisters: "Fylla aftur Ã¡ hylkin",
        runAt: "Daglega kl.",
        runDefinedDaysAt: "Skilgreina daga kl.",
        runEvery: "Keyra hvern",
        runInDays: "Keyra Ã¡ dÃ¶gum",
        serialNum: "RaÃ°nÃºmer",
        settingsMachine: "StillivÃ©l",
        smartPurgeAll: "Snjallhreinsun Ã¡ Ã¶llu",
        smartPurgeChannels: "Snjallhreinsun Ã¡ rÃ¡sum",
        smartPurgeRules: "Reglur fyrir snjallhreinsun",
        startType: "GerÃ° rÃ¦singar",
        stirAll: "HrÃ¦ra Ã­ Ã¶llu",
        stirCanisters: "HrÃ¦ra Ã­ hylkjum",
        stirringSpeed: "HraÃ°i viÃ° hrÃ¦ringu",
        stirringTime: "HrÃ¦ringartÃ­mi",
        switchPlateMaintenance: "Skipta um viÃ°hald Ã¡ plÃ¶tu",
        theCurrentlySelectedMachine: "Valin vÃ©l",
        threshold: "Byrjun",
        turntable: "SnÃºningsskÃ­fa",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "Magn",
        weekdays: "Vikudagur"
    },
    mainTab: {
        acceptedFormula: "SamÃ¾ykkt formÃºla",
        addBuildingSite: "Add building site",
        addToFavorites: "BÃ¦ta viÃ° eftirlÃ¦ti",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "Eitt eÃ°a fleiri litarefni eru tiltÃ¦k",
        dispensedPackages: "LitblandaÃ°ur pakki",
        dispensingInProgress: "LitblÃ¶ndun stendur yfir",
        dispensingIsAborted: "LitblÃ¶ndun var stÃ¶Ã°vuÃ°",
        dispensingIsNotAvailable: "LitblÃ¶ndun er ekki tiltÃ¦k",
        dispensingProgress: "%{done} af %{all}",
        editColorant: "Breyta litarefni",
        editNote: "Breyta athugasemd",
        findCompetitiveColor: "Reyna aÃ° finna samkeppnislit",
        forceDispensing: "Ãvinga litblÃ¶ndun",
        formulaInvalidColorants: "Uppskriftin inniheldur Ã³gild litarefni: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Falin litaspjÃ¶ld",
        hiddenProducts: "Faldar vÃ¶rur",
        historicalFormulas: "Eldri uppskriftir",
        lowerDeltaNumber: "LÃ¦gri delta-tala er nÃ¡kvÃ¦mari samsvÃ¶run",
        machineError: "Villa Ã­ vÃ©l",
        machineIsBusy: "VÃ©lin er upptekin",
        machineNotConnected: "VÃ©lin er ekki tengd",
        manualColorantAddition: "Handvirku litarefni bÃ¦tt viÃ°",
        modifiedFormula: "Uppskriftinni var breytt",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "NÃ½r litur eftir kvÃ¶rÃ°un",
        newRgbNotAccuratelyMeasured: "NÃ½tt RGB er ekki nÃ¡kvÃ¦mlega mÃ¦lt, heldur aÃ°eins vÃ­sbending",
        noBaseAvailable: "Enginn grunnur er tiltÃ¦kur",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Engin litarefni",
        noCustomer: "Engir viÃ°skiptavinir",
        noCustomers: "Engir viÃ°skiptavinir tiltÃ¦kir",
        noDispenseNotesAvailable: "Engar athugasemdir um litblÃ¶ndun eru tiltÃ¦kar",
        noFormulaAvailable: "ÃÃº valdir samsetningu Ã¡n formÃºlu!",
        noFormulaSelected: "Engin uppskrift var valin",
        noInternalNotesAvailable: "Engar athugasemdir Ãºr kerfi eru tiltÃ¦kar",
        noNotesAvailable: "Engar athugasemdir eru tiltÃ¦kar",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Engir pakkar voru valdir",
        noProductAvailable: "No product is available",
        noResultsFound: "Engar niÃ°urstÃ¶Ã°ur fundust",
        openLocalFile: "Opna Ãºr staÃ°bundnum gagnagrunni",
        openOnlineFile: "Opna Ã¡ netinu",
        order: "PÃ¶ntun",
        orderingIsNotAvailable: "PÃ¶ntunin er ekki tiltÃ¦k",
        originalColor: "Upprunalegur litur",
        overAvailableLevel: "Yfir tiltÃ¦ku stigi",
        package: "Pakki",
        packageIsRequired: "Pakki er Ã¡skilinn",
        packaging: "UmbÃºÃ°ir",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Ãtprentun er ekki tiltÃ¦k",
        productFiles: "VÃ¶ruskrÃ¡r",
        productFilesViewer: "SkoÃ°ari fyrir vÃ¶ruskrÃ¡r",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "Venjulegt verÃ°",
        resetFormulaData: "NÃ½ uppskrift",
        rgbOnlyIndicative: "RGB er aÃ°eins vÃ­sbending!",
        saveAsCustom: "Vista sem",
        saveToStatsIsNotAvailable: "Ekki er hÃ¦gt aÃ° vista Ã­ ferli",
        searchForCheaper: "Leita aÃ° Ã³dÃ½rara",
        selectFromCompetitive: "ÃÃº getur valiÃ° lit Ãºr samkeppnislitunum.",
        specialPrice: "SÃ©rverÃ°",
        specialPriceVip: "SÃ©rverÃ° fyrir vildarviÃ°skiptavini",
        splitFormula: "Skipta upp uppskrift",
        withVAT: "meÃ° VSK",
        withoutVAT: "Ã¡n VSK"
    },
    marginSettings: {
        allBases: "Allir grunnar",
        allProducts: "Allar vÃ¶rur",
        editMargin: "Breyta hagnaÃ°i (Ã­ hlutfalli viÃ° sÃ¶lutekjur)",
        marginAndDiscountWarning: "Ã Ãºtreikningi Ã¡ verÃ°i verÃ°ur Ã¾Ãº aÃ° stilla valkostinn fyrir Ã¡gÃ³Ã°a og afslÃ¦tti.",
        marginSettings: "Stillingar fyrir hagnaÃ° (Ã­ hlutfalli viÃ° sÃ¶lutekjur)",
        marginsFor: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur) fyrir",
        markupColorants: "Ãskilegt hagnaÃ°arhlutfall (Ã¡lagning) fyrir litarefni",
        sizeOfPackage: "StÃ¦rÃ° pakka",
        valueBase: "Grunngildi",
        valueColorant: "Litarefnisgildi"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Breyta einingu fyrir litarefni",
        payAttention: "GÃ¦ttu Ã¾Ã­n!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "SÃ­a fyrir litakort",
            formulasOverLimit: "Um Ã¾aÃ° bil %{count} niÃ°urstÃ¶Ã°ur. PrÃ³faÃ°u aÃ° skrifa fleiri stafi.",
            foundFormulas: "%{count} uppskriftir fundust",
            help: "HjÃ¡lp:",
            helpText:
                "SkrifaÃ°u t.d. â%{filter}â til aÃ° leita eftir uppskriftum sem hefjast Ã¡ â%{formula}â, vÃ¶rum sem hefjast Ã¡ â%{product}â og litakortum â%{fandeck}â.",
            productFilter: "VÃ¶rusÃ­a",
            searchInFormulas: "Leita Ã­ kvittunum",
            typeMore: "SkrifaÃ°u fleiri stafi."
        },
        menu: {
            actionHistory: "AÃ°gerÃ°aferill",
            additionalFormulaTab: "Auka uppskriftaflipi",
            advancedSettings: "Ãtarlegar stillingar",
            autotaskSettings: "SjÃ¡lfvirk aÃ°gerÃ° (Autotask)",
            availableDatabases: "TiltÃ¦kir gagnagrunnar",
            availablePrices: "TiltÃ¦k verÃ°",
            bugReport: "VilluskÃ½rsla",
            canisterBarcodes: "Strikamerki hylkis",
            canisterDispensingLogic: "Reglur fyrir litarefni",
            canisterFilling: "Ãfylling hylkja",
            canisterSettings: "Stillingar hylkja",
            clientServerSettings: "Tenging biÃ°lara/netÃ¾jÃ³ns",
            closing: "Lokar",
            color: "Litur",
            colorModification: "Litabreyting",
            colorPanel: "Stillingar litasvÃ¦Ã°is",
            colorRepresentation: "Litaframsetning og gÃ¶gn",
            colorSearch: "Litaleit",
            colorant: "Litarefni",
            colorantConsumption: "Notkun Ã¡ litarefni",
            colorantPricing: "VerÃ°lagning litarefnis",
            colorantRefillHistory: "Ãfyllingarferill litarefnis",
            competitiveSearch: "Litaleit meÃ° hermingu",
            connections: "Tengingar",
            currency: "GjaldmiÃ°ilsstillingar",
            customData: "SÃ©rsniÃ°in gÃ¶gn",
            database: "Gagnagrunnur",
            databaseCheck: "SkoÃ°un Ã¡ gagnagrunni",
            databaseConnection: "Tenging gagnagrunns",
            defaultValues: "SjÃ¡lfgefin gildi",
            devices: "Einingar",
            dispensingHistory: "Ferill litblÃ¶ndunar",
            dispensingSettings: "LitblÃ¶ndunarstillingar",
            driverSettings: "Rekilsstillingar",
            environment: "Umhverfi",
            environmentConfiguration: "Umhverfisstillingar",
            environmentalSettings: "Umhverfisstillingar",
            favorites: "EftirlÃ¦ti",
            fileTransfer: "DESO-skrÃ¡aflutningur",
            formatting: "MÃ³tun",
            formula: "Formula",
            formulaData: "GÃ¶gn",
            formulaModification: "Formula modification",
            formulaPanels: "UppskriftasvÃ¦Ã°i",
            formulaSettings: "Uppskriftastillingar",
            formulaUnit: "Einingar uppskrifta",
            generalSearch: "Almenn leit",
            globalSettingsSearch: "Leit samkvÃ¦mt altÃ¦kum stillingum",
            helpItems: "HjÃ¡lparstillingar",
            importAndExport: "Inn- og Ãºtflutningur",
            importAndExportData: "Flytja inn gÃ¶gn",
            importCustomData: "Flytja inn sÃ©rsniÃ°in gÃ¶gn",
            initialFormulaTab: "Upprunalegur uppskriftarflipi",
            interfaceSettings: "ViÃ°mÃ³tsstillingar",
            keyboardShortcuts: "FlÃ½tileiÃ°ir Ã¡ lyklaborÃ°i",
            language: "TungumÃ¡l",
            languageSettings: "TungumÃ¡lastillingar",
            layout: "Uppsetning",
            license: "Leyfi",
            licenseData: "LeyfisgÃ¶gn",
            licenseIdentification: "LeyfisauÃ°kenni",
            licenseStatus: "LeyfisstaÃ°a",
            licenseSupplier: "Leyfisveitandi",
            licenseVersion: "LeyfisÃºtgÃ¡fa",
            localData: "StaÃ°bundin gÃ¶gn",
            machine: "UpplÃ½singar um vÃ©l",
            machineActions: "VÃ©laraÃ°gerÃ°ir",
            machineAndDevices: "VÃ©l og tÃ¦ki",
            machineManagement: "VÃ©larstÃ½ring",
            machineSettings: "VÃ©larstillingar",
            mainSettings: "AÃ°alstillingar",
            maintenance: "ViÃ°hald",
            marginAndDiscount: "FramlegÃ° og afslÃ¡ttur",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "FlettiatriÃ°i",
            newFormulaWindow: "Uppskrift",
            orderSearch: "Leit Ã­ pÃ¶ntunum",
            orderSettings: "PÃ¶ntunarstillingar",
            packageSurcharge: "Pakkagjald",
            popUps: "Sprettigluggi",
            posInfo: "UpplÃ½singar um sÃ¶lustaÃ°",
            price: "VerÃ°stillingar",
            priceManagement: "VerÃ°stjÃ³rnun",
            priceSettings: "VerÃ°stillingar",
            pricingOptions: "VerÃ°stillingar",
            printSettings: "Prentstillingar",
            productPricing: "VÃ¶ruverÃ°lagning",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "FljÃ³tleg litastilling",
            rccConfig: "Stillingar fyrir RCC (Redlike Control Center)",
            rccConnection: "Tengingar fyrir RCC (Redlike Control Center)",
            rccSettings: "Stillingar fyrir RCC (Redlike Control Center)",
            refillSettings: "Refill Settings",
            refillingLogic: "EndurÃ¡fyllingarrÃ¶k",
            registration: "SkrÃ¡ning",
            searchSettings: "Leitarstillingar",
            serverPlugins: "ViÃ°bÃ³t fyrir netÃ¾jÃ³n",
            serviceActions: "NetÃ¾jÃ³nsaÃ°gerÃ°ir",
            settings: "Stillingar",
            simplifiers: "Einfaldanir",
            singleActions: "Stakar aÃ°gerÃ°ir",
            smartPurgeRules: "Reglur fyrir snjallhreinsun",
            softwareOptions: "HugbÃºnaÃ°arÃºrrÃ¦Ã°i",
            spectroSettings: "Stillingar litrÃ³fsmÃ¦lis",
            statistics: "TÃ¶lfrÃ¦Ã°igÃ¶gn",
            switchToFrontdesk: "Skipta Ã­ mÃ³ttÃ¶ku",
            switchToFullRedlike: "Skipta Ã­ %{name}",
            switchToLight: "Skipta Ã­ %{name}",
            switchToMachine: "Skipta Ã­ vÃ©l",
            tabs: "Flipi og sprettigluggi",
            testBarcodes: "StrikamerkjaprÃ³f",
            updateOptions: "UppfÃ¦rslukostir",
            userManagemenet: "StjÃ³rnun notenda",
            visibleUnits: "SÃ½nilegar einingar"
        },
        navBar: {
            barcode: "Strikamerki",
            help: "HjÃ¡lp",
            hideItems: "Fela vÃ¶rur/litaspjÃ¶ld"
        },
        notificationPanel: {
            noNotifications: "Engar nÃ½jar tilkynningar"
        },
        tabBar: {
            closeActive: "Loka Ã¶llu virku",
            closeAll: "Loka Ã¶llu",
            closeAllExceptActive: "Loka Ã¶llu nema virku",
            customFormula: "Custom Formula",
            dispensingHistory: "Ferill litblÃ¶ndunar",
            favorites: "EftirlÃ¦ti",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Ãthluta",
        assignment: "Verkefni",
        createdDate: "Stofndagsetning",
        finishDispensing: "LjÃºka litblÃ¶ndun",
        foundInOrders: "Finnst Ã­ pÃ¶ntunum",
        inactiveDatabase: "Uppskriftin er Ãºr Ã³virkum eÃ°a Ã³Ã¾ekktum gagnagrunni %{0}",
        inactiveUnknownDatabase: "Uppskriftin er Ãºr Ã³virkum eÃ°a Ã³Ã¾ekktum gagnagrunni",
        newOrderReceived: "ÃÃº hefur fengiÃ° nÃ½ja pÃ¶ntun!",
        noOrderSelected: "Engin pÃ¶ntun valin",
        release: "Birta",
        status: {
            accepted: "samÃ¾ykkt",
            canceled: "Ã³gilt",
            created: "bÃºiÃ° til",
            done: "lokiÃ°",
            partlyDone: "lokiÃ° aÃ° hluta",
            preparing: "undirbÃ½r",
            unknown: "Ã³Ã¾ekkt"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Heimilisfang",
        contactName: "Nafn tengiliÃ°ar",
        contactPerson: "TengiliÃ°ur",
        identification: "AuÃ°kenning",
        machineInformation: "VÃ©larupplÃ½singar",
        pos: "SÃ¶lustaÃ°ur",
        secondAddress: "AnnaÃ° heimilisfang",
        shopIdentification: "AuÃ°kenning verslunar",
        shopName: "Heiti verslunar",
        url: "Tilfangaleit fyrir einingar",
        zipCode: "PÃ³stnÃºmer"
    },
    priceTypeList: {
        priceBasePurchase: "FramleiÃ°sluverÃ° fyrir grunn",
        priceBaseSell: "ÃtsÃ¶luverÃ° fyrir grunn",
        priceBaseSellFull: "ÃtsÃ¶luverÃ° fyrir grunn",
        priceCntPurchase: "FramleiÃ°sluverÃ° fyrir litarefni",
        priceCntPurchaseByColorantName: "FramleiÃ°sluverÃ° fyrir %{0} litarefni",
        priceCntPurchaseByName: "FramleiÃ°sluverÃ° fyrir litarefni meÃ° heitinu",
        priceCntSell: "ÃtsÃ¶luverÃ° fyrir litarefni",
        priceCntSellByColorantName: "ÃtsÃ¶luverÃ° fyrir %{0} litarefni",
        priceCntSellByName: "ÃtsÃ¶luverÃ° fyrir litarefni meÃ° heitinu",
        priceCntSellFull: "SÃ¶luverÃ° fyrir litarefni",
        priceCntSellFullByColorantName: "SÃ¶luverÃ° fyrir litarefni %{0}",
        priceCntSellFullByName: "SÃ¶luverÃ° fyrir litarefni Ã¡ hvert nafn",
        priceGroupBarcode: "Strikamerki fyrir verÃ°flokk",
        priceMarginAll: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur) fyrir alla pakka",
        priceMarginPerPkg: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur) fyrir einn pakka",
        priceSellPriceAll: "ÃtsÃ¶luverÃ° fyrir alla pakka",
        priceSellPricePerKg: "ÃtsÃ¶luverÃ° Ã¡ kÃ­lÃ³",
        priceSellPricePerL: "ÃtsÃ¶luverÃ° Ã¡ lÃ­tra",
        priceSellPricePerPkg: "ÃtsÃ¶luverÃ° fyrir einn pakka",
        priceSurchargeAll: "Aukagjald fyrir alla pakka",
        priceSurchargePerPkg: "Aukagjald fyrir einn pakka",
        priceTintPurchaseAll: "FramleiÃ°sluverÃ° litablÃ¶ndunar fyrir alla pakka",
        priceTintPurchasePerPkg: "FramleiÃ°sluverÃ° litablÃ¶ndunar fyrir einn pakka",
        priceTintSellFullAll: "SÃ¶luverÃ° fyrir litblÃ¶ndun fyrir alla pakka",
        priceTintSellFullAllPerPackage: "SÃ¶luverÃ° fyrir litblÃ¶ndun fyrir hvern pakka",
        priceTotalPurchaseAll: "HeildarframleiÃ°sluverÃ° fyrir alla pakka",
        priceTotalPurchasePerKg: "HeildarframleiÃ°sluverÃ° Ã¡ kÃ­lÃ³",
        priceTotalPurchasePerL: "HeildarframleiÃ°sluverÃ° Ã¡ lÃ­tra",
        priceTotalPurchasePerPkg: "HeildarframleiÃ°sluverÃ° fyrir einn pakka",
        priceTotalSellFullAll: "SÃ¶luverÃ° samtals fyrir alla pakka",
        priceTotalSellFullPerKg: "SÃ¶luverÃ° samtals Ã¡ hvert kg",
        priceTotalSellFullPerLiter: "SÃ¶luverÃ° samtals Ã¡ hvern lÃ­tra",
        priceTotalSellFullPerPackage: "SÃ¶luverÃ° samtals Ã¡ hvern pakka"
    },
    pricing: {
        allBases: "Allir grunnar",
        allPackages: "Allir pakkar",
        backup: "Backup",
        basesOfProduct: "Grunnar meÃ° %{productName}",
        colorantPricing: "VerÃ°lagning litarefnis",
        export: "Flytja Ãºt",
        import: "Flytja inn",
        packagePricing: "VerÃ°lagning Ã¡ pakka",
        packageSurcharge: "Aukagjald Ã¡ pakka",
        packages: "Pakkar",
        packagesOfProduct: "Pakkar meÃ° %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "VerÃ°flokkur fyrir verÃ° Ã¡ lÃ­tra",
        priceGroups: "VerÃ°flokkar",
        pricePerLiter: "VerÃ° Ã¡ lÃ­tra",
        productPricing: "VÃ¶ruverÃ°lagning",
        purchasePrice: "InnkaupsverÃ°",
        purchasePricePerLiter: "InnkaupsverÃ° Ã¡ lÃ­tra",
        sellPrice: "SÃ¶luverÃ°",
        surcharge: "Aukagjald"
    },
    print: {
        adminRightsRequired: "Til aÃ° breyta sniÃ°mÃ¡ti eÃ°a bÃºa til nÃ½tt sniÃ°mÃ¡t Ã¾arf stjÃ³rnandaheimildir.",
        allowAutomaticPrint: "SjÃ¡lfvirk prentun",
        allowPrintAfterDispensing: "Leyfa prentun eftir litblÃ¶ndun",
        allowPrintBeforeDispensing: "Leyfa prentun fyrir litblÃ¶ndun",
        automaticPrint: "Prenta sjÃ¡lfvirkt",
        choosePrinter: "Prentari",
        chooseSettings: "Breyta stillingum",
        chooseTemplate: "SniÃ°mÃ¡t",
        copies: "Afrit",
        createTemplate: "BÃºa til sniÃ°mÃ¡t",
        createTemplateHint: "BÃºÃ°u til nÃ½tt sniÃ°mÃ¡t frÃ¡ grunni. VistaÃ°u sniÃ°mÃ¡tiÃ° Ã­ sniÃ°mÃ¡tamÃ¶ppuna og endurrÃ¦stu RCC.",
        defaultPrinter: "SjÃ¡lfgefinn prentari",
        defaultSettings: "SjÃ¡lfgefnar stillingar",
        defaultTemplate: "SjÃ¡lfgefiÃ° sniÃ°mÃ¡t",
        editTemplate: "Breyta sniÃ°mÃ¡ti",
        editTemplateHint: "Breyttu %{name}. Breytingarnar verÃ°a sÃ½nilegar eftir endurrÃ¦singu RCC.",
        noEditTemplate: "Ekkert sniÃ°mÃ¡t til aÃ° breyta",
        noPrinterSelected: "Enginn prentari var valinn",
        noPrintersAvailable: "Enginn prentari er tiltÃ¦kur",
        noTemplateSelected: "Ekkert sniÃ°mÃ¡t var valiÃ°",
        noTemplatesAvailable: "Ekkert sniÃ°mÃ¡t er tiltÃ¦kt",
        numberOfCopies: "FjÃ¶ldi afrita",
        openTemplateEditor: "Opna sniÃ°mÃ¡tsritil",
        printAfterDispensing: "Prenta Ãºt eftir litblÃ¶ndun",
        printAsImage: "Prenta Ãºt sem mynd",
        printBeforeDispensing: "Prenta Ãºt fyrir litblÃ¶ndun",
        printOnRequest: "Prenta Ãºt eftir beiÃ°ni",
        printOptions: "Prentvalkostir",
        printPagesAfterDispensing: "FjÃ¶ldi afrita af merkimiÃ°a",
        printPagesBeforeDispensing: "FjÃ¶ldi afrita af merkimiÃ°a",
        printPreview: "Prenta Ãºt forskoÃ°un",
        printSettings: "Prentstillingar",
        printTaskLinkVariable: "Tengja viÃ° aÃ°rar breytur",
        printVariable: "Prenta breytu",
        printerName: "Heiti prentara",
        printerOptions: "Prentvalkostir",
        printerSettings: "Stillingar prentara",
        quickTintTemplate: "SniÃ°mÃ¡t fyrir fljÃ³tlega litblÃ¶ndun",
        setDefaultPrinter: "Velja sjÃ¡lfgefinn prentara",
        setDefaultTemplate: "Velja sjÃ¡lfgefiÃ° sniÃ°mÃ¡t",
        setQuickTintTemplate: "Velja sniÃ°mÃ¡t fyrir fljÃ³tlega litblÃ¶ndun",
        showPreviewDialogBeforePrint: "SÃ½na forskoÃ°unarglugga fyrir prentun",
        template: "SniÃ°mÃ¡t",
        templateName: "Heiti sniÃ°mÃ¡ts",
        templateSettings: "SniÃ°mÃ¡tstillingar "
    },
    printTemplate: {
        baseCode: "GrunnkÃ³Ã°i",
        baseName: "Grunnheiti",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Borg/bÃ¦r viÃ°skiptavinar",
        customerEmail: "Netfang viÃ°skiptavinar",
        customerName: "Nafn viÃ°skiptavinar",
        customerPhone: "SÃ­manÃºmer viÃ°skiptavinar",
        customerStreet: "GÃ¶tuheiti viÃ°skiptavinar",
        customerZipCode: "PÃ³stnÃºmer viÃ°skiptavinar",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS-stig",
        orderQrCode: "QR-kÃ³Ã°i",
        packageOrderCount: "FjÃ¶ldi pakkapantana",
        posAddress: "SÃ¶lustaÃ°ur, heimilisfang",
        posAddressSecond: "SÃ¶lustaÃ°ur, heimilisfang 2",
        posCity: "SÃ¶lustaÃ°ur, borg/bÃ¦r",
        posContact: "TengiliÃ°ur Ã¡ sÃ¶lustaÃ°",
        posEmail: "SÃ¶lustaÃ°ur, netfang",
        posPhone: "SÃ¶lustaÃ°ur, sÃ­manÃºmer",
        posUrl: "SÃ¶lustaÃ°ur, tilfangaleit fyrir einingar (vefslÃ³Ã°)",
        posZipCode: "SÃ¶lustaÃ°ur, pÃ³stnÃºmer",
        priceBasePurchaseWithTax: "FramleiÃ°sluverÃ° fyrir grunn meÃ° VSK",
        priceBaseSellWithTax: "ÃtsÃ¶luverÃ° fyrir grunn meÃ° VSK",
        priceCntPurchaseWithTax: "FramleiÃ°sluverÃ° fyrir litarefni meÃ° VSK",
        priceCntTotalSellWithTax: "ÃtsÃ¶luverÃ° fyrir litarefni meÃ° VSK",
        priceMarginAllWithTax: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur) fyrir alla pakka meÃ° VSK",
        priceMarginPerPkgWithTax: "HagnaÃ°ur (Ã­ hlutfalli viÃ° sÃ¶lutekjur) fyrir einn pakka meÃ° VSK",
        priceSellPriceAllWithTax: "ÃtsÃ¶luverÃ° fyrir alla pakka meÃ° VSK",
        priceSellPricePerKgWithTax: "ÃtsÃ¶luverÃ° Ã¡ kÃ­lÃ³ meÃ° VSK",
        priceSellPricePerLWithTax: "ÃtsÃ¶luverÃ° Ã¡ lÃ­tra meÃ° VSK",
        priceSellPricePerPkgWithTax: "ÃtsÃ¶luverÃ° fyrir einn pakka meÃ° VSK",
        priceSurchargeAllWithTax: "Aukagjald fyrir alla pakka meÃ° VSK",
        priceSurchargePerPkgWithTax: "Aukagjald fyrir einn pakka meÃ° VSK",
        priceTintPurchaseAllWithTax: "FramleiÃ°sluverÃ° fyrir litblÃ¶ndun fyrir alla pakka meÃ° VSK",
        priceTintPurchasePerPkgWithTax: "FramleiÃ°sluverÃ° fyrir litblÃ¶ndun fyrir einn pakka meÃ° VSK",
        priceTotalPurchaseAllWithTax: "HeildarframleiÃ°sluverÃ° fyrir alla pakka meÃ° VSK",
        priceTotalPurchasePerKgWithTax: "HeildarframleiÃ°sluverÃ° Ã¡ kÃ­lÃ³ meÃ° VSK",
        priceTotalPurchasePerLWithTax: "HeildarframleiÃ°sluverÃ° Ã¡ lÃ­tra meÃ° VSK",
        priceTotalPurchasePerPkgWithTax: "HeildarframleiÃ°sluverÃ° fyrir einn pakka meÃ° VSK",
        productAltName: "Vara",
        recipeInline: "Uppskrift"
    },
    products: {
        bases: "Grunnur",
        numberOfProducts: "FjÃ¶ldi vara",
        packagesFor: "Pakkar til",
        sizeOfPackage: "StÃ¦rÃ° pakka"
    },
    purgeModal: {
        purgeAll: "Hreinsa allt",
        purgeAllChannels: "Hreinsa allar rÃ¡sir",
        purgeVolume: "Hreinsa rÃºmtak",
        startPurge: "Hefja hreinsun"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "LitblÃ¶ndun Ã¡ meÃ°an vinna er Ã­ gangi",
        dispensingIsNotAvailable: "LitblÃ¶ndun er ekki tiltÃ¦k",
        machineNotConnected: "Engin vÃ©l er tengd",
        noColorantsSelected: "Engin litarefni hafa veriÃ° valin",
        noPrinterAvailable: "Ekki er hÃ¦gt aÃ° prenta Ã¾ar sem engin prentari er tiltÃ¦kur.",
        noTemplateAvailable: "Ekki er hÃ¦gt aÃ° prenta Ã¾ar sem ekkert sniÃ°mÃ¡t er tiltÃ¦kt.",
        overMaxCanisterSize: "Eitt eÃ°a fleiri litarefni er Ã³gilt"
    },
    quickTintSettings: {
        alphabetically: "StafrÃ³fsrÃ¶Ã°",
        byCanister: "Ãr hylki",
        closeAfterDispensing: "Loka eftir litblÃ¶ndun",
        closeBeforeDispensing: "Loka fyrir litblÃ¶ndun",
        quickTintSettings: "FlÃ½tistillingar litblÃ¶ndunar",
        sorting: "RaÃ°a",
        windowClosingRules: "Reglur um lokun glugga"
    },
    rccButtons: {
        abort: "hÃ¦tta",
        all: "allt",
        cancel: "Ã³gilda",
        continue: "halda Ã¡fram",
        help: "hjÃ¡lp",
        ignore: "hunsa",
        no: "ekkert",
        noToAll: "ekki fyrir allt",
        ok: "Ã­ lagi",
        postpone: "fresta",
        resume: "byrja aftur",
        retry: "reyna aftur",
        skip: "hlaupa yfir",
        yes: "jÃ¡",
        yesToAll: "jÃ¡ viÃ° Ã¶llu"
    },
    rccDialog: {
        98: "AthugaÃ°u grunn %{0} meÃ° strikamerki",
        99: "FÃ¦rÃ°u inn grunn %{0} og staÃ°festu (smelltu Ã¡ Ã lagi)",
        100: "Villa kom upp Ã­ skammtara, Ã¡ aÃ° nÃºllstilla villuna?",
        101: "Villa kom upp Ã­ skammtara og hann getur Ã¾vÃ­ ekki haldiÃ° Ã¡fram",
        102: "NÃºllstilling mistÃ³kst og ekki er hÃ¦gt aÃ° halda henni Ã¡fram",
        103: "Uppskriftin inniheldur Ã³gilt litarefni: %{0}",
        104: "Uppskriftin inniheldur Ã³gild litarefni: %{0}",
        105: "Magn litarefnisins: %{0} Ã­ hylki er undir viÃ°vÃ¶runarmÃ¶rkum",
        106: "Magn litarefnanna: %{0} Ã­ hylki er undir viÃ°vÃ¶runarmÃ¶rkum",
        107: "Magn litarefnisins: %{0} Ã­ hylki er of lÃ­tiÃ°",
        108: "Magn litarefnanna: %{0} Ã­ hylki er of lÃ­tiÃ°",
        109: "StaÃ°setja dÃ³s/fÃ¶tu",
        110: "StaÃ°setja grunn: %{0} fyrir uppskriftina: %{1}",
        111: "FjarlÃ¦gja dÃ³s/fÃ¶tu",
        112: "Stansa dÃ³sina/fÃ¶tuna?",
        113: "NÃºllstillir villu, bÃ­ddu andartak",
        114: "Flytur hillu, bÃ­ddu andartak",
        115: "Stansar dÃ³sina/fÃ¶tuna, bÃ­ddu andartak",
        116: "Litblandar eftir uppskriftinni %{0}, bÃ­ddu andartak | Pakki: %{1} af %{2} | Vara: %{3} | Grunnur: %{4} | StÃ¦rÃ° dÃ³sar/fÃ¶tu: %{5}",
        117: "Litblandar eftir uppskriftinni %{0}, bÃ­ddu andartak | Pakki: %{1} af %{2} | Vara: %{3} | Grunnur: %{4} | StÃ¦rÃ° dÃ³sar/fÃ¶tu: %{5}",
        118: "Litblandar, bÃ­ddu andartak|Pakki: %{0} af %{1}",
        119: "Litblandar, bÃ­ddu andartak|Pakki: %{0} af %{1}",
        120: "Ãgildir litblÃ¶ndun, bÃ­ddu andartak",
        121: "StaÃ°festa strikamerki Ã¡ dÃ³sinni/fÃ¶tunni",
        122: "StaÃ°festa strikamerki grunns | Vara: %{0} | Grunnur: %{1} | StÃ¦rÃ° dÃ³sar/fÃ¶tu: %{2}",
        123: "LitblÃ¶ndunarferliÃ° var stÃ¶Ã°vaÃ°. Ã aÃ° halda litblÃ¶ndun Ã¡fram?",
        124: "Villa kom upp Ã­ litblÃ¶ndun %{0} : %{1}. Ã aÃ° halda litblÃ¶ndun Ã¡fram?",
        125: "Gakktu Ãºr skugga um aÃ° Ã¡Ã°ur notuÃ° dÃ³s sÃ© staÃ°sett",
        126: "Gakktu Ãºr skugga um aÃ° notuÃ° sÃ© nÃ½ dÃ³s/fata, Ã¾ar sem litblÃ¶ndunarferliÃ° hefst upp Ã¡ nÃ½tt",
        127: "Litarefni: %{0} er undir lÃ¡gmarksskÃ¶mmtunarmagni. Ã aÃ° halda Ã¡fram Ã¾rÃ¡tt fyrir viÃ°vÃ¶runina?",
        128: "Litarefni: %{0} eru undir lÃ¡gmarksskÃ¶mmtunarmagni. Ã aÃ° halda Ã¡fram Ã¾rÃ¡tt fyrir viÃ°vÃ¶runina?",
        129: "Valin formÃºla brÃ½tur gegn ofÃ¡fyllingarreglunni varÃ°andi heildarmagn litarefna: %{0} %{1}, mesta leyfilega magn litarefna: %{2} %{3}. Ã aÃ° halda Ã¡fram Ã¾rÃ¡tt fyrir viÃ°vÃ¶runina?",
        130: "Villa kom upp Ã­ litblÃ¶ndunarvÃ©l, Ã¡ aÃ° nÃºllstilla villuna?",
        131: "Villa kom upp Ã­ litblÃ¶ndunarvÃ©l og hÃºn getur Ã¾vÃ­ ekki haldiÃ° Ã¡fram",
        132: "NÃºllstilling mistÃ³kst og ekki er hÃ¦gt aÃ° halda henni Ã¡fram",
        133: "Hreinsunaruppskriftin er auÃ° og ekki er hÃ¦gt aÃ° halda Ã¡fram",
        134: "Hreinsunaruppskriftin inniheldur hluti sem ekki er hÃ¦gt aÃ° hreinsa, Ã¡ aÃ° halda Ã¡fram?",
        135: "StaÃ°setja fÃ¶tu fyrir hreinsunina",
        136: "FjarlÃ¦gja fÃ¶tu fyrir hreinsunina",
        137: "NÃºllstillir villu, bÃ­ddu andartak",
        138: "Flytur hillu, bÃ­ddu andartak",
        139: "Hreinsar, bÃ­ddu andartak",
        140: "Hreinsar, bÃ­ddu andartak",
        141: "Ãgildir hreinsun, bÃ­ddu andartak",
        142: "FÃ¶tu fyrir hreinsun vantar, gakktu Ãºr skugga um aÃ° fata sÃ© rÃ©tt staÃ°sett",
        143: "Hreinsunaruppskriftin inniheldur hluti sem ekki er hÃ¦gt aÃ° hreinsa, Ã¡ aÃ° halda Ã¡fram?",
        144: "StaÃ°setja fÃ¶tu fyrir hreinsunina",
        145: "UndirbÃ½r, bÃ­ddu andartak",
        146: "LÃ½kur viÃ°, bÃ­ddu andartak",
        150: "Hreinsar, bÃ­ddu andartak",
        151: "Hreinsar, bÃ­ddu andartak",
        152: "Ãgildir hreinsun, bÃ­ddu andartak",
        160: "EndurdÃ¦lir, bÃ­ddu andartak",
        161: "EndurdÃ¦lir, bÃ­ddu andartak",
        162: "Ãgildir endurdÃ¦lingu, bÃ­ddu andartak",
        170: "HrÃ¦rir, bÃ­ddu andartak",
        171: "HrÃ¦rir, bÃ­ddu andartak",
        172: "Ãgildir hrÃ¦ringu, bÃ­ddu andartak",
        180: "Grunnstillir tengingu viÃ° litblÃ¶ndunarvÃ©lina, bÃ­ddu andartak",
        181: "Ekki er hÃ¦gt aÃ° koma Ã¡ tengingu viÃ° litblÃ¶ndunarvÃ©l %{0}: %{1}",
        182: "Ekki er hÃ¦gt aÃ° koma Ã¡ tengingu viÃ° litblÃ¶ndunarvÃ©l. SjÃ¡ skrÃ¡ningargÃ¶gn til aÃ° fÃ¡ frekari upplÃ½singar",
        183: "Litarefni vantar Ã­ litblÃ¶ndunarvÃ©l: %{0}, sem er skilgreint Ã­ gagnagrunninum",
        184: "Litarefni vantar Ã­ litblÃ¶ndunarvÃ©l: %{0}, sem eru skilgreind Ã­ gagnagrunninum",
        185: "Lokar fyrir tengingu viÃ° litblÃ¶ndunarvÃ©l, bÃ­ddu andartak",
        190: "Loka skal Ã¾jÃ³nustuglugganum til aÃ° halda Ã¡fram",
        200: "NÃºllstillir, bÃ­ddu andartak",
        201: "HÃ¶rÃ° nÃºllstilling, bÃ­ddu andartak",
        202: "Grunnstilling, bÃ­ddu andartak",
        203: "NÃºllstilling Ã¡ villu, bÃ­ddu andartak",
        205: "SjÃ¡lfvirkur lokunarbÃºnaÃ°ur opnast, bÃ­ddu andartak",
        206: "SjÃ¡lfvirkur lokunarbÃºnaÃ°ur lokast, bÃ­ddu andartak",
        207: "SjÃ¡lfvirkur lokunarbÃºnaÃ°ur fluttur, bÃ­ddu andartak",
        210: "StÃ¶nsun, bÃ­ddu andartak",
        211: "Tenging, bÃ­ddu andartak",
        215: "Flytur hillu upp, bÃ­ddu andartak",
        216: "Flytur hillu niÃ°ur, bÃ­ddu andartak",
        217: "Flytur hillu, bÃ­ddu andartak",
        220: "Flytur borÃ° Ã­ endurÃ¡fyllingarstÃ¶Ã°u: %{0}, bÃ­ddu andartak",
        221: "Flytur borÃ° Ã­ upphafsstÃ¶Ã°u, bÃ­ddu andartak",
        222: "Flytur borÃ°, bÃ­ddu andartak",
        230: "LitblÃ¶ndunarvÃ©lin er upptekin, bÃ­ddu andartak",
        240: "Fylltu aftur Ã¡ hylki %{0}",
        241: "Fylltu aftur Ã¡ hylki %{0}",
        242: "StaÃ°settu hylki: %{0} (%{1}) Ã­ endurÃ¡fyllingarstÃ¶Ã°u",
        243: "Fylltu aftur Ã¡ hylki %{0} meÃ° Ã¾vÃ­ aÃ° nota strikamerki",
        244: "Fylltu aftur Ã¡ hylki %{0} meÃ° Ã¾vÃ­ aÃ° nota strikamerki",
        250: "FjarlÃ¦gÃ°u burstaÃ­lÃ¡tiÃ°, hreinsaÃ°u Ã¾aÃ° og fylltu Ã¾aÃ° meÃ° vatni samkvÃ¦mt leiÃ°beiningunum",
        251: "Komdu burstaÃ­lÃ¡tinu aftur fyrir",
        254: "Opnar sjÃ¡lfvirkan lokunarbÃºnaÃ°",
        255: "HreinsaÃ°u sjÃ¡lfvirka lokunarbÃºnaÃ°inn samkvÃ¦mt leiÃ°beiningum",
        256: "StaÃ°festu Ã¾egar hreinsun er lokiÃ° og sjÃ¡lfvirki lokunarbÃºnaÃ°urinn er kominn Ã¡ sinn staÃ° aftur",
        257: "Lokar sjÃ¡lfvirkum lokunarbÃºnaÃ°i",
        260: "FjarlÃ¦gÃ°u snertiplÃ¶tuna og hreinsaÃ°u hana",
        261: "Komdu snertiplÃ¶tunni aftur fyrir",
        265: "HreinsaÃ°u vÃ©lina meÃ° klÃºti og fjarlÃ¦gÃ°u allt litarefni sem hefur lekiÃ°, eÃ°a annan vÃ¶kva",
        266: "StaÃ°festu Ã¾egar Ã¾essu er lokiÃ°",
        270: "Fylltu aftur Ã¡ vatnstank rakatÃ¦kis og staÃ°festu Ã¾egar Ã¾vÃ­ er lokiÃ°",
        271: "Fylltu aftur Ã¡ vatnstank rakatÃ¦kis og staÃ°festu Ã¾egar Ã¾vÃ­ er lokiÃ°",
        272: "VatnsborÃ°iÃ° er ennÃ¾Ã¡ lÃ¡gt, athugaÃ°u Ã¾aÃ° aftur",
        273: "VatnsborÃ°iÃ° er ennÃ¾Ã¡ lÃ¡gt, athugaÃ°u Ã¾aÃ° aftur",
        274: "AthugaÃ°u vatnsborÃ°iÃ° Ã­ vatnstanki rakatÃ¦kisins og fylltu Ã¡ ef Ã¾Ã¶rf krefur",
        275: "BÃ­ddu andartak",
        280: "EndurrÃ¦sir tÃ¶lvu",
        281: "Slekkur Ã¡ tÃ¶lvu",
        300: "Grunn vantar, gakktu Ãºr skugga um aÃ° dÃ³s/fata hafi veriÃ° rÃ©tt staÃ°sett",
        301: "UndirbÃ½r, bÃ­ddu andartak",
        302: "LÃ½kur viÃ°, bÃ­ddu andartak",
        303: "Ekki er hÃ¦gt aÃ° litblanda eftir uppskriftinni Ã¾ar sem hÃºn inniheldur litarefni: %{0}, sem eru yfir hÃ¡marksskÃ¶mmtunarmagni sem skilgreint er fyrir hylkiÃ°",
        304: "Ekki er hÃ¦gt aÃ° litblanda eftir uppskriftinni Ã¾ar sem hÃºn inniheldur litarefni: %{0}, sem eru yfir hÃ¡marksskÃ¶mmtunarmagni sem skilgreint er fyrir hylkin",
        305: "Litarefni: %{0} ekki hÃ¦gt aÃ° skammta samtÃ­mis. Viltu skipta uppskriftinni?",
        306: "Litarefnin: %{0} ekki hÃ¦gt aÃ° skammta samtÃ­mis. Viltu skipta uppskriftinni?",
        307: "Litarefni: %{0} er ekki skammtaÃ° Ãºr litblÃ¶ndunarvÃ©linni, Ã¡ aÃ° halda Ã¡fram og skammta Ã¾aÃ° handvirkt?",
        308: "Litarefnin: %{0} er ekki skammtaÃ° Ãºr litblÃ¶ndunarvÃ©linni, Ã¡ aÃ° halda Ã¡fram og skammta Ã¾aÃ° handvirkt?",
        309: "Valin uppskrift er tÃ³m, nota skal grunninn eins og hann er",
        310: "Ekki er hÃ¦gt aÃ° skammta litarefni, undirbÃºa skal grunn fyrir handvirka Ã­blÃ¶ndun litarefna",
        311: "FjarlÃ¦gÃ°u grunn og undirbÃºÃ°u hann fyrir handvirka Ã­blÃ¶ndun litarefna",
        312: "Skammta handvirkt %{0} %{1} litarefni: %{2}, staÃ°festu Ã¾egar Ã¾essu er lokiÃ°",
        313: "Skammta litarefni handvirkt",
        314: "Uppskrift er ekki Ã­ samrÃ¦mi viÃ° ofÃ¡fyllingarregluna varÃ°andi heildarmagn litarefna: %{0} %{1}, mesta leyfilega magn litarefna: %{2} %{3}. Ã aÃ° halda Ã¡fram Ã¾rÃ¡tt fyrir viÃ°vÃ¶runina?",
        315: "Skanna eÃ°a slÃ¡ inn UFI-kÃ³Ã°a stofnsins",
        316: "SkannaÃ°u eÃ°a slÃ¡Ã°u inn UFI-kÃ³Ã°a fyrir stofninn|Vara: %{0}Grunnur: %{1}StÃ¦rÃ° dÃ³sar: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "SjÃ¡lfvirk hreinsun verÃ°ur sett af staÃ°",
        401: "SjÃ¡lfvirk hreinsun verÃ°ur sett af staÃ°",
        405: "BurstaÃ­lÃ¡t Ã¾arf aÃ° fÃ¡ viÃ°hald",
        406: "BurstaÃ­lÃ¡t Ã¾arf aÃ° fÃ¡ viÃ°hald",
        410: "SjÃ¡lfvirkt viÃ°hald loks verÃ°ur sett af staÃ°",
        411: "SjÃ¡lfvirkt viÃ°hald loks verÃ°ur sett af staÃ°",
        415: "Hreinsa Ã¾arf snertiplÃ¶tuna",
        416: "Hreinsa Ã¾arf snertiplÃ¶tuna",
        420: "Hreinsa Ã¾arf litblÃ¶ndunarvÃ©lin",
        421: "Hreinsa Ã¾arf litblÃ¶ndunarvÃ©lin",
        425: "EndurÃ¡fylling hylkis verÃ°ur sett af staÃ°",
        426: "EndurÃ¡fylling hylkis verÃ°ur sett af staÃ°",
        430: "EndurrÃ¦sing tÃ¶lvu er Ã¡Ã¦tluÃ°",
        431: "EndurrÃ¦sing tÃ¶lvu er Ã¡Ã¦tluÃ°",
        435: "AÃ°gerÃ° til aÃ° slÃ¶kkva Ã¡ tÃ¶lvu er Ã¡Ã¦tluÃ°",
        436: "AÃ°gerÃ° til aÃ° slÃ¶kkva Ã¡ tÃ¶lvu er Ã¡Ã¦tluÃ°",
        440: "Hreinsun litblÃ¶ndunarvÃ©lar er Ã¡Ã¦tluÃ°",
        441: "Hreinsun litblÃ¶ndunarvÃ©lar er Ã¡Ã¦tluÃ°",
        445: "EndurdÃ¦lingarvinnsla Ã­ skammtara er Ã¡Ã¦tluÃ°",
        446: "EndurdÃ¦lingarvinnsla Ã­ skammtara er Ã¡Ã¦tluÃ°",
        450: "HrÃ¦ring Ã­ skammtara er Ã¡Ã¦tluÃ°",
        451: "HrÃ¦ring Ã­ skammtara er Ã¡Ã¦tluÃ°",
        990: "Villa kom upp Ã­ litblÃ¶ndunarvÃ©l %{0}: %{1}. Ã aÃ° reyna aftur aÃ° vinna verkiÃ°?",
        991: "Innri villa kom upp: %{0}",
        200000001: "StaÃ°setja dÃ³s/fÃ¶tu",
        200000002: "FjarlÃ¦gja dÃ³s/fÃ¶tu",
        200000003: "Magn fyrir â%{0}â er undir lÃ¡gmarkshÃ¦Ã° litarefnis, Ã¡ aÃ° halda Ã¡fram Ã¾rÃ¡tt fyrir Ã¡hÃ¦ttuna?",
        200000004: "Fylla aftur Ã¡ â%{0}â"
    },
    rccDriverSettings: {
        databasePath: "SlÃ³Ã° Ã¡ gagnagrunn",
        dispenser: "LitblÃ¶ndunarvÃ©l",
        dispenserConfigurationFile: "GrunnstillingarskrÃ¡ litblÃ¶ndunarvÃ©lar",
        driverPath: "SlÃ³Ã° Ã¡ rekil",
        extensionPath: "SlÃ³Ã° Ã¡ skrÃ¡arheiti",
        folder: "Mappa",
        formulaPath: "SlÃ³Ã° Ã¡ uppskrift",
        host: "GestgjafavÃ©l",
        iddPath: "IDD-grunnstillingaskrÃ¡",
        italtintoPath: "Italtinto-grunnstillingaskrÃ¡",
        lldPath: "HLD-rÃ³tarskrÃ¡asafn",
        machineType: "GerÃ° vÃ©lar",
        noMachineAvailable: "Engin vÃ©l er tiltÃ¦k",
        protocolVersion: "ÃtgÃ¡fa af starfsreglum",
        rccDriverSettings: "Stillingar rekils",
        resultPath: "SlÃ³Ã° Ã¡ niÃ°urstÃ¶Ã°ur",
        save: "Vista stillingar",
        saveSettingsWarning: "VarÃºÃ°! Breytingar Ã­ Ã¾essum hluta geta orsakaÃ° villur Ã­ aÃ°gerÃ°um litblÃ¶ndunarvÃ©lar.",
        serviceSwPath: "SlÃ³Ã° Ã¡ Ã¾jÃ³nustuhugbÃºnaÃ°",
        simulationPath: "SlÃ³Ã° Ã¡ hermingu"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "Leyfa handvirka skÃ¶mmtun litarefnis",
        ask: "Spyrja",
        canHandlingOptions: "MeÃ°hÃ¶ndlunarstillingar fyrir dÃ³s/fÃ¶tu",
        checkCanBeforeDispense: "SkoÃ°a dÃ³s/fÃ¶tu fyrir litblÃ¶ndun",
        checkOverfill: "Athuga ofÃ¡fyllingu",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "AÃ°eins staÃ°festing Ã¡ litarefnispakka",
        disable: "Gera Ã³virkt",
        dispenseInvalidColorants: "Skammtar Ã³gild litarefni",
        dispensingOptions: "LitblÃ¶ndunarstillingar",
        enable: "Virkja",
        enableUserIdentification: "AuÃ°kenni notanda",
        fullValidation: "Full staÃ°festing",
        machineAccuracyWarning: "ViÃ°vÃ¶run um nÃ¡kvÃ¦mni vÃ©lar",
        machineOptions: "VÃ©larstillingar",
        machineUnit: "Eining Ã­ vÃ©l",
        minimalDispenseAmount: "LÃ¡gmarks skÃ¶mmtunarmagn",
        placeCanSensor: "Skynjari til aÃ° staÃ°setja dÃ³s/fÃ¶tu",
        placeCanSensorDelay: "Seinkun Ã¡ skynjara til aÃ° staÃ°setja dÃ³s/fÃ¶tu",
        rccMachineSettings: "VÃ©larstillingar",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "Skynjari til aÃ° flytja dÃ³s/fÃ¶tu",
        removeCanSensorDelay: "Seinkun Ã¡ skynjara til aÃ° flytja dÃ³s/fÃ¶tu",
        save: "Vista stillingar",
        sec: "sekÃºndur",
        skipPlaceCanDialog: "Hlaupa yfir samtalsglugga um staÃ°setningu Ã¡ dÃ³s/fÃ¶tu",
        skipRemoveCanDialog: "Hlaupa yfir samtalsglugga um flutning Ã¡ dÃ³s/fÃ¶tu",
        splitFormula: "Deildu uppskrift",
        tmcEnabled: "Gera TMC virkt",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "StaÃ°festa strikamerki Ã¡ dÃ³s/fÃ¶tu meÃ° grunni",
        validateBarcodeRefill: "StaÃ°festa strikamerki Ã¡ hylki fyrir endurÃ¡fyllingu",
        validateColorantsDuringInit: "StaÃ°festa litarefni viÃ° grunnstillingu"
    },
    rccPanel: {
        actionsRunningOnDispenser: "Nokkrar aÃ°gerÃ°ir eru Ã­ gangi Ã­ vÃ©linni",
        addLevel: "BÃTA VIÃ HÃÃ",
        addManually: "BÃ¦ta viÃ° handvirkt",
        barcodeNotSet: "HylkiÃ° %{colorantName} (%{canisterName}) hefur ekki fengiÃ° ÃºthlutaÃ° strikamerki.",
        cancel: "ÃGILDA",
        dispenseFormula: "Uppskrift",
        dispenserIdle: "VÃ©lin er Ã³virk",
        dispenserIsBusy: "VÃ©lin er Ã­ notkun",
        dispenserIsIdle: "VÃ©lin er Ã³virk",
        dispenserIsReady: "VÃ©lin er tilbÃºin Ã­ frekari vinnslu",
        dispensingFormula: "Uppskrift",
        errorCode: "VillukÃ³Ã°i",
        explanation: "SkÃ½ring",
        fillToMax: "Fylla aÃ° hÃ¡marki",
        finished: "LokiÃ°",
        inProgress: "Ã gangi",
        machineIsReady: "VÃ©lin er tilbÃºin",
        moveToFill: "FÃ¦ra til Ã¡fyllingar",
        noMachineDialog: "Engin vÃ©l er tengd",
        of: "frÃ¡",
        packageSize: "StÃ¦rÃ° pakka",
        placeBaseCan: "StaÃ°setja dÃ³s/fÃ¶tu fyrir grunn",
        pleaseCheckYourMachineConnection: "AthugaÃ°u tengingu vÃ©lar",
        pleaseRefill: "Fylltu Ã¡ aftur",
        solution: "ÃrrÃ¦Ã°i",
        subErrors: "Villa",
        timeToEnd: "TÃ­mi til aÃ° klÃ¡ra",
        tintingFormula: "Uppskrift",
        tintingPleaseWait: "Er aÃ° litblanda, bÃ­ddu andartak",
        validateBaseCan: "StaÃ°festa dÃ³s/fÃ¶tu fyrir grunn",
        waiting: "BÃ­Ã°ur"
    },
    rccSettigns: {
        rccSettigns: "Tengingar fyrir RCC (Redlike Control Center)",
        rccUrl: "VefslÃ³Ã° fyrir RCC (Redlike Control Center)"
    },
    rccSpectroDialog: {
        100: "Tengist tÃ¦kinu Ã¾Ã­nu um Bluetooth. Gakktu Ãºr skugga um aÃ° Bluetooth sÃ© virkt og kveikt sÃ© Ã¡ tÃ¦kinu.",
        101: "TÃ¦kiÃ° finnst ekki. Viltu reyna aftur?",
        110: "Gakktu Ãºr skugga um aÃ° kveikt sÃ© Ã¡ Nano og Ã½ttu Ã¡ tÃ¦kjahnappinn til aÃ° hefja grunnstillingu",
        111: "Nano finnst ekki. Viltu reyna aftur?",
        112: "Aftengdu Nano, bÃ­ddu Ã­ 10 sekÃºndur, tengdu aftur og haltu Ã¡fram",
        120: "VeriÃ° er aÃ° tengja tÃ¦kiÃ° Ã¾itt, bÃ­ddu andartak",
        121: "TÃ¦kiÃ° finnst ekki. Viltu reyna aftur?",
        200: "Settu tÃ¦kiÃ° Ã¡ svarta reitinn og haltu Ã¡fram, eÃ°a Ã½ttu Ã¡ tÃ¦kjahnappinn",
        201: "Settu tÃ¦kiÃ° Ã¡ svarta reitinn og haltu Ã¡fram",
        202: "Settu tÃ¦kiÃ° Ã¡ svarta reitinn og Ã½ttu Ã¡ tÃ¦kjahnappinn",
        205: "Settu tÃ¦kiÃ° Ã¡ hvÃ­ta reitinn og haltu Ã¡fram, eÃ°a Ã½ttu Ã¡ tÃ¦kjahnappinn",
        206: "Settu tÃ¦kiÃ° Ã¡ hvÃ­ta reitinn og haltu Ã¡fram",
        207: "Settu tÃ¦kiÃ° Ã¡ hvÃ­ta reitinn og Ã½ttu Ã¡ tÃ¦kjahnappinn",
        210: "Settu tÃ¦kiÃ° Ã¡ greiningarreitinn og haltu Ã¡fram, eÃ°a Ã½ttu Ã¡ tÃ¦kjahnappinn",
        211: "Settu tÃ¦kiÃ° Ã¡ greiningarreitinn og haltu Ã¡fram",
        212: "Settu tÃ¦kiÃ° Ã¡ greiningarreitinn og Ã½ttu Ã¡ tÃ¦kjahnappinn",
        215: "LokaÃ°u tÃ¦kjalokinu og haltu Ã¡fram eÃ°a Ã½ttu Ã¡ tÃ¦kjatakkann",
        216: "LokaÃ°u tÃ¦kjalokinu og haltu Ã¡fram",
        217: "LokaÃ°u tÃ¦kjalokinu og Ã½ttu Ã¡ tÃ¦kjatakkann",
        220: "Settu tÃ¦kiÃ° Ã¡ nÃºllplÃ¶tuna og haltu Ã¡fram, eÃ°a Ã½ttu Ã¡ tÃ¦kjahnappinn",
        221: "Settu tÃ¦kiÃ° Ã¡ nÃºllplÃ¶tuna og haltu Ã¡fram",
        222: "Settu tÃ¦kiÃ° Ã¡ nÃºllplÃ¶tuna og Ã½ttu Ã¡ tÃ¦kjahnappinn",
        224: "Settu Ã¡haldiÃ° Ã¡ kvÃ¶rÃ°unarflÃ¶tinn og haltu Ã¡fram, eÃ°a Ã½ttu Ã¡ Ã¡haldahnappinn",
        225: "Settu Ã¡haldiÃ° Ã¡ kvÃ¶rÃ°unarflÃ¶tinn og haltu Ã¡fram",
        226: "Settu Ã¡haldiÃ° Ã¡ kvÃ¶rÃ°unarflÃ¶tinn og Ã½ttu Ã¡ Ã¡haldahnappinn",
        227: "Settu Ã¡haldiÃ° Ã¡ kvÃ¶rÃ°unarflÃ¶tinn og Ã½ttu Ã¡ Ã¡haldahnappinn",
        295: "LjÃºktu viÃ° kvÃ¶rÃ°unina Ã­ rekilsglugganum",
        296: "VerkfÃ¦riÃ° er ekki tengt, Ã¡ aÃ° opna tengingu viÃ° Ã¾aÃ°?",
        297: "UndirbÃºningur fyrir kvÃ¶rÃ°unarstig, bÃ­ddu andartak",
        298: "KvarÃ°ar, bÃ­ddu andartak",
        299: "KvÃ¶rÃ°unarstigi lokiÃ°, bÃ­ddu andartak",
        300: "Settu tÃ¦kiÃ° Ã¡ prufuna og haltu Ã¡fram, eÃ°a Ã½ttu Ã¡ tÃ¦kjahnappinn",
        301: "Settu tÃ¦kiÃ° Ã¡ prufuna og haltu Ã¡fram",
        302: "Settu tÃ¦kiÃ° Ã¡ prufuna og Ã½ttu Ã¡ tÃ¦kjahnappinn",
        303: "VerkfÃ¦riÃ° er ekki kvarÃ°aÃ°, Ã¡ aÃ° halda Ã¡fram meÃ° kvÃ¶rÃ°un?",
        304: "VerkfÃ¦riÃ° er ekki tengt, Ã¡ aÃ° opna tengingu viÃ° Ã¾aÃ°?",
        390: "Velja mÃ¦listillingu (measure mode)",
        395: "LjÃºka viÃ° mÃ¦lingu Ã­ rekilsglugganum",
        397: "UndirbÃ½r mÃ¦lingu, bÃ­ddu andartak",
        398: "MÃ¦ling Ã­ gangi, bÃ­ddu andartak",
        399: "LokiÃ° viÃ° mÃ¦lingu, bÃ­ddu andartak",
        498: "SÃ¦kir mÃ¦lingar, bÃ­ddu andartak",
        499: "SÃ¦kir allar mÃ¦lingar, bÃ­ddu andartak",
        900: "Villa Ã­ tÃ¦kjum kom upp %{0}: %{1}. Ã aÃ° reyna aftur aÃ° vinna verkiÃ°?",
        901: "Villa Ã­ tÃ¦kjum kom upp: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "TÃ¶lvan verÃ°ur aÃ° hafa Bluetooth-tengingu. LitrÃ³fsmÃ¦lirinn verÃ°ur aÃ° vera paraÃ°ur viÃ° tÃ¶lvuna. Windows 10 meÃ° haustuppfÃ¦rslu 2018 er krafist.",
        DatacolorSilent:
            "Ãegar hljÃ³Ã°laus stilling er notuÃ° birtast Datacolor-gluggar beint Ã­ %{name}. Ã Ã¾essum gluggum er ekki hÃ¦gt aÃ° breyta fÃ¦ribreytum litrÃ³fs.",
        DatacolorUseDiagnosticTile: "Notkun greiningarflÃ­sar bÃ¦tir mÃ¦ligÃ¦Ã°i.",
        comPort: "Com-port",
        diagnosticTile: "Gagnalitur notar greiningarreiti",
        measureModes: "MÃ¦listillingar",
        measureModesOrder: "RÃ¶Ã° mÃ¦listillinga",
        model: "GerÃ°",
        noSpectroAvailable: "Enginn litrÃ³fsmÃ¦lir er tiltÃ¦kur",
        rccSpectroSettings: "Stillingar litrÃ³fsmÃ¦lis",
        save: "Vista stillingar",
        silent: "Gagnalitur hljÃ³Ã°ur",
        simulationPath: "HermingarslÃ³Ã°",
        spectroType: "GerÃ° litrÃ³fsmÃ¦lis",
        useProfiledValues: "Nota notandatengd gildi"
    },
    recirculateChannels: {
        recirculateAllChannels: "DÃ¦la aftur Ã­ gegnum allar rÃ¡sir",
        recirculateChannels: "DÃ¦la aftur Ã­ gegnum rÃ¡sir",
        recirculatingSpeed: "HraÃ°i endurdÃ¦lingar",
        recirculatingTime: "TÃ­mi endurdÃ¦lingar",
        startRecirculating: "Hefja endurdÃ¦lingu"
    },
    redlikeLight: {
        finishPreviousSteps: "LjÃºktu viÃ° fyrri skref",
        searchBySpectro: "Leita meÃ° litrÃ³fsmÃ¦li",
        searchFormula: "Leita eftir kvittun",
        selectBase: "Velja stofn",
        selectColor: "Velja lit",
        selectCustomer: "Velja viÃ°skiptavin",
        selectFandeck: "Velja litakort",
        selectPackage: "Velja pakka",
        selectProduct: "Velja vÃ¶ru",
        startSelectFandeck: "ByrjaÃ°u Ã¡ aÃ° velja litakort",
        startSelectProduct: "ByrjaÃ°u Ã¡ aÃ° velja vÃ¶ru",
        stepByStepProgress: "ÃÃº getur haldiÃ° Ã¡fram, skref fyrir skref",
        typeHereToSearch: "FÃ¦rÃ°u inn texta hÃ©r til aÃ° leita",
        typeToFilter: "GerÃ° sÃ­u"
    },
    restartModal: {
        computerNeedsRestart: "EndurrÃ¦sa Ã¾arf tÃ¶lvuna",
        notCompletelyTranslated:
            "Breytingar Ã¡ tungumÃ¡li krefjast endurrÃ¦singar Ã¡ hugbÃºnaÃ°i. Sumir hlutar hugbÃºnaÃ°arins eru hugsanlega ekki Ã¾Ã½ddir aÃ° fullu eins og er.",
        restartIsRequired: "Ãegar breytingar hafa veriÃ° gerÃ°ar Ã¾arf aÃ° endurrÃ¦sa hugbÃºnaÃ°inn.",
        softwareNeedsRestart: "%{name} Ã¾arfnast endurrÃ¦singar!"
    },
    searchPanel: {
        basePlaceholder: "eÃ°a slÃ¡Ã°u inn heiti stofns",
        baseStartPlaceholder: "ByrjaÃ°u Ã¡ aÃ° slÃ¡ inn heiti stofns",
        colorCodeNamePlaceholder: "eÃ°a slÃ¡Ã°u inn kÃ³Ã°a/heiti uppskriftar",
        colorCodeNameStartPlaceholder: "ByrjaÃ°u Ã¡ Ã¾vÃ­ aÃ° skrifa kÃ³Ã°a/heiti uppskriftar",
        colorCodePlaceholder: "eÃ°a fÃ¦rÃ°u inn uppskriftarkÃ³Ã°a",
        colorCodeStartPlaceholder: "ByrjaÃ°u Ã¡ aÃ° fÃ¦ra inn uppskriftarkÃ³Ã°a",
        colorNameCodePlaceholder: "eÃ°a slÃ¡Ã°u inn heiti/kÃ³Ã°a uppskriftar",
        colorNameCodeStartPlaceholder: "ByrjaÃ°u Ã¡ Ã¾vÃ­ aÃ° skrifa heiti/kÃ³Ã°a uppskriftar",
        colorNamePlaceholder: "eÃ°a fÃ¦rÃ°u inn heiti uppskriftar",
        colorNameStartPlaceholder: "ByrjaÃ°u Ã¡ aÃ° fÃ¦ra inn heiti uppskriftar",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "eÃ°a fÃ¦rÃ°u inn litakort",
        fandeckStartPlaceholder: "ByrjaÃ°u Ã¡ aÃ° fÃ¦ra inn litakort",
        formulaByColor: "Uppskrift eftir lit",
        noResultsFound: "Engar niÃ°urstÃ¶Ã°ur fundust",
        packagePlaceholder: "eÃ°a slÃ¡Ã°u inn heiti pakka",
        packageStartPlaceholder: "ByrjaÃ°u Ã¡ aÃ° slÃ¡ inn heiti pakka",
        productPlaceholder: "eÃ°a fÃ¦rÃ°u inn vÃ¶ruheiti",
        productStartPlaceholder: "ByrjaÃ°u Ã¡ aÃ° fÃ¦ra inn heiti vÃ¶ru",
        standard: "StaÃ°laÃ°",
        typeFandeckToFilter: "Leita eftir litakorti",
        typeProductToFilter: "Leita eftir vÃ¶ruheiti"
    },
    sendOrderModal: {
        customNote: "Athugasemd um sÃ©rsniÃ°iÃ°",
        noCompatibleServers: "Engir samhÃ¦fir netÃ¾jÃ³nar eru tiltÃ¦kir Ã¡ netinu Ã¾Ã­nu",
        orderOverview: "Yfirlit yfir pÃ¶ntun",
        selectTargetMachine: "Velja fyrirhugaÃ°a vÃ©l",
        sendOrder: "Senda pÃ¶ntun",
        sendOrderTo: "Pantanirnar Ã¾Ã­nar verÃ°a sendar Ã¡ %{serverName}",
        targetMachine: "FyrirhuguÃ° vÃ©l"
    },
    server: {
        computerId: "AuÃ°kenni tÃ¶lvu",
        ip: "IP-tala",
        selectServer: "Veldu einhvern tiltÃ¦kra netÃ¾jÃ³na",
        server: "NetÃ¾jÃ³nn"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Virk viÃ°bÃ³t fyrir netÃ¾jÃ³n",
        currentlyActive: "ViÃ°bÃ³t fyrir netÃ¾jÃ³n sem er virk nÃºna",
        plugin: "ViÃ°bÃ³t",
        pluginName: "Heiti viÃ°bÃ³tar",
        statusActive: "Virkja",
        statusInactive: "Gera Ã³virka"
    },
    serviceActionsSettings: {
        canisterLevel: "HÃ¦Ã° Ã­ hylki",
        capClose: "Loka",
        capMiddle: "Ã miÃ°ju",
        capOpen: "OpiÃ°",
        cleanAllChannels: "Hreinsa allt",
        cleanChannels: "Hreinsa rÃ¡sir",
        computer: "TÃ¶lva",
        computerReboot: "EndurrÃ¦sa tÃ¶lvu",
        computerShutdown: "SlÃ¶kkt Ã¡ tÃ¶lvu",
        connectMachine: "Tengja vÃ©l",
        general: "Almennt",
        initialize: "Grunnstilla",
        noMachineIsConnected: "Engin vÃ©l er tengd",
        plug: "Tengja",
        plugger: "Tengihnappur",
        punch: "Stansar",
        puncher: "StÃ¶nsunarhnappur",
        purgeChannels: "Hreinsa rÃ¡sir",
        recirculate: "EndurdÃ¦la",
        recirculateAllChannels: "EndurdÃ¦la Ã¶llu",
        recirculateChannels: "DÃ¦la aftur Ã­ gegnum rÃ¡sir",
        serviceActions: "ÃjÃ³nustuaÃ°gerÃ°ir",
        setCanisterLevel: "Stilla hÃ¦Ã° Ã­ hylki",
        shelfDown: "Hilla niÃ°ur",
        shelfUp: "Hilla upp",
        showServiceWindow: "SÃ½na Ã¾jÃ³nustuglugga",
        smartPurgeAllChannels: "Snjallhreinsun allra rÃ¡sa",
        smartPurgeChannels: "Snjallhreinsun rÃ¡sa",
        startErrorReset: "NÃºllstilla villu Ã­ rÃ¦singu",
        startHardReset: "Byrja harÃ°a nÃºllstillingu",
        startReset: "ByrjaÃ°u nÃºllstillingu",
        stirAllCanisters: "HrÃ¦ra Ã­ Ã¶llu",
        stirCanisters: "HrÃ¦ra",
        stirCanistersMore: "HrÃ¦ra Ã­ hylki"
    },
    spectroMode: {
        eggshell: "Eggshell",
        flat: "Flat",
        gloss: "Gloss",
        matt: "Matt",
        matte: "Matt",
        pearl: "Perla",
        satin: "Satin",
        selectGlossLevel: "BerÃ°u litasÃ½niÃ° saman viÃ° gljÃ¡stigskvarÃ°ann og veldu gljÃ¡stig",
        semiGloss: "Semi-Gloss"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "KvarÃ°ar",
        calibrateInstrument: "KvÃ¶rÃ°un verkfÃ¦ris",
        connectDevice: "Tengja tÃ¦ki",
        connectedTo: "Tengt viÃ°",
        connectingDevice: "Tengir Ã¾itt tÃ¦ki",
        deselectAll: "Afmerkja allt",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "TÃ¦kiÃ° Ã¾itt er ekki kvarÃ°aÃ°",
        eraseResult: "EyÃ°a niÃ°urstÃ¶Ã°um",
        filter: "SÃ­a",
        foundInFormulas: "Finnst Ã­ uppskriftum",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "ÃaÃ° Ã¾arf aÃ° kvarÃ°a verkfÃ¦riÃ° Ã¾itt.",
        manualInput: "Handvirkur innslÃ¡ttur",
        measure: "MÃ¦la",
        measurementResult: "NiÃ°urstÃ¶Ã°ur mÃ¦linga",
        noFilters: "Engar sÃ­ur eru tiltÃ¦kar",
        noFormulas: "Engar uppskriftir fundust",
        noSelectedSpectro: "Enginn litrÃ³fsmÃ¦lir er valinn",
        notSelected: "Ekki valiÃ°",
        pressConnectButton: "Gakktu Ãºr skugga um aÃ° kveikt sÃ© Ã¡ tÃ¦kinu og Ã½ttu svo Ã¡ tengingarhnappinn",
        searchFormulas: "Leita eftir kvittun",
        selectSpectro: "Velja litrÃ³fsmÃ¦li",
        showDetails: "SÃ½na upplÃ½singar",
        skipCalibration: "Sleppa kvÃ¶rÃ°un",
        spectroIsConnected: "LitrÃ³fsmÃ¦lir er tengdur",
        spectroIsReady: "LitrÃ³fsmÃ¦lir er tilbÃºinn",
        spectroReady: "TÃ¦kiÃ° er tilbÃºiÃ° fyrir frekari verkefni",
        startCalibrateNow: "Byrja kvÃ¶rÃ°un nÃºna",
        startMeasureText: "TÃ¦kiÃ° Ã¾itt er kvarÃ°aÃ° og Ã¾Ãº getur byrjaÃ° aÃ° mÃ¦la",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "FrÃ¡vik fyrir Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "SÃ©rsniÃ°iÃ° %{1} %{2}",
        deleteSelectedRecords: "EyÃ°a vÃ¶ldum fÃ¦rslum",
        exportHistory: "Flytja Ãºt feril",
        finishFormula: "LjÃºka viÃ° uppskrift",
        foundInFormulas: "Finnst Ã­ uppskriftum",
        hideHiddenRecords: "SÃ½na fÃ¦rslur sem eru ekki faldar",
        hideSelectedRecord: "Fela valda fÃ¦rslu",
        historicalFormula: "FerilsformÃºla",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "Endurskapa valda fÃ¦rslu",
        showAllRecords: "SÃ½na allar fÃ¦rslur",
        standardFormula: "Standard formula",
        unknownFormula: "ÃÃ¾ekkt formÃºla"
    },
    stirCanisters: {
        selectCanisters: "Velja hylki",
        startStirring: "Byrja aÃ° hrÃ¦ra",
        stirAllCanisters: "HrÃ¦ra Ã­ Ã¶llum hylkjum",
        stirCanisters: "HrÃ¦ra Ã­ hylkjum",
        stirringSpeed: "HraÃ°i viÃ° hrÃ¦ringu",
        stirringTime: "HrÃ¦ringartÃ­mi "
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Engum Ã¾Ã¦tti er ÃºthlutaÃ° strikamerki %{code}",
        pleaseScanBarcode: "Skanna strikamerki fyrir grunn, vÃ¶ru, pakka eÃ°a aÃ°ra hluti",
        testBarcodes: "PrÃ³fa strikamerki"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "SÃ­Ã°asta",
        next: "NÃ¦sta"
    },
    ufiCodeModal: {
        currentStatus: "NÃºverandi staÃ°a",
        detailedInfoForColorant: "Ãtarlegar upplÃ½singar um litarefni %{colorantName}",
        userSetUfiCode: "Notandi stillti UFI-kÃ³Ã°a, nÃºverandi gildi"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "SannprÃ³fun Ã¡ UFI-kÃ³Ã°a stofns",
        confirmColorantRefilling: "StaÃ°festa endurÃ¡fylllingu litarefnis",
        enableUfiCodes: "Virkja UFI-kÃ³Ã°a",
        printUfiCode: "Prenta ef magn litarefnis er yfir",
        printUfiCodePercentage: "Prenta prÃ³sentuhlutfall ef magn litarefnis er yfir",
        scanOrTypeUfiCode: "Skanna eÃ°a slÃ¡ inn UFI-kÃ³Ã°a",
        scanOrTypeUfiCodeOfBase: "Skanna eÃ°a slÃ¡ inn UFI-kÃ³Ã°a stofnsins",
        ufiCodesByPercentage: "Nota UFI-kÃ³Ã°a eftir prÃ³sentuhlutfalli",
        ufiCodesFromDatabase: "Nota UFI-kÃ³Ã°a Ãºr gagnagrunni",
        ufiCodesFromLastFilling: "Nota UFI-kÃ³Ã°a Ãºr sÃ­Ã°ustu Ã¡fyllingu"
    },
    userSettings: {
        addUser: "BÃ¦ta viÃ° notanda",
        assignedUserGroups: "ÃthlutaÃ°ir notendahÃ³par",
        availableUserGroups: "TiltÃ¦kir notendahÃ³par",
        barcode: "Strikamerki",
        confirmNewPassword: "StaÃ°festa strikamerki",
        editPassword: "Breyta aÃ°gangsorÃ°i",
        editUser: "Breyta notanda",
        enableAutoLogin: "Virkja sjÃ¡lfvirka innskrÃ¡ningu",
        newPassword: "NÃ½tt aÃ°gangsorÃ°",
        noChange: "Engar breytingar eru til staÃ°ar sem Ã¾arf aÃ° vista",
        oldPassword: "Eldra aÃ°gangsorÃ°",
        password: "AÃ°gangsorÃ°",
        passwordsDoNotMatch: "AÃ°gangsorÃ° stemma ekki",
        restoreUser: "Ãessum notanda var eytt. Ã aÃ° endurheimta hann?",
        userGroup: "User Group",
        userGroups: "NotandahÃ³par",
        userManagement: "StjÃ³rnun notenda",
        userSettings: "Stillingar notenda",
        username: "Notandanafn",
        usernameIsMissing: "Notandanafn vantar"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "FÃ¶studagur",
        monday: "MÃ¡nudagur",
        saturday: "Laugardagur",
        sunday: "Sunnudagur",
        thursday: "Fimmtudagur",
        tuesday: "ÃriÃ°judagur",
        wednesday: "MiÃ°vikudagur"
    },
    welcome: {
        availableDatabase:
            "NetÃ¾jÃ³nn getur ekki tengst gagnagrunninum. HafÃ°u umsjÃ³n meÃ° grunnstillingum gagnagrunnsins.",
        availableDatabaseLocalError:
            "Villa kom upp Ã­ tengingu viÃ° staÃ°bundinn gagnagrunn (rÃ¶ng skrÃ¡, Ã³gilt aÃ°gangsorÃ°)",
        availableDatabaseLocalMissing: "StaÃ°bundna gagnagrunnsskrÃ¡ vantar",
        availableDatabaseLocalUpdate: "UppfÃ¦ra skal staÃ°bundinn gagnagrunn Ã­ nÃ½rri ÃºtgÃ¡fu",
        availableDatabaseMainAndLocalError:
            "Villa kom upp Ã­ tengslum viÃ° bÃ¦Ã°i aÃ°algagnagrunn og staÃ°bundinn gagnagrunn (rÃ¶ng skrÃ¡, Ã³gilt aÃ°gangsorÃ°)",
        availableDatabaseMainAndLocalMissing: "AÃ°algagnagrunnur og staÃ°bundinn gagnagrunnur",
        availableDatabaseMainAndLocalUpdate:
            "BÃ¦Ã°i aÃ°algagnagrunn og staÃ°bundinn gagnagrunn Ã¾arf aÃ° uppfÃ¦ra Ã­ nÃ½rri ÃºtgÃ¡fu",
        availableDatabaseMainError: "Villa kom upp Ã­ tengingu viÃ° aÃ°algagnagrunn (rÃ¶ng skrÃ¡, Ã³gilt aÃ°gangsorÃ°)",
        availableDatabaseMainMissing: "AÃ°algagnagrunnsskrÃ¡ vantar",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "UppfÃ¦ra skal aÃ°algagnagrunn Ã­ nÃ½rri ÃºtgÃ¡fu",
        closing: "HugbÃºnaÃ°urinn lokast",
        compatibility:
            "AthugaÃ°u ÃºtgÃ¡funa af netÃ¾jÃ³ninum Ã¾Ã­num. BiÃ°larinn Ã¾inn er aÃ°eins samhÃ¦fur viÃ° netÃ¾jÃ³n %{0} eÃ°a hÃ¦rri.",
        compatibilityCheck: "SamhÃ¦fisathugun er Ã­ gangi",
        compatibilityDatabase:
            "Gagnagrunnurinn Ã¾inn er ekki samhÃ¦fur viÃ° netÃ¾jÃ³ninn. HafÃ°u umsjÃ³n meÃ° grunnstillingum gagnagrunnsins.",
        connectingServer: "Tengist viÃ° netÃ¾jÃ³ninn Ã¡ %{ip}",
        databaseCompatibility: "Gagnagrunnurinn Ã¾inn er ekki samhÃ¦fur viÃ° nÃºverandi hugbÃºnaÃ°",
        databasesCompatibility: "Gagnagrunnarnir Ã¾Ã­nir eru ekki samhÃ¦fir viÃ° nÃºverandi hugbÃºnaÃ°",
        licenseVerification: "StaÃ°festing leyfis er Ã­ gangi",
        loading: "Les af",
        lostConnection: "Tengingin viÃ° netÃ¾jÃ³ninn rofnaÃ°i",
        moduleMessage:
            "Fylgstu meÃ° vali Ã¡ einingu, Ã¾ar sem breytingar Ã¡ einingunni Ã­ framtÃ­Ã°inni verÃ°a aÃ°eins Ã­ boÃ°i fyrir notendur meÃ° forrÃ©ttindi.",
        refresh: "UppfÃ¦ra",
        restoring: "Endurheimtir tenginguna",
        selectModule: "Veldu eina af tiltÃ¦kum einingum.",
        stopUpdate: "HÃ¦tta aÃ° uppfÃ¦ra",
        updateDatabase: "UppfÃ¦rir gagnagrunn",
        updatingDatabase: "VeriÃ° er aÃ° uppfÃ¦ra gagnagrunninn",
        updatingDatabases: "VeriÃ° er aÃ° uppfÃ¦ra gagnagrunnana",
        updatingWarning: "Ekki loka Ã¾essum glugga. ÃendurkrÃ¦ft ferli stendur yfir.",
        updatingWarningInfo: "Lokun orsakar Ã³afturkrÃ¦ft tjÃ³n Ã¡ gÃ¶gnum."
    }
};
